{
  "level": "mt01",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:mt01",
    "objects": "AREAS.E3:mt01.e3",
    "mesh": "TREES.E3:mt01.e3"
  },
  "spawn_point": {
    "position": [
      -2132.225378978496,
      -3772.3799797213806,
      771.0778198242188
    ],
    "facing_rad": 0.0,
    "look_point": [
      -2132.225378978496,
      -3672.3799797213806,
      771.0778198242188
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -3963.99951171875,
      -5079.7685546875,
      747.0778198242188
    ],
    "bbox_max": [
      -664.7411499023438,
      -2911.618408203125,
      1574.9000244140625
    ],
    "vertex_count": 980,
    "vertices": [
      [
        -1320.0,
        -3094.332763671875,
        835.09130859375
      ],
      [
        -1320.0,
        -3082.269287109375,
        863.54296875
      ],
      [
        -928.214111328125,
        -3044.112548828125,
        860.7633056640625
      ],
      [
        -839.289306640625,
        -3015.748291015625,
        995.3905029296875
      ],
      [
        -839.289306640625,
        -3015.748291015625,
        995.3905029296875
      ],
      [
        -755.7307739257812,
        -2930.939453125,
        1302.5999755859375
      ],
      [
        -833.4789428710938,
        -3014.314208984375,
        1000.5853271484375
      ],
      [
        -1314.6207275390625,
        -3103.500244140625,
        824.4576416015625
      ],
      [
        -1320.0,
        -3095.778076171875,
        828.3320922851562
      ],
      [
        -1320.0,
        -3095.1962890625,
        833.0553588867188
      ],
      [
        -1314.5830078125,
        -3102.52880859375,
        832.7578125
      ],
      [
        -919.8648681640625,
        -3044.44287109375,
        863.2477416992188
      ],
      [
        -839.728271484375,
        -3021.015869140625,
        976.3096313476562
      ],
      [
        -839.9186401367188,
        -3021.219970703125,
        975.822998046875
      ],
      [
        -839.728271484375,
        -3021.015869140625,
        976.3096313476562
      ],
      [
        -847.523681640625,
        -3029.375244140625,
        956.3824462890625
      ],
      [
        -850.43994140625,
        -3032.502685546875,
        931.3502197265625
      ],
      [
        -847.523681640625,
        -3029.375244140625,
        956.3824462890625
      ],
      [
        -1152.318115234375,
        -3322.175537109375,
        823.8451538085938
      ],
      [
        -1126.0,
        -3322.0,
        906.8358764648438
      ],
      [
        -1140.92724609375,
        -3322.0,
        860.0
      ],
      [
        -1130.3677978515625,
        -3314.0,
        912.0
      ],
      [
        -1126.0,
        -3319.810546875,
        912.0
      ],
      [
        -1146.0,
        -3315.25146484375,
        860.0
      ],
      [
        -1146.5478515625,
        -3314.0,
        861.2327880859375
      ],
      [
        -1155.2801513671875,
        -3350.7841796875,
        747.0778198242188
      ],
      [
        -1152.318115234375,
        -3322.175537109375,
        823.8451538085938
      ],
      [
        -1320.0,
        -3094.332763671875,
        835.09130859375
      ],
      [
        -1320.0,
        -3095.03369140625,
        834.3765869140625
      ],
      [
        -1320.0,
        -3095.03369140625,
        834.3765869140625
      ],
      [
        -1135.1934814453125,
        -3322.0,
        877.9901123046875
      ],
      [
        -1146.5098876953125,
        -3322.0,
        861.1472778320312
      ],
      [
        -1148.6920166015625,
        -3314.0,
        866.0571899414062
      ],
      [
        -1146.5098876953125,
        -3322.0,
        861.1472778320312
      ],
      [
        -1153.5582275390625,
        -3357.557373046875,
        754.5106811523438
      ],
      [
        -1147.3780517578125,
        -3350.929931640625,
        830.355224609375
      ],
      [
        -1320.0,
        -3084.23828125,
        1302.5999755859375
      ],
      [
        -1320.0,
        -3084.23828125,
        1052.346923828125
      ],
      [
        -1147.20849609375,
        -3350.748046875,
        832.436279296875
      ],
      [
        -1141.5216064453125,
        -3344.6494140625,
        867.8198852539062
      ],
      [
        -1147.20849609375,
        -3350.748046875,
        832.436279296875
      ],
      [
        -1141.5216064453125,
        -3344.6494140625,
        867.8198852539062
      ],
      [
        -1134.300048828125,
        -3336.9052734375,
        878.1983032226562
      ],
      [
        -1124.3956298828125,
        -3441.16357421875,
        963.5977172851562
      ],
      [
        -1111.09814453125,
        -3487.473388671875,
        1029.9256591796875
      ],
      [
        -1135.3389892578125,
        -3368.7138671875,
        869.4544067382812
      ],
      [
        -1124.3956298828125,
        -3441.16357421875,
        963.597900390625
      ],
      [
        -1126.0,
        -3374.0,
        884.6598510742188
      ],
      [
        -1136.467041015625,
        -3374.0,
        860.0
      ],
      [
        -1134.5406494140625,
        -3374.0,
        876.3234252929688
      ],
      [
        -1136.448486328125,
        -3366.0,
        860.0
      ],
      [
        -1126.0,
        -3366.0,
        875.4437255859375
      ],
      [
        -1135.7489013671875,
        -3366.0,
        865.9278564453125
      ],
      [
        -1146.477783203125,
        -3349.96435546875,
        836.982666015625
      ],
      [
        -1135.3389892578125,
        -3368.7138671875,
        869.4544677734375
      ],
      [
        -1137.91455078125,
        -3366.0,
        860.0
      ],
      [
        -1136.951171875,
        -3366.0,
        864.7543334960938
      ],
      [
        -1141.1036376953125,
        -3374.0,
        860.0
      ],
      [
        -1140.0697021484375,
        -3374.0,
        870.926513671875
      ],
      [
        -1141.822021484375,
        -3366.0,
        860.0
      ],
      [
        -1144.144775390625,
        -3374.0,
        860.0
      ],
      [
        -1143.6812744140625,
        -3374.0,
        867.4013061523438
      ],
      [
        -1147.5926513671875,
        -3374.0,
        863.5834350585938
      ],
      [
        -1005.9225463867188,
        -3266.954345703125,
        918.49560546875
      ],
      [
        -1005.9225463867188,
        -3266.954345703125,
        918.49560546875
      ],
      [
        -1124.53173828125,
        -3388.795166015625,
        971.9285278320312
      ],
      [
        -1111.7132568359375,
        -3461.162109375,
        1071.4483642578125
      ],
      [
        -1109.1981201171875,
        -3477.063720703125,
        1093.0709228515625
      ],
      [
        -1109.1981201171875,
        -3477.0634765625,
        1093.070556640625
      ],
      [
        -1107.0994873046875,
        -3484.318359375,
        1103.709716796875
      ],
      [
        -1130.330078125,
        -3374.0,
        912.0
      ],
      [
        -1134.5406494140625,
        -3374.0,
        876.3234252929688
      ],
      [
        -1135.7489013671875,
        -3366.0,
        865.9278564453125
      ],
      [
        -1126.0,
        -3366.0,
        900.6021728515625
      ],
      [
        -1134.1500244140625,
        -3366.0,
        879.4757690429688
      ],
      [
        -1130.330078125,
        -3374.0,
        912.0
      ],
      [
        -1130.3292236328125,
        -3373.63671875,
        912.0
      ],
      [
        -1126.0,
        -3369.84814453125,
        912.0
      ],
      [
        -1124.53173828125,
        -3388.795166015625,
        971.9285278320312
      ],
      [
        -1111.71337890625,
        -3461.161865234375,
        1071.44775390625
      ],
      [
        -1130.7442626953125,
        -3374.0,
        912.0
      ],
      [
        -1132.3358154296875,
        -3374.0,
        895.00537109375
      ],
      [
        -1130.78955078125,
        -3374.0,
        911.8827514648438
      ],
      [
        -1134.22900390625,
        -3366.0,
        878.8062744140625
      ],
      [
        -1134.1732177734375,
        -3366.0,
        879.4157104492188
      ],
      [
        -1130.7442626953125,
        -3374.0,
        912.0
      ],
      [
        -1148.5718994140625,
        -3374.0,
        865.786865234375
      ],
      [
        -1141.5673828125,
        -3366.0,
        860.24853515625
      ],
      [
        -1134.4034423828125,
        -3366.0,
        877.3278198242188
      ],
      [
        -1136.9512939453125,
        -3366.0,
        864.7543334960938
      ],
      [
        -1138.5511474609375,
        -3363.30712890625,
        860.090576171875
      ],
      [
        -753.2093505859375,
        -2930.939453125,
        1302.5999755859375
      ],
      [
        -1108.4205322265625,
        -3479.75146484375,
        1097.0123291015625
      ],
      [
        -849.7271118164062,
        -3031.73828125,
        937.4691772460938
      ],
      [
        -1857.6201171875,
        -3492.940185546875,
        1082.962646484375
      ],
      [
        -1650.8538818359375,
        -3434.6806640625,
        1302.5999755859375
      ],
      [
        -1739.9085693359375,
        -3467.27099609375,
        1302.5999755859375
      ],
      [
        -1857.6021728515625,
        -3492.9619140625,
        1083.3204345703125
      ],
      [
        -1857.6021728515625,
        -3492.9619140625,
        1083.3204345703125
      ],
      [
        -1739.9085693359375,
        -3467.27099609375,
        1302.5999755859375
      ],
      [
        -1543.630859375,
        -3387.394775390625,
        1201.0750732421875
      ],
      [
        -1604.0823974609375,
        -3391.488037109375,
        973.598388671875
      ],
      [
        -1551.188720703125,
        -3366.486328125,
        902.3794555664062
      ],
      [
        -1604.0823974609375,
        -3391.488037109375,
        973.5984497070312
      ],
      [
        -1365.8299560546875,
        -3369.2412109375,
        883.0553588867188
      ],
      [
        -1405.0,
        -3368.0,
        884.3972778320312
      ],
      [
        -1405.0,
        -3376.997314453125,
        894.0
      ],
      [
        -1401.5,
        -3377.220947265625,
        894.0
      ],
      [
        -1401.5,
        -3396.897216796875,
        915.0
      ],
      [
        -1370.0,
        -3379.229736328125,
        894.0
      ],
      [
        -1373.0,
        -3379.03857421875,
        894.0
      ],
      [
        -1337.604248046875,
        -3374.0,
        886.213134765625
      ],
      [
        -1356.0,
        -3374.0,
        887.4653930664062
      ],
      [
        -1401.5,
        -3368.0,
        870.0
      ],
      [
        -1370.0,
        -3368.0,
        880.4854125976562
      ],
      [
        -1390.6519775390625,
        -3368.0,
        883.4205932617188
      ],
      [
        -1401.5,
        -3368.0,
        884.1590576171875
      ],
      [
        -1356.0,
        -3374.0,
        887.4653930664062
      ],
      [
        -1356.0,
        -3368.0,
        860.0
      ],
      [
        -1356.0,
        -3368.0,
        878.4959716796875
      ],
      [
        -1356.0,
        -3369.73291015625,
        882.9113159179688
      ],
      [
        -1356.0,
        -3366.0,
        873.400146484375
      ],
      [
        -1332.33740234375,
        -3366.0,
        870.0363159179688
      ],
      [
        -1356.0,
        -3366.0,
        873.400146484375
      ],
      [
        -1397.5,
        -3400.431640625,
        918.5
      ],
      [
        -1377.0,
        -3401.7392578125,
        918.5
      ],
      [
        -1401.5,
        -3396.897216796875,
        915.0
      ],
      [
        -1397.5,
        -3400.431640625,
        918.5
      ],
      [
        -1405.0,
        -3376.997314453125,
        894.0
      ],
      [
        -1401.5,
        -3377.220947265625,
        894.0
      ],
      [
        -1405.0,
        -3368.0,
        884.3972778320312
      ],
      [
        -1403.1392822265625,
        -3371.45556640625,
        894.0
      ],
      [
        -1372.38671875,
        -3373.171142578125,
        894.0
      ],
      [
        -1372.38671875,
        -3373.171142578125,
        894.0
      ],
      [
        -1370.0,
        -3373.30419921875,
        894.0
      ],
      [
        -1405.0,
        -3371.351806640625,
        894.0
      ],
      [
        -1403.1392822265625,
        -3371.45556640625,
        894.0
      ],
      [
        -1339.2958984375,
        -3374.0,
        891.408935546875
      ],
      [
        -1356.0,
        -3374.0,
        893.7833862304688
      ],
      [
        -1405.0,
        -3368.0,
        885.4597778320312
      ],
      [
        -1356.0,
        -3374.0,
        893.7833862304688
      ],
      [
        -1405.0,
        -3368.0,
        885.4597778320312
      ],
      [
        -1405.0,
        -3371.351806640625,
        894.0
      ],
      [
        -1405.0,
        -3374.0,
        894.0
      ],
      [
        -1405.0,
        -3374.0,
        890.801025390625
      ],
      [
        -1397.5,
        -3381.385986328125,
        918.5
      ],
      [
        -1377.0,
        -3382.529541015625,
        918.5
      ],
      [
        -1401.5,
        -3374.5,
        901.523681640625
      ],
      [
        -1401.5,
        -3379.789306640625,
        915.0
      ],
      [
        -1401.5,
        -3379.789306640625,
        915.0
      ],
      [
        -1397.5,
        -3381.385986328125,
        918.5
      ],
      [
        -1401.5,
        -3374.5,
        901.523681640625
      ],
      [
        -1395.0,
        -3374.5,
        900.599853515625
      ],
      [
        -1373.0,
        -3374.5,
        897.4727783203125
      ],
      [
        -1385.0,
        -3374.5,
        899.1785888671875
      ],
      [
        -1356.0,
        -3366.0,
        878.9274291992188
      ],
      [
        -1334.7613525390625,
        -3366.0,
        877.4814453125
      ],
      [
        -1390.6510009765625,
        -3368.0,
        883.42041015625
      ],
      [
        -1370.0,
        -3368.0,
        882.0146484375
      ],
      [
        -1356.0,
        -3369.733154296875,
        882.91162109375
      ],
      [
        -1356.0,
        -3368.0,
        878.495849609375
      ],
      [
        -1356.0,
        -3368.0,
        881.0618896484375
      ],
      [
        -1356.0,
        -3366.0,
        878.9274291992188
      ],
      [
        -1472.77197265625,
        -3341.89697265625,
        884.6555786132812
      ],
      [
        -1430.7042236328125,
        -3335.754150390625,
        882.5087280273438
      ],
      [
        -1350.0,
        -3323.9697265625,
        878.1983032226562
      ],
      [
        -1430.7042236328125,
        -3335.754150390625,
        882.5087280273438
      ],
      [
        -1334.729248046875,
        -3323.0,
        877.3826293945312
      ],
      [
        -1343.357177734375,
        -3323.0,
        860.0
      ],
      [
        -1343.357177734375,
        -3323.0,
        877.843505859375
      ],
      [
        -1334.8028564453125,
        -3323.0,
        877.60888671875
      ],
      [
        -1343.357177734375,
        -3323.0,
        878.0511474609375
      ],
      [
        -1495.9229736328125,
        -3345.277587890625,
        889.9683837890625
      ],
      [
        -1472.77197265625,
        -3341.89697265625,
        884.6555786132812
      ],
      [
        -1551.188720703125,
        -3366.486328125,
        902.3794555664062
      ],
      [
        -1340.1395263671875,
        -3374.0,
        894.0
      ],
      [
        -1356.0,
        -3374.0,
        894.0
      ],
      [
        -1356.0,
        -3374.0,
        894.0
      ],
      [
        -1356.0,
        -3368.0,
        881.0618896484375
      ],
      [
        -1356.0,
        -3368.0,
        894.0
      ],
      [
        -1356.0,
        -3366.0,
        894.0
      ],
      [
        -1343.357177734375,
        -3323.0,
        903.8826904296875
      ],
      [
        -1597.9923095703125,
        -3370.631591796875,
        1302.5999755859375
      ],
      [
        -1634.891845703125,
        -3372.7666015625,
        1302.5999755859375
      ],
      [
        -1650.8538818359375,
        -3434.6806640625,
        1302.5999755859375
      ],
      [
        -1634.891845703125,
        -3372.7666015625,
        1302.5999755859375
      ],
      [
        -1857.6201171875,
        -3492.940185546875,
        1082.962646484375
      ],
      [
        -1876.72509765625,
        -3436.68115234375,
        1019.8193969726562
      ],
      [
        -1888.2955322265625,
        -3402.609375,
        981.5785522460938
      ],
      [
        -1888.3092041015625,
        -3402.573486328125,
        981.4912109375
      ],
      [
        -1888.2955322265625,
        -3402.609375,
        981.5785522460938
      ],
      [
        -1497.943603515625,
        -3346.052978515625,
        890.4221801757812
      ],
      [
        -1597.9923095703125,
        -3370.631591796875,
        1302.5999755859375
      ],
      [
        -1566.66552734375,
        -3355.607421875,
        1291.816650390625
      ],
      [
        -1592.8734130859375,
        -3359.43408203125,
        1302.5999755859375
      ],
      [
        -1560.625732421875,
        -3354.725341796875,
        1292.5194091796875
      ],
      [
        -1566.66552734375,
        -3355.607421875,
        1291.816650390625
      ],
      [
        -1325.873046875,
        -3087.09765625,
        833.7279663085938
      ],
      [
        -1320.0,
        -3084.238525390625,
        858.898681640625
      ],
      [
        -1325.9539794921875,
        -3087.136962890625,
        833.382080078125
      ],
      [
        -1326.0028076171875,
        -3087.16064453125,
        832.6555786132812
      ],
      [
        -1325.873046875,
        -3087.09765625,
        833.7279663085938
      ],
      [
        -1325.9395751953125,
        -3087.1298828125,
        833.5960083007812
      ],
      [
        -1325.9395751953125,
        -3087.1298828125,
        833.5960083007812
      ],
      [
        -1465.0,
        -3302.74755859375,
        930.0036010742188
      ],
      [
        -1445.0,
        -3300.372314453125,
        930.0040893554688
      ],
      [
        -1320.0,
        -3095.1962890625,
        833.0553588867188
      ],
      [
        -1325.9539794921875,
        -3087.136962890625,
        833.382080078125
      ],
      [
        -1445.0,
        -3300.372314453125,
        930.0040893554688
      ],
      [
        -1445.0,
        -3300.369873046875,
        930.01025390625
      ],
      [
        -1356.0,
        -3316.6494140625,
        860.0
      ],
      [
        -1356.0,
        -3315.0,
        864.3011474609375
      ],
      [
        -1445.0,
        -3294.620361328125,
        945.0027465820312
      ],
      [
        -1700.1717529296875,
        -3195.748291015625,
        1281.8350830078125
      ],
      [
        -1698.493408203125,
        -3187.58544921875,
        1302.5999755859375
      ],
      [
        -1700.1717529296875,
        -3195.748291015625,
        1281.8350830078125
      ],
      [
        -1900.942626953125,
        -3361.09033203125,
        980.9415283203125
      ],
      [
        -1900.9678955078125,
        -3360.975341796875,
        981.2509765625
      ],
      [
        -1925.1641845703125,
        -3248.03076171875,
        1302.5999755859375
      ],
      [
        -1900.9678955078125,
        -3360.975341796875,
        981.2509765625
      ],
      [
        -1356.0,
        -3323.0,
        878.4855346679688
      ],
      [
        -1356.0,
        -3315.0,
        898.57421875
      ],
      [
        -1356.0,
        -3316.654541015625,
        895.3706665039062
      ],
      [
        -1343.357177734375,
        -3323.0,
        873.1968994140625
      ],
      [
        -1356.0,
        -3323.0,
        878.4855346679688
      ],
      [
        -1350.0914306640625,
        -3323.0,
        878.4636840820312
      ],
      [
        -1445.0,
        -3300.369873046875,
        930.01025390625
      ],
      [
        -1445.0,
        -3303.759033203125,
        930.01025390625
      ],
      [
        -1900.942626953125,
        -3361.09033203125,
        980.9415283203125
      ],
      [
        -1888.3245849609375,
        -3402.525390625,
        981.4669799804688
      ],
      [
        -1888.3131103515625,
        -3402.563232421875,
        981.466064453125
      ],
      [
        -1888.3245849609375,
        -3402.525390625,
        981.4669799804688
      ],
      [
        -1885.0430908203125,
        -3402.0966796875,
        980.7196044921875
      ],
      [
        -1888.3131103515625,
        -3402.563232421875,
        981.466064453125
      ],
      [
        -1512.2174072265625,
        -3331.19140625,
        894.0480346679688
      ],
      [
        -1471.2705078125,
        -3325.007568359375,
        884.6555786132812
      ],
      [
        -1512.2174072265625,
        -3331.19140625,
        894.0480346679688
      ],
      [
        -1471.2705078125,
        -3325.007568359375,
        884.6555786132812
      ],
      [
        -1463.448486328125,
        -3340.53564453125,
        884.1797485351562
      ],
      [
        -1467.7373046875,
        -3332.021484375,
        884.440673828125
      ],
      [
        -1353.774658203125,
        -3324.52099609375,
        878.39990234375
      ],
      [
        -1356.0,
        -3323.0,
        878.5187377929688
      ],
      [
        -1355.3323974609375,
        -3323.0,
        878.4830932617188
      ],
      [
        -1356.0,
        -3323.0,
        878.5187377929688
      ],
      [
        -1356.0,
        -3322.987548828125,
        878.5187377929688
      ],
      [
        -1356.0,
        -3323.0,
        883.084716796875
      ],
      [
        -1356.0,
        -3323.0,
        883.084716796875
      ],
      [
        -1580.328125,
        -3331.9921875,
        1302.5999755859375
      ],
      [
        -1564.6063232421875,
        -3333.48291015625,
        1302.5999755859375
      ],
      [
        -1580.328125,
        -3331.9921875,
        1302.5999755859375
      ],
      [
        -1265.480712890625,
        -3057.69580078125,
        1302.5999755859375
      ],
      [
        -1249.2091064453125,
        -3016.591552734375,
        1341.32421875
      ],
      [
        -1320.0,
        -3084.23828125,
        1302.5999755859375
      ],
      [
        -1320.0,
        -2979.299072265625,
        1425.064697265625
      ],
      [
        -664.7411499023438,
        -2911.618408203125,
        1340.847412109375
      ],
      [
        -1925.17431640625,
        -3247.990234375,
        1302.6690673828125
      ],
      [
        -1411.826904296875,
        -3042.403564453125,
        1403.593017578125
      ],
      [
        -1320.0,
        -3064.385498046875,
        1325.768310546875
      ],
      [
        -1512.1971435546875,
        -2990.03857421875,
        1534.9000244140625
      ],
      [
        -1411.826904296875,
        -3042.404052734375,
        1403.592529296875
      ],
      [
        -1925.1641845703125,
        -3248.03076171875,
        1302.5999755859375
      ],
      [
        -1925.17431640625,
        -3247.990234375,
        1302.6690673828125
      ],
      [
        -1518.93115234375,
        -2994.08203125,
        1534.9000244140625
      ],
      [
        -1411.6416015625,
        -3062.6884765625,
        1379.815185546875
      ],
      [
        -1330.9732666015625,
        -3089.58056640625,
        1302.5999755859375
      ],
      [
        -1411.6416015625,
        -3062.68896484375,
        1379.8145751953125
      ],
      [
        -1634.29931640625,
        -3382.0,
        1345.2088623046875
      ],
      [
        -1633.3604736328125,
        -3382.0,
        1397.349365234375
      ],
      [
        -1646.46435546875,
        -3493.31103515625,
        1548.9510498046875
      ],
      [
        -1620.0,
        -3433.10595703125,
        1510.3582763671875
      ],
      [
        -1613.8685302734375,
        -3428.0,
        1515.0
      ],
      [
        -1629.9910888671875,
        -3429.841552734375,
        1485.0
      ],
      [
        -1624.184326171875,
        -3435.164306640625,
        1505.0
      ],
      [
        -1632.0,
        -3428.0,
        1478.0806884765625
      ],
      [
        -1632.0,
        -3415.578125,
        1459.0
      ],
      [
        -1563.3309326171875,
        -3382.0,
        1531.2568359375
      ],
      [
        -1554.83740234375,
        -3382.0,
        1525.9482421875
      ],
      [
        -1624.184326171875,
        -3435.164306640625,
        1505.0
      ],
      [
        -1620.0,
        -3433.10595703125,
        1510.358154296875
      ],
      [
        -1632.0,
        -3490.0068359375,
        1574.9000244140625
      ],
      [
        -1632.0,
        -3487.009033203125,
        1568.722900390625
      ],
      [
        -1648.033935546875,
        -3507.629150390625,
        1574.9000244140625
      ],
      [
        -1646.4644775390625,
        -3493.31103515625,
        1548.9510498046875
      ],
      [
        -1642.5057373046875,
        -3443.77099609375,
        1455.83544921875
      ],
      [
        -1727.3770751953125,
        -3462.68505859375,
        1302.5999755859375
      ],
      [
        -1642.5057373046875,
        -3443.77099609375,
        1455.83544921875
      ],
      [
        -1637.2723388671875,
        -3382.0,
        1302.5999755859375
      ],
      [
        -1634.29931640625,
        -3382.0,
        1345.208984375
      ],
      [
        -1634.7877197265625,
        -3386.785888671875,
        1355.8927001953125
      ],
      [
        -1633.395751953125,
        -3383.444091796875,
        1406.7977294921875
      ],
      [
        -1633.3604736328125,
        -3382.0,
        1397.3492431640625
      ],
      [
        -1633.291748046875,
        -3382.0,
        1404.79150390625
      ],
      [
        -1632.6080322265625,
        -3382.0,
        1478.7926025390625
      ],
      [
        -1622.605224609375,
        -3311.9482421875,
        1441.2652587890625
      ],
      [
        -1624.1009521484375,
        -3328.0,
        1485.0
      ],
      [
        -1627.0,
        -3348.380615234375,
        1485.0
      ],
      [
        -1625.0,
        -3335.396728515625,
        1493.5
      ],
      [
        -1625.5,
        -3338.21533203125,
        1488.0
      ],
      [
        -1554.891845703125,
        -3332.108154296875,
        1496.0
      ],
      [
        -1554.891845703125,
        -3334.891845703125,
        1496.0
      ],
      [
        -1554.891845703125,
        -3334.891845703125,
        1496.0
      ],
      [
        -1552.108154296875,
        -3334.891845703125,
        1496.0
      ],
      [
        -1627.0,
        -3348.76025390625,
        1488.0
      ],
      [
        -1627.0,
        -3378.5,
        1488.0
      ],
      [
        -1627.0,
        -3378.772705078125,
        1485.0
      ],
      [
        -1627.0,
        -3348.380615234375,
        1485.0
      ],
      [
        -1625.0,
        -3333.0,
        1474.5684814453125
      ],
      [
        -1625.0,
        -3331.029296875,
        1459.0
      ],
      [
        -1624.8662109375,
        -3333.0,
        1482.0
      ],
      [
        -1625.0,
        -3333.0,
        1474.5706787109375
      ],
      [
        -1624.3682861328125,
        -3329.5,
        1482.0
      ],
      [
        -1624.439453125,
        -3330.0,
        1482.0
      ],
      [
        -1624.88330078125,
        -3333.5,
        1485.0
      ],
      [
        -1624.937255859375,
        -3333.5,
        1482.0
      ],
      [
        -1624.8662109375,
        -3333.0,
        1482.0
      ],
      [
        -1624.937255859375,
        -3333.5,
        1482.0
      ],
      [
        -1625.0,
        -3378.5,
        1485.0
      ],
      [
        -1625.0,
        -3378.5,
        1482.0
      ],
      [
        -1632.84228515625,
        -3372.64794921875,
        1302.5999755859375
      ],
      [
        -1633.74365234375,
        -3372.7001953125,
        1302.5999755859375
      ],
      [
        -1625.0,
        -3329.5,
        1482.0
      ],
      [
        -1625.0,
        -3333.5,
        1485.0
      ],
      [
        -1625.0,
        -3333.5,
        1482.0
      ],
      [
        -1625.0,
        -3333.5,
        1482.0
      ],
      [
        -1636.6453857421875,
        -3382.0,
        1311.585205078125
      ],
      [
        -1554.8775634765625,
        -3334.48681640625,
        1525.973388671875
      ],
      [
        -1563.090576171875,
        -3334.41748046875,
        1531.106689453125
      ],
      [
        -1633.6953125,
        -3364.03515625,
        1529.26708984375
      ],
      [
        -1622.4443359375,
        -3359.504638671875,
        1513.9002685546875
      ],
      [
        -1614.199951171875,
        -3354.705322265625,
        1505.4095458984375
      ],
      [
        -1604.624755859375,
        -3346.498291015625,
        1500.478271484375
      ],
      [
        -1612.1478271484375,
        -3352.05322265625,
        1506.024658203125
      ],
      [
        -1622.4443359375,
        -3359.504638671875,
        1513.9002685546875
      ],
      [
        -1559.3818359375,
        -3344.282470703125,
        1528.78857421875
      ],
      [
        -1554.634521484375,
        -3335.518798828125,
        1525.821533203125
      ],
      [
        -1559.3818359375,
        -3344.282470703125,
        1528.78857421875
      ],
      [
        -1558.63232421875,
        -3344.294189453125,
        1529.432861328125
      ],
      [
        -1553.48388671875,
        -3334.5,
        1525.9840087890625
      ],
      [
        -1554.082763671875,
        -3334.5,
        1525.4765625
      ],
      [
        -1610.4500732421875,
        -3350.78955078125,
        1504.7919921875
      ],
      [
        -1612.1478271484375,
        -3352.05322265625,
        1506.024658203125
      ],
      [
        -1609.736572265625,
        -3350.2314453125,
        1504.32421875
      ],
      [
        -1610.4500732421875,
        -3350.78955078125,
        1504.7919921875
      ],
      [
        -1608.0,
        -3348.689453125,
        1503.5301513671875
      ],
      [
        -1608.7193603515625,
        -3349.359375,
        1503.8004150390625
      ],
      [
        -1608.7193603515625,
        -3349.359375,
        1503.8004150390625
      ],
      [
        -1609.2286376953125,
        -3349.809326171875,
        1504.0377197265625
      ],
      [
        -1609.2286376953125,
        -3349.809326171875,
        1504.0377197265625
      ],
      [
        -1609.736572265625,
        -3350.2314453125,
        1504.32421875
      ],
      [
        -1554.513916015625,
        -3334.5,
        1525.111328125
      ],
      [
        -1614.199951171875,
        -3353.6025390625,
        1507.474609375
      ],
      [
        -1614.199951171875,
        -3353.53857421875,
        1507.5943603515625
      ],
      [
        -1614.199951171875,
        -3355.6689453125,
        1508.9034423828125
      ],
      [
        -1614.199951171875,
        -3353.763671875,
        1507.1728515625
      ],
      [
        -1614.199951171875,
        -3355.6005859375,
        1508.8416748046875
      ],
      [
        -1601.5604248046875,
        -3355.926513671875,
        1508.4747314453125
      ],
      [
        -1601.199951171875,
        -3355.93408203125,
        1508.4625244140625
      ],
      [
        -1614.199951171875,
        -3353.9541015625,
        1506.81591796875
      ],
      [
        -1614.199951171875,
        -3354.27392578125,
        1506.2171630859375
      ],
      [
        -1614.199951171875,
        -3353.9541015625,
        1506.81591796875
      ],
      [
        -1614.199951171875,
        -3354.705322265625,
        1505.4095458984375
      ],
      [
        -1614.199951171875,
        -3354.27392578125,
        1506.2171630859375
      ],
      [
        -1603.5,
        -3356.3388671875,
        1501.3812255859375
      ],
      [
        -1604.7454833984375,
        -3356.7021484375,
        1500.7763671875
      ],
      [
        -1611.2552490234375,
        -3356.7021484375,
        1500.7763671875
      ],
      [
        -1612.0,
        -3356.48486328125,
        1501.137939453125
      ],
      [
        -1612.0,
        -3352.819580078125,
        1504.276611328125
      ],
      [
        -1612.0,
        -3356.48486328125,
        1501.137939453125
      ],
      [
        -1612.0,
        -3355.746337890625,
        1500.2021484375
      ],
      [
        -1612.0,
        -3355.178466796875,
        1499.86083984375
      ],
      [
        -1612.0,
        -3356.581298828125,
        1500.9774169921875
      ],
      [
        -1612.0,
        -3356.34716796875,
        1500.5631103515625
      ],
      [
        -1611.38037109375,
        -3356.7021484375,
        1500.7763671875
      ],
      [
        -1612.0,
        -3356.581298828125,
        1500.9774169921875
      ],
      [
        -1603.5,
        -3356.484130859375,
        1501.1392822265625
      ],
      [
        -1604.6185302734375,
        -3356.7021484375,
        1500.7763671875
      ],
      [
        -1553.320068359375,
        -3334.5,
        1525.0
      ],
      [
        -1554.082763671875,
        -3334.5,
        1525.4765625
      ],
      [
        -1614.199951171875,
        -3353.5810546875,
        1507.5146484375
      ],
      [
        -1614.199951171875,
        -3352.963623046875,
        1506.8338623046875
      ],
      [
        -1614.199951171875,
        -3353.722412109375,
        1507.2498779296875
      ],
      [
        -1614.199951171875,
        -3352.963623046875,
        1506.8338623046875
      ],
      [
        -1614.199951171875,
        -3345.227783203125,
        1502.5927734375
      ],
      [
        -1612.0,
        -3351.86767578125,
        1498.1435546875
      ],
      [
        -1612.0,
        -3352.515869140625,
        1498.2608642578125
      ],
      [
        -1612.0,
        -3351.974365234375,
        1497.9661865234375
      ],
      [
        -1612.0,
        -3352.1572265625,
        1498.04541015625
      ],
      [
        -1905.4954833984375,
        -3442.0400390625,
        1052.5999755859375
      ],
      [
        -2050.7568359375,
        -3469.260498046875,
        1052.5999755859375
      ],
      [
        -1877.2235107421875,
        -3435.805908203125,
        1018.7938842773438
      ],
      [
        -1877.0391845703125,
        -3435.756103515625,
        1018.7813720703125
      ],
      [
        -2530.148681640625,
        -4028.199951171875,
        1052.5999755859375
      ],
      [
        -2530.148681640625,
        -4036.266357421875,
        1052.5999755859375
      ],
      [
        -2530.148681640625,
        -4028.199951171875,
        1052.5999755859375
      ],
      [
        -2521.800048828125,
        -4028.199951171875,
        1052.5999755859375
      ],
      [
        -1888.322509765625,
        -3402.532470703125,
        981.466796875
      ],
      [
        -2521.800048828125,
        -4036.266357421875,
        1052.5999755859375
      ],
      [
        -2530.148681640625,
        -4036.266357421875,
        1052.5999755859375
      ],
      [
        -2521.800048828125,
        -4028.199951171875,
        1052.5999755859375
      ],
      [
        -2521.800048828125,
        -4036.266357421875,
        1052.5999755859375
      ],
      [
        -1896.9144287109375,
        -3422.105224609375,
        1016.67626953125
      ],
      [
        -1877.2235107421875,
        -3435.805908203125,
        1018.7938842773438
      ],
      [
        -2144.113037109375,
        -3478.30517578125,
        1036.0379638671875
      ],
      [
        -2193.854736328125,
        -3489.9541015625,
        1040.6011962890625
      ],
      [
        -2144.113037109375,
        -3478.30517578125,
        1036.0379638671875
      ],
      [
        -2193.854736328125,
        -3489.9541015625,
        1040.6011962890625
      ],
      [
        -2328.351806640625,
        -3521.27880859375,
        1052.5999755859375
      ],
      [
        -2050.7568359375,
        -3469.260498046875,
        1052.5999755859375
      ],
      [
        -1905.4954833984375,
        -3442.0400390625,
        1052.5999755859375
      ],
      [
        -1866.9840087890625,
        -3465.924072265625,
        1052.5999755859375
      ],
      [
        -1866.9840087890625,
        -3465.924072265625,
        1052.5999755859375
      ],
      [
        -1866.806884765625,
        -3465.8876953125,
        1052.5999755859375
      ],
      [
        -2056.87158203125,
        -3489.6318359375,
        1052.5999755859375
      ],
      [
        -2090.0,
        -3470.0,
        1039.635009765625
      ],
      [
        -2081.520263671875,
        -3475.025146484375,
        1052.5999755859375
      ],
      [
        -2080.0,
        -3465.0,
        1033.507080078125
      ],
      [
        -2054.08740234375,
        -3480.35546875,
        1052.5999755859375
      ],
      [
        -2067.511962890625,
        -3472.400146484375,
        1052.5999755859375
      ],
      [
        -2080.0,
        -3465.0,
        1033.507080078125
      ],
      [
        -2090.0,
        -3470.0,
        1039.635009765625
      ],
      [
        -2093.25244140625,
        -3407.82421875,
        1052.5999755859375
      ],
      [
        -1906.344970703125,
        -3336.721435546875,
        1050.388427734375
      ],
      [
        -1920.9259033203125,
        -3372.69189453125,
        986.3633422851562
      ],
      [
        -1920.9259033203125,
        -3372.69189453125,
        986.3633422851562
      ],
      [
        -1899.3868408203125,
        -3366.89013671875,
        981.060791015625
      ],
      [
        -1899.3868408203125,
        -3366.89013671875,
        981.060791015625
      ],
      [
        -1899.192626953125,
        -3366.8369140625,
        981.014404296875
      ],
      [
        -1906.1572265625,
        -3336.752685546875,
        1050.1697998046875
      ],
      [
        -1906.344970703125,
        -3336.721435546875,
        1050.388427734375
      ],
      [
        -2095.4931640625,
        -3425.24658203125,
        1027.7513427734375
      ],
      [
        -2095.09765625,
        -3424.814697265625,
        1027.6839599609375
      ],
      [
        -2095.990966796875,
        -3423.116943359375,
        1027.5908203125
      ],
      [
        -2095.0,
        -3425.0,
        1027.694091796875
      ],
      [
        -2095.0,
        -3425.0,
        1027.694091796875
      ],
      [
        -2095.0,
        -3425.0,
        1027.707763671875
      ],
      [
        -2095.0,
        -3425.0,
        1027.707763671875
      ],
      [
        -2074.00537109375,
        -3402.604736328125,
        1052.5999755859375
      ],
      [
        -1906.5107421875,
        -3335.94384765625,
        1052.5999755859375
      ],
      [
        -2074.00537109375,
        -3402.604736328125,
        1052.5999755859375
      ],
      [
        -2093.25244140625,
        -3407.82421875,
        1052.5999755859375
      ],
      [
        -2102.800048828125,
        -3411.51708984375,
        1052.5999755859375
      ],
      [
        -2096.996826171875,
        -3421.205810546875,
        1027.819580078125
      ],
      [
        -2101.585205078125,
        -3413.5810546875,
        1052.5999755859375
      ],
      [
        -2107.56298828125,
        -3425.130126953125,
        1028.556640625
      ],
      [
        -2113.288330078125,
        -3415.558349609375,
        1052.5999755859375
      ],
      [
        -2112.11865234375,
        -3417.773193359375,
        1052.5999755859375
      ],
      [
        -2096.940185546875,
        -3421.313232421875,
        1027.478759765625
      ],
      [
        -2096.996826171875,
        -3421.205810546875,
        1027.819580078125
      ],
      [
        -2105.0,
        -3430.0,
        1052.5999755859375
      ],
      [
        -2095.0,
        -3425.0,
        1052.5999755859375
      ],
      [
        -2111.650390625,
        -3418.66015625,
        1052.5999755859375
      ],
      [
        -2105.0,
        -3430.0,
        1052.5999755859375
      ],
      [
        -2096.146240234375,
        -3422.82177734375,
        1052.5999755859375
      ],
      [
        -2111.650390625,
        -3418.66015625,
        1052.5999755859375
      ],
      [
        -2095.0,
        -3425.0,
        1052.5999755859375
      ],
      [
        -2096.146240234375,
        -3422.82177734375,
        1052.5999755859375
      ],
      [
        -2080.0,
        -3465.0,
        1052.5999755859375
      ],
      [
        -2080.0,
        -3465.0,
        1052.5999755859375
      ],
      [
        -2090.0,
        -3470.0,
        1052.5999755859375
      ],
      [
        -2090.0,
        -3470.0,
        1052.5999755859375
      ],
      [
        -1906.3402099609375,
        -3335.8984375,
        1052.5999755859375
      ],
      [
        -1906.5107421875,
        -3335.94384765625,
        1052.5999755859375
      ],
      [
        -3162.666748046875,
        -4939.7734375,
        1152.623779296875
      ],
      [
        -3175.552978515625,
        -4919.7685546875,
        1052.5999755859375
      ],
      [
        -2214.780029296875,
        -4470.28857421875,
        1302.5999755859375
      ],
      [
        -2214.780029296875,
        -4470.28857421875,
        1052.5999755859375
      ],
      [
        -3744.11083984375,
        -4769.76904296875,
        1302.5999755859375
      ],
      [
        -3733.237548828125,
        -4754.986328125,
        1228.687255859375
      ],
      [
        -3699.999755859375,
        -4719.7685546875,
        1052.5999755859375
      ],
      [
        -3733.237548828125,
        -4754.986328125,
        1228.687255859375
      ],
      [
        -2799.999755859375,
        -4755.7734375,
        1232.623779296875
      ],
      [
        -2799.999755859375,
        -4719.76904296875,
        1052.5999755859375
      ],
      [
        -3016.882080078125,
        -4739.77392578125,
        1152.623779296875
      ],
      [
        -3029.098876953125,
        -4729.86767578125,
        1103.0936279296875
      ],
      [
        -3221.847900390625,
        -4859.59814453125,
        1302.5999755859375
      ],
      [
        -3244.551513671875,
        -4859.876953125,
        1302.5999755859375
      ],
      [
        -3221.847900390625,
        -4859.59814453125,
        1302.5999755859375
      ],
      [
        -3206.59619140625,
        -4859.537109375,
        1302.5999755859375
      ],
      [
        -2954.386962890625,
        -4907.5830078125,
        1302.5999755859375
      ],
      [
        -2954.386962890625,
        -4866.78369140625,
        1302.5999755859375
      ],
      [
        -2954.386962890625,
        -4859.7490234375,
        1302.5999755859375
      ],
      [
        -2936.17822265625,
        -4857.55078125,
        1265.8883056640625
      ],
      [
        -2879.999755859375,
        -4851.9541015625,
        1152.623779296875
      ],
      [
        -2954.386962890625,
        -4866.78369140625,
        1302.5999755859375
      ],
      [
        -3219.23583984375,
        -4851.95458984375,
        1152.623779296875
      ],
      [
        -3219.999755859375,
        -4850.7685546875,
        1128.6246337890625
      ],
      [
        -3210.992919921875,
        -4864.7509765625,
        1290.53515625
      ],
      [
        -3185.6435546875,
        -4906.7431640625,
        1302.5999755859375
      ],
      [
        -3185.6435546875,
        -4904.10400390625,
        1302.5999755859375
      ],
      [
        -3219.999755859375,
        -4850.7685546875,
        1128.6246337890625
      ],
      [
        -3217.48974609375,
        -4847.01220703125,
        1052.5999755859375
      ],
      [
        -2936.17822265625,
        -4857.55078125,
        1265.8883056640625
      ],
      [
        -2954.386962890625,
        -4859.7490234375,
        1302.5999755859375
      ],
      [
        -2978.151611328125,
        -4859.59814453125,
        1302.5999755859375
      ],
      [
        -3185.643798828125,
        -4859.45361328125,
        1302.5999755859375
      ],
      [
        -3185.6435546875,
        -4859.45361328125,
        1302.5999755859375
      ],
      [
        -3014.35595703125,
        -4859.45361328125,
        1302.5999755859375
      ],
      [
        -2978.151611328125,
        -4859.59814453125,
        1302.5999755859375
      ],
      [
        -3219.999755859375,
        -4850.7685546875,
        1149.93603515625
      ],
      [
        -3216.216796875,
        -4845.10693359375,
        1052.5999755859375
      ],
      [
        -3219.900634765625,
        -4850.92236328125,
        1152.623779296875
      ],
      [
        -3219.999755859375,
        -4850.7685546875,
        1149.93603515625
      ],
      [
        -3119.999755859375,
        -4730.7685546875,
        1107.5975341796875
      ],
      [
        -3119.999755859375,
        -4719.76904296875,
        1052.5999755859375
      ],
      [
        -2839.999755859375,
        -4755.7734375,
        1232.623779296875
      ],
      [
        -2799.999755859375,
        -4755.7734375,
        1232.623779296875
      ],
      [
        -3029.098876953125,
        -4729.86767578125,
        1103.0936279296875
      ],
      [
        -3039.36572265625,
        -4719.7685546875,
        1052.5999755859375
      ],
      [
        -2749.999755859375,
        -4755.77392578125,
        1232.623779296875
      ],
      [
        -2724.999755859375,
        -4755.7734375,
        1232.623779296875
      ],
      [
        -3725.0927734375,
        -4286.08154296875,
        1073.0491943359375
      ],
      [
        -3827.165283203125,
        -4342.15087890625,
        1302.5999755859375
      ],
      [
        -3117.009033203125,
        -4293.56640625,
        1101.623779296875
      ],
      [
        -3118.603759765625,
        -4295.22607421875,
        1108.4144287109375
      ],
      [
        -3699.999755859375,
        -4281.10009765625,
        1052.5999755859375
      ],
      [
        -3704.081298828125,
        -4286.0888671875,
        1073.0081787109375
      ],
      [
        -3119.999755859375,
        -4730.7685546875,
        1116.0718994140625
      ],
      [
        -3119.999755859375,
        -4679.7998046875,
        1116.0711669921875
      ],
      [
        -3119.999755859375,
        -4730.7685546875,
        1117.5472412109375
      ],
      [
        -3119.999755859375,
        -4679.7998046875,
        1117.1722412109375
      ],
      [
        -3128.563232421875,
        -4306.03271484375,
        1152.623779296875
      ],
      [
        -3118.603759765625,
        -4295.22607421875,
        1108.4144287109375
      ],
      [
        -3070.100341796875,
        -4689.537109375,
        1152.623779296875
      ],
      [
        -3070.099853515625,
        -4689.53759765625,
        1052.5999755859375
      ],
      [
        -3070.03759765625,
        -4689.5986328125,
        1152.623779296875
      ],
      [
        -3070.03759765625,
        -4689.5986328125,
        1052.5999755859375
      ],
      [
        -3070.061279296875,
        -4629.7685546875,
        1101.585693359375
      ],
      [
        -3020.1005859375,
        -4587.7509765625,
        1052.5999755859375
      ],
      [
        -3070.063720703125,
        -4623.67578125,
        1101.5880126953125
      ],
      [
        -2799.999755859375,
        -4529.7685546875,
        1092.623779296875
      ],
      [
        -2799.999755859375,
        -4479.7685546875,
        1092.623779296875
      ],
      [
        -2799.999755859375,
        -4479.7685546875,
        1092.623779296875
      ],
      [
        -2799.999755859375,
        -4372.7685546875,
        1092.623779296875
      ],
      [
        -3060.9208984375,
        -4529.7685546875,
        1092.623779296875
      ],
      [
        -3060.921142578125,
        -4617.10205078125,
        1092.623779296875
      ],
      [
        -3070.10009765625,
        -4529.7685546875,
        1092.623779296875
      ],
      [
        -3060.9208984375,
        -4529.7685546875,
        1092.623779296875
      ],
      [
        -2909.999755859375,
        -4499.7685546875,
        1092.623779296875
      ],
      [
        -2909.999755859375,
        -4441.7685546875,
        1092.623779296875
      ],
      [
        -2839.999755859375,
        -4559.7685546875,
        1092.623779296875
      ],
      [
        -2799.999755859375,
        -4559.7685546875,
        1052.5999755859375
      ],
      [
        -2799.999755859375,
        -4559.7685546875,
        1092.623779296875
      ],
      [
        -2884.999755859375,
        -4529.7685546875,
        1092.623779296875
      ],
      [
        -2884.999755859375,
        -4499.7685546875,
        1092.623779296875
      ],
      [
        -2884.999755859375,
        -4499.7685546875,
        1092.623779296875
      ],
      [
        -2909.999755859375,
        -4499.7685546875,
        1092.623779296875
      ],
      [
        -2799.999755859375,
        -4372.7685546875,
        1122.623779296875
      ],
      [
        -2799.999755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      [
        -2799.999755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      [
        -2799.999755859375,
        -4319.7685546875,
        1092.623779296875
      ],
      [
        -2799.999755859375,
        -4559.7685546875,
        1112.623779296875
      ],
      [
        -2739.999755859375,
        -4319.7685546875,
        1072.6239013671875
      ],
      [
        -2739.999755859375,
        -4479.7685546875,
        1072.6239013671875
      ],
      [
        -2749.999755859375,
        -4479.7685546875,
        1092.623779296875
      ],
      [
        -2749.999755859375,
        -4372.7685546875,
        1092.623779296875
      ],
      [
        -2749.999755859375,
        -4559.7685546875,
        1092.6239013671875
      ],
      [
        -2799.999755859375,
        -4559.7685546875,
        1092.623779296875
      ],
      [
        -2764.999755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      [
        -2749.999755859375,
        -4319.7685546875,
        1092.623779296875
      ],
      [
        -2759.999755859375,
        -4559.7685546875,
        1112.623779296875
      ],
      [
        -2739.999755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      [
        -2739.999755859375,
        -4319.7685546875,
        1092.623779296875
      ],
      [
        -2687.4853515625,
        -4306.30322265625,
        1122.623779296875
      ],
      [
        -2683.28466796875,
        -4299.0576171875,
        1122.623779296875
      ],
      [
        -2673.35888671875,
        -4281.93603515625,
        1052.5999755859375
      ],
      [
        -2695.29150390625,
        -4319.7685546875,
        1122.623779296875
      ],
      [
        -2695.29150390625,
        -4319.7685546875,
        1092.623779296875
      ],
      [
        -2654.999755859375,
        -4319.7685546875,
        1064.6016845703125
      ],
      [
        -2675.010986328125,
        -4319.7685546875,
        1112.635009765625
      ],
      [
        -2675.010986328125,
        -4372.7685546875,
        1112.6351318359375
      ],
      [
        -2675.010986328125,
        -4319.7685546875,
        1112.635009765625
      ],
      [
        -2687.4853515625,
        -4306.30322265625,
        1142.5771484375
      ],
      [
        -2685.4052734375,
        -4302.71533203125,
        1137.584228515625
      ],
      [
        -2404.44921875,
        -4707.20947265625,
        1212.623779296875
      ],
      [
        -2455.55029296875,
        -4707.20947265625,
        1212.623779296875
      ],
      [
        -2401.098388671875,
        -4712.97314453125,
        1177.623779296875
      ],
      [
        -2399.216796875,
        -4712.97314453125,
        1177.623779296875
      ],
      [
        -2383.865966796875,
        -4728.32373046875,
        1177.623779296875
      ],
      [
        -2476.13330078125,
        -4728.32373046875,
        1177.623779296875
      ],
      [
        -2460.7822265625,
        -4712.97314453125,
        1177.623779296875
      ],
      [
        -2458.901123046875,
        -4712.97314453125,
        1177.623779296875
      ],
      [
        -2458.901123046875,
        -4712.97314453125,
        1177.623779296875
      ],
      [
        -2458.969482421875,
        -4710.50341796875,
        1192.623779296875
      ],
      [
        -2455.55029296875,
        -4707.20947265625,
        1212.623779296875
      ],
      [
        -2401.030029296875,
        -4710.50341796875,
        1192.623779296875
      ],
      [
        -2404.44921875,
        -4707.20947265625,
        1212.623779296875
      ],
      [
        -2359.095947265625,
        -4712.97265625,
        1177.623779296875
      ],
      [
        -2500.903564453125,
        -4712.97265625,
        1177.623779296875
      ],
      [
        -2470.485107421875,
        -4712.97314453125,
        1177.623779296875
      ],
      [
        -2483.222412109375,
        -4691.23291015625,
        1159.0247802734375
      ],
      [
        -2325.060791015625,
        -4699.79443359375,
        1177.623779296875
      ],
      [
        -2381.70751953125,
        -4684.6162109375,
        1177.623779296875
      ],
      [
        -2660.082763671875,
        -4372.7685546875,
        1097.7069091796875
      ],
      [
        -2675.010986328125,
        -4350.705078125,
        1112.6351318359375
      ],
      [
        -2687.4853515625,
        -4306.30322265625,
        1152.259033203125
      ],
      [
        -3804.730224609375,
        -4329.8271484375,
        1252.145751953125
      ],
      [
        -3827.1015625,
        -4342.06982421875,
        1302.5999755859375
      ],
      [
        -2680.017822265625,
        -4293.42236328125,
        1099.5777587890625
      ],
      [
        -3699.999755859375,
        -4247.81884765625,
        1052.5999755859375
      ],
      [
        -3746.163818359375,
        -4247.82763671875,
        1283.420654296875
      ],
      [
        -3747.91845703125,
        -4247.82763671875,
        1283.418701171875
      ],
      [
        -3752.752197265625,
        -4247.82861328125,
        1302.5999755859375
      ],
      [
        -2666.06884765625,
        -4269.361328125,
        1152.623779296875
      ],
      [
        -2666.06884765625,
        -4269.361328125,
        1052.5999755859375
      ],
      [
        -3699.999755859375,
        -4239.7685546875,
        1052.5999755859375
      ],
      [
        -3749.999755859375,
        -4239.7685546875,
        1302.5999755859375
      ],
      [
        -3430.738037109375,
        -4186.0302734375,
        1092.4654541015625
      ],
      [
        -3424.76611328125,
        -4192.001953125,
        1052.5999755859375
      ],
      [
        -3416.10888671875,
        -3935.422119140625,
        1302.5999755859375
      ],
      [
        -3386.928466796875,
        -3948.4140625,
        1151.6270751953125
      ],
      [
        -3087.4287109375,
        -3368.7841796875,
        1302.5999755859375
      ],
      [
        -3086.152099609375,
        -3932.528564453125,
        1052.5999755859375
      ],
      [
        -3110.8232421875,
        -3943.19287109375,
        1247.45458984375
      ],
      [
        -3086.49267578125,
        -3903.7587890625,
        1079.9710693359375
      ],
      [
        -3083.144287109375,
        -3903.39501953125,
        1052.5999755859375
      ],
      [
        -3083.468505859375,
        -3931.36865234375,
        1154.199951171875
      ],
      [
        -3094.6171875,
        -3936.187744140625,
        1280.1251220703125
      ],
      [
        -3080.901123046875,
        -3903.1513671875,
        1082.623779296875
      ],
      [
        -3080.8984375,
        -3903.151123046875,
        1052.5999755859375
      ],
      [
        -3080.901123046875,
        -3903.1513671875,
        1082.623779296875
      ],
      [
        -3080.906005859375,
        -3903.15185546875,
        1139.7886962890625
      ],
      [
        -3085.076904296875,
        -3903.60498046875,
        1187.623779296875
      ],
      [
        -3077.043212890625,
        -3860.464111328125,
        1072.5999755859375
      ],
      [
        -3077.04150390625,
        -3860.464111328125,
        1052.5999755859375
      ],
      [
        -3078.84326171875,
        -3880.383056640625,
        1072.5999755859375
      ],
      [
        -3077.043212890625,
        -3860.464111328125,
        1072.5999755859375
      ],
      [
        -3078.843017578125,
        -3880.383056640625,
        1072.3743896484375
      ],
      [
        -3078.841552734375,
        -3880.383056640625,
        1052.5999755859375
      ],
      [
        -3078.84326171875,
        -3880.383056640625,
        1072.5999755859375
      ],
      [
        -3078.843017578125,
        -3880.383056640625,
        1072.3743896484375
      ],
      [
        -3080.91015625,
        -3903.15234375,
        1187.623779296875
      ],
      [
        -2739.749755859375,
        -3866.09033203125,
        1082.623779296875
      ],
      [
        -2739.749755859375,
        -3866.09033203125,
        1052.5999755859375
      ],
      [
        -2739.749755859375,
        -3866.09033203125,
        1082.623779296875
      ],
      [
        -2739.749755859375,
        -3866.09033203125,
        1226.623779296875
      ],
      [
        -2769.29736328125,
        -3873.324462890625,
        1226.623779296875
      ],
      [
        -2769.29736328125,
        -3873.324462890625,
        1203.623779296875
      ],
      [
        -2768.421630859375,
        -3869.205078125,
        1226.623779296875
      ],
      [
        -2768.421630859375,
        -3869.205078125,
        1203.623779296875
      ],
      [
        -3047.613037109375,
        -3865.04638671875,
        1072.5999755859375
      ],
      [
        -3047.613037109375,
        -3865.04638671875,
        1052.5999755859375
      ],
      [
        -3049.181884765625,
        -3882.977783203125,
        1070.5999755859375
      ],
      [
        -3078.8427734375,
        -3880.383056640625,
        1070.5999755859375
      ],
      [
        -3049.181884765625,
        -3882.977783203125,
        1070.5999755859375
      ],
      [
        -3047.613037109375,
        -3865.04638671875,
        1070.5999755859375
      ],
      [
        -2457.470458984375,
        -3820.60791015625,
        1052.5999755859375
      ],
      [
        -2576.844482421875,
        -4027.3720703125,
        1102.623779296875
      ],
      [
        -2556.418701171875,
        -3991.838623046875,
        1082.623779296875
      ],
      [
        -2556.384521484375,
        -3991.900146484375,
        1052.5999755859375
      ],
      [
        -2556.418701171875,
        -3991.838623046875,
        1082.623779296875
      ],
      [
        -2556.375,
        -3991.91748046875,
        1094.0460205078125
      ],
      [
        -2556.431884765625,
        -3991.815185546875,
        1094.033447265625
      ],
      [
        -2563.491943359375,
        -4004.0439453125,
        1096.991943359375
      ],
      [
        -2563.375,
        -4004.0419921875,
        1096.9793701171875
      ],
      [
        -2563.458251953125,
        -4004.04345703125,
        1082.623779296875
      ],
      [
        -2574.960693359375,
        -4023.9111328125,
        1101.0238037109375
      ],
      [
        -2574.874755859375,
        -4023.960693359375,
        1101.0238037109375
      ],
      [
        -2574.874755859375,
        -4023.960693359375,
        1101.79833984375
      ],
      [
        -2574.9619140625,
        -4023.910400390625,
        1101.79833984375
      ],
      [
        -2536.157470703125,
        -3956.89892578125,
        1070.5999755859375
      ],
      [
        -2546.8701171875,
        -3975.453857421875,
        1070.5999755859375
      ],
      [
        -2536.157470703125,
        -3956.89892578125,
        1070.5999755859375
      ],
      [
        -2536.157470703125,
        -3956.89892578125,
        1052.5999755859375
      ],
      [
        -2546.8701171875,
        -3975.453857421875,
        1070.5999755859375
      ],
      [
        -2546.869873046875,
        -3975.4541015625,
        1052.5999755859375
      ],
      [
        -2586.52587890625,
        -3994.139892578125,
        1097.6080322265625
      ],
      [
        -2569.205322265625,
        -4004.139892578125,
        1097.6080322265625
      ],
      [
        -2643.68359375,
        -3961.139892578125,
        1097.6080322265625
      ],
      [
        -2586.52587890625,
        -3994.139892578125,
        1097.6080322265625
      ],
      [
        -2569.205322265625,
        -4004.139892578125,
        1097.6080322265625
      ],
      [
        -2579.205322265625,
        -4021.46044921875,
        1101.7984619140625
      ],
      [
        -2596.52587890625,
        -4011.46044921875,
        1101.7984619140625
      ],
      [
        -2586.52587890625,
        -3994.139892578125,
        1097.6080322265625
      ],
      [
        -2579.205322265625,
        -4021.46044921875,
        1101.79833984375
      ],
      [
        -2694.376953125,
        -3924.94384765625,
        1096.350830078125
      ],
      [
        -2640.68359375,
        -3955.94384765625,
        1096.350830078125
      ],
      [
        -2745.6064453125,
        -3897.67578125,
        1096.7698974609375
      ],
      [
        -2695.376953125,
        -3926.67578125,
        1096.7698974609375
      ],
      [
        -2598.382080078125,
        -3982.67578125,
        1082.623779296875
      ],
      [
        -2598.382080078125,
        -3982.67578125,
        1052.5999755859375
      ],
      [
        -2603.84619140625,
        -3984.139892578125,
        1097.60791015625
      ],
      [
        -2598.382080078125,
        -3982.67578125,
        1082.623779296875
      ],
      [
        -2598.382080078125,
        -3982.67578125,
        1096.7698974609375
      ],
      [
        -2569.205322265625,
        -4004.139892578125,
        1097.6080322265625
      ],
      [
        -2641.68359375,
        -3957.67578125,
        1082.623779296875
      ],
      [
        -2641.68359375,
        -3957.67578125,
        1052.5999755859375
      ],
      [
        -2641.68359375,
        -3957.67578125,
        1082.623779296875
      ],
      [
        -2643.68359375,
        -3961.139892578125,
        1097.6080322265625
      ],
      [
        -2641.68359375,
        -3957.67578125,
        1096.7698974609375
      ],
      [
        -2595.650146484375,
        -3981.94384765625,
        1082.623779296875
      ],
      [
        -2595.650146484375,
        -3981.94384765625,
        1052.5999755859375
      ],
      [
        -2595.650146484375,
        -3981.94384765625,
        1082.623779296875
      ],
      [
        -2595.650146484375,
        -3981.94384765625,
        1096.350830078125
      ],
      [
        -2640.68359375,
        -3955.94384765625,
        1096.350830078125
      ],
      [
        -2695.376953125,
        -3926.67578125,
        1096.7698974609375
      ],
      [
        -2694.376953125,
        -3924.94384765625,
        1096.350830078125
      ],
      [
        -2576.52587890625,
        -3976.8193359375,
        1093.41748046875
      ],
      [
        -2559.205322265625,
        -3986.8193359375,
        1093.4176025390625
      ],
      [
        -2576.52587890625,
        -3976.8193359375,
        1093.41748046875
      ],
      [
        -2559.205322265625,
        -3986.8193359375,
        1093.4176025390625
      ],
      [
        -2566.59765625,
        -3975.623291015625,
        1092.160400390625
      ],
      [
        -2556.205322265625,
        -3981.623291015625,
        1092.160400390625
      ],
      [
        -2569.59765625,
        -3980.8193359375,
        1093.41748046875
      ],
      [
        -2566.59765625,
        -3975.623291015625,
        1092.160400390625
      ],
      [
        -2559.205322265625,
        -3986.8193359375,
        1093.4176025390625
      ],
      [
        -2556.205322265625,
        -3981.623291015625,
        1092.160400390625
      ],
      [
        -2574.874755859375,
        -4023.960693359375,
        1142.623779296875
      ],
      [
        -2574.874755859375,
        -4023.960693359375,
        1142.623779296875
      ],
      [
        -2564.875,
        -4006.64013671875,
        1142.623779296875
      ],
      [
        -2564.875,
        -4006.64013671875,
        1104.623779296875
      ],
      [
        -2641.68359375,
        -3957.67578125,
        1172.623779296875
      ],
      [
        -2641.68359375,
        -3957.67578125,
        1096.7698974609375
      ],
      [
        -2598.382080078125,
        -3982.67578125,
        1096.769775390625
      ],
      [
        -2598.382080078125,
        -3982.67578125,
        1166.623779296875
      ],
      [
        -2595.650634765625,
        -3981.94384765625,
        1096.350830078125
      ],
      [
        -2595.650634765625,
        -3981.94384765625,
        1166.623779296875
      ],
      [
        -2214.780029296875,
        -4450.17041015625,
        1302.5999755859375
      ],
      [
        -2214.780029296875,
        -4444.59619140625,
        1052.5999755859375
      ],
      [
        -2190.8857421875,
        -4417.92333984375,
        1052.5999755859375
      ],
      [
        -2190.8857421875,
        -4417.92333984375,
        1082.623779296875
      ],
      [
        -2190.8857421875,
        -4417.92333984375,
        1082.623779296875
      ],
      [
        -2190.8857421875,
        -4417.92333984375,
        1187.623779296875
      ],
      [
        -2147.994140625,
        -4390.62158203125,
        1052.5999755859375
      ],
      [
        -2147.994140625,
        -4390.62158203125,
        1072.5999755859375
      ],
      [
        -2147.994140625,
        -4390.62158203125,
        1072.5999755859375
      ],
      [
        -2164.866455078125,
        -4401.361328125,
        1072.5999755859375
      ],
      [
        -2164.86669921875,
        -4401.361328125,
        1052.5999755859375
      ],
      [
        -2164.86669921875,
        -4401.361328125,
        1071.330810546875
      ],
      [
        -2164.866455078125,
        -4401.361328125,
        1072.5999755859375
      ],
      [
        -2164.86669921875,
        -4401.361328125,
        1071.330810546875
      ],
      [
        -2222.2890625,
        -4346.72216796875,
        1052.5999755859375
      ],
      [
        -2219.427001953125,
        -4353.21142578125,
        1080.8914794921875
      ],
      [
        -2212.47216796875,
        -4378.89208984375,
        1187.623779296875
      ],
      [
        -2223.0869140625,
        -4354.82568359375,
        1082.6944580078125
      ],
      [
        -2222.943359375,
        -4354.76220703125,
        1082.623779296875
      ],
      [
        -2219.427001953125,
        -4353.21142578125,
        1080.8914794921875
      ],
      [
        -2222.943359375,
        -4354.76220703125,
        1082.623779296875
      ],
      [
        -2223.0869140625,
        -4354.82568359375,
        1082.6944580078125
      ],
      [
        -2164.826416015625,
        -4367.45751953125,
        1052.5999755859375
      ],
      [
        -2164.826416015625,
        -4367.45751953125,
        1072.5999755859375
      ],
      [
        -2164.86669921875,
        -4401.361328125,
        1070.5999755859375
      ],
      [
        -2180.091552734375,
        -4376.99609375,
        1070.5999755859375
      ],
      [
        -2164.826416015625,
        -4367.45751953125,
        1070.5999755859375
      ],
      [
        -2180.091552734375,
        -4376.99609375,
        1070.5999755859375
      ],
      [
        -1846.745361328125,
        -4225.9462890625,
        1302.5999755859375
      ],
      [
        -2329.536376953125,
        -4103.5615234375,
        1226.623779296875
      ],
      [
        -2329.536376953125,
        -4103.5615234375,
        1082.623779296875
      ],
      [
        -2321.402587890625,
        -4131.91748046875,
        1203.623779296875
      ],
      [
        -2321.402587890625,
        -4131.91748046875,
        1226.623779296875
      ],
      [
        -2318.272705078125,
        -4129.099609375,
        1203.623779296875
      ],
      [
        -2318.272705078125,
        -4129.09912109375,
        1226.623779296875
      ],
      [
        -2329.91162109375,
        -4102.71044921875,
        1052.5999755859375
      ],
      [
        -2329.91162109375,
        -4102.71044921875,
        1082.623779296875
      ],
      [
        -2329.91162109375,
        -4102.71044921875,
        1082.623779296875
      ],
      [
        -2329.91162109375,
        -4102.71044921875,
        1226.623779296875
      ],
      [
        -2658.272705078125,
        -4255.91357421875,
        1152.623779296875
      ],
      [
        -2564.874267578125,
        -4094.807373046875,
        1113.6060791015625
      ],
      [
        -2548.897216796875,
        -4038.958740234375,
        1101.0238037109375
      ],
      [
        -2548.89453125,
        -4038.960205078125,
        1101.79833984375
      ],
      [
        -2574.874755859375,
        -4023.960693359375,
        1101.79833984375
      ],
      [
        -2537.567626953125,
        -4018.94189453125,
        1096.9793701171875
      ],
      [
        -2549.067626953125,
        -4038.8603515625,
        1101.7984619140625
      ],
      [
        -2537.567626953125,
        -4018.94189453125,
        1096.9794921875
      ],
      [
        -2530.567626953125,
        -4006.8173828125,
        1094.0460205078125
      ],
      [
        -2537.487060546875,
        -4019.087158203125,
        1082.623779296875
      ],
      [
        -2537.567626953125,
        -4018.94189453125,
        1096.9794921875
      ],
      [
        -2537.45458984375,
        -4019.1455078125,
        1097.004638671875
      ],
      [
        -2530.443603515625,
        -4006.8154296875,
        1070.5999755859375
      ],
      [
        -2530.3876953125,
        -4006.814453125,
        1082.623779296875
      ],
      [
        -2530.567626953125,
        -4006.8173828125,
        1070.5999755859375
      ],
      [
        -2530.334716796875,
        -4006.8134765625,
        1094.0208740234375
      ],
      [
        -2530.567626953125,
        -4006.8173828125,
        1094.0460205078125
      ],
      [
        -2530.3876953125,
        -4006.814453125,
        1082.623779296875
      ],
      [
        -2530.527587890625,
        -4006.816650390625,
        1052.5999755859375
      ],
      [
        -2530.148681640625,
        -4028.199951171875,
        1097.882080078125
      ],
      [
        -2530.148681640625,
        -4034.907958984375,
        1052.5999755859375
      ],
      [
        -2530.148681640625,
        -4034.907958984375,
        1099.099365234375
      ],
      [
        -2530.148681640625,
        -4006.810302734375,
        1052.5999755859375
      ],
      [
        -2530.148681640625,
        -4006.810546875,
        1082.623779296875
      ],
      [
        -2530.148681640625,
        -4006.810302734375,
        1094.0008544921875
      ],
      [
        -2530.148681640625,
        -4006.810546875,
        1082.623779296875
      ],
      [
        -2536.020263671875,
        -4026.26171875,
        1098.1455078125
      ],
      [
        -2534.737548828125,
        -4024.0400390625,
        1097.6080322265625
      ],
      [
        -2544.737548828125,
        -4041.3603515625,
        1101.7984619140625
      ],
      [
        -2540.882568359375,
        -4034.68359375,
        1100.18310546875
      ],
      [
        -2534.737548828125,
        -4024.0400390625,
        1097.6080322265625
      ],
      [
        -2530.148681640625,
        -4026.689453125,
        1082.623779296875
      ],
      [
        -2530.148681640625,
        -4026.689453125,
        1097.6080322265625
      ],
      [
        -2534.737548828125,
        -4024.0400390625,
        1097.6080322265625
      ],
      [
        -2544.737548828125,
        -4041.3603515625,
        1101.79833984375
      ],
      [
        -2530.148681640625,
        -4028.199951171875,
        1097.882080078125
      ],
      [
        -2526.259765625,
        -4028.199951171875,
        1097.474609375
      ],
      [
        -2526.259765625,
        -4028.199951171875,
        1052.5999755859375
      ],
      [
        -2516.548095703125,
        -4011.44775390625,
        1052.5999755859375
      ],
      [
        -2516.548095703125,
        -4011.44775390625,
        1082.623779296875
      ],
      [
        -2524.737548828125,
        -4006.719482421875,
        1093.4176025390625
      ],
      [
        -2516.548095703125,
        -4011.44775390625,
        1082.623779296875
      ],
      [
        -2516.548095703125,
        -4011.44775390625,
        1093.4176025390625
      ],
      [
        -2524.737548828125,
        -4006.719482421875,
        1093.4176025390625
      ],
      [
        -2527.532470703125,
        -4028.199951171875,
        1082.623779296875
      ],
      [
        -2527.532470703125,
        -4028.199951171875,
        1097.6080322265625
      ],
      [
        -2513.538818359375,
        -4006.2568359375,
        1052.5999755859375
      ],
      [
        -2513.538818359375,
        -4006.2568359375,
        1082.623779296875
      ],
      [
        -2521.737548828125,
        -4001.5234375,
        1092.160400390625
      ],
      [
        -2513.538818359375,
        -4006.2568359375,
        1082.623779296875
      ],
      [
        -2513.538818359375,
        -4006.2568359375,
        1092.160400390625
      ],
      [
        -2524.737548828125,
        -4006.719482421875,
        1093.4176025390625
      ],
      [
        -2521.737548828125,
        -4001.5234375,
        1092.160400390625
      ],
      [
        -2526.578857421875,
        -4028.75048828125,
        1082.623779296875
      ],
      [
        -2526.578857421875,
        -4028.75048828125,
        1097.6080322265625
      ],
      [
        -2517.4169921875,
        -4034.0400390625,
        1097.6080322265625
      ],
      [
        -2517.4169921875,
        -4034.0400390625,
        1097.6080322265625
      ],
      [
        -2460.25927734375,
        -4067.0400390625,
        1097.6080322265625
      ],
      [
        -2521.800048828125,
        -4036.266357421875,
        1098.4710693359375
      ],
      [
        -2530.148681640625,
        -4036.266357421875,
        1099.345703125
      ],
      [
        -2530.148681640625,
        -4036.266357421875,
        1099.3458251953125
      ],
      [
        -2521.800048828125,
        -4031.509521484375,
        1097.60791015625
      ],
      [
        -2521.800048828125,
        -4036.266357421875,
        1098.4710693359375
      ],
      [
        -2521.800048828125,
        -4031.509521484375,
        1052.5999755859375
      ],
      [
        -2457.25927734375,
        -4061.84375,
        1096.350830078125
      ],
      [
        -2403.565673828125,
        -4092.84375,
        1096.350830078125
      ],
      [
        -2404.565673828125,
        -4094.575927734375,
        1096.7698974609375
      ],
      [
        -2354.336181640625,
        -4123.57568359375,
        1096.769775390625
      ],
      [
        -2521.800048828125,
        -4028.199951171875,
        1097.0074462890625
      ],
      [
        -2521.800048828125,
        -4028.199951171875,
        1097.0074462890625
      ],
      [
        -2501.560302734375,
        -4038.576416015625,
        1082.623779296875
      ],
      [
        -2501.560302734375,
        -4038.576416015625,
        1052.5999755859375
      ],
      [
        -2501.560302734375,
        -4038.576416015625,
        1082.623779296875
      ],
      [
        -2500.096435546875,
        -4044.0400390625,
        1097.6080322265625
      ],
      [
        -2501.560302734375,
        -4038.576416015625,
        1096.77001953125
      ],
      [
        -2458.25927734375,
        -4063.575927734375,
        1082.623779296875
      ],
      [
        -2458.25927734375,
        -4063.575927734375,
        1052.5999755859375
      ],
      [
        -2460.25927734375,
        -4067.0400390625,
        1097.6080322265625
      ],
      [
        -2458.25927734375,
        -4063.575927734375,
        1082.623779296875
      ],
      [
        -2458.25927734375,
        -4063.575927734375,
        1096.7698974609375
      ],
      [
        -2502.29248046875,
        -4035.84375,
        1082.623779296875
      ],
      [
        -2502.29248046875,
        -4035.84375,
        1052.5999755859375
      ],
      [
        -2502.29248046875,
        -4035.84375,
        1082.623779296875
      ],
      [
        -2502.29248046875,
        -4035.84375,
        1096.350830078125
      ],
      [
        -2457.25927734375,
        -4061.84375,
        1096.350830078125
      ],
      [
        -2403.565673828125,
        -4092.84375,
        1096.350830078125
      ],
      [
        -2404.565673828125,
        -4094.575927734375,
        1096.7698974609375
      ],
      [
        -2507.4169921875,
        -4016.719482421875,
        1093.41748046875
      ],
      [
        -2507.4169921875,
        -4016.719482421875,
        1093.41748046875
      ],
      [
        -2514.34521484375,
        -4012.719482421875,
        1093.41748046875
      ],
      [
        -2511.34521484375,
        -4007.523193359375,
        1092.160400390625
      ],
      [
        -2511.34521484375,
        -4007.523193359375,
        1092.160400390625
      ],
      [
        -2526.578857421875,
        -4028.75048828125,
        1097.6080322265625
      ],
      [
        -2526.578857421875,
        -4028.75048828125,
        1187.623779296875
      ],
      [
        -2564.875,
        -4006.64013671875,
        1142.623779296875
      ],
      [
        -2539.067626953125,
        -4021.5400390625,
        1104.623779296875
      ],
      [
        -2539.067626953125,
        -4021.5400390625,
        1097.60791015625
      ],
      [
        -2539.067626953125,
        -4021.5400390625,
        1104.623779296875
      ],
      [
        -2530.825439453125,
        -4036.0751953125,
        1115.6239013671875
      ],
      [
        -2530.825439453125,
        -4036.0751953125,
        1104.6239013671875
      ],
      [
        -2527.5322265625,
        -4028.199951171875,
        1115.6239013671875
      ],
      [
        -2527.5322265625,
        -4028.199951171875,
        1097.60791015625
      ],
      [
        -2537.139404296875,
        -4028.199951171875,
        1104.6239013671875
      ],
      [
        -2537.139404296875,
        -4028.199951171875,
        1115.623779296875
      ],
      [
        -2530.148681640625,
        -4034.907958984375,
        1104.6239013671875
      ],
      [
        -2530.825439453125,
        -4036.0751953125,
        1104.6239013671875
      ],
      [
        -2530.148681640625,
        -4034.907958984375,
        1104.6239013671875
      ],
      [
        -2530.148681640625,
        -4034.907958984375,
        1099.099365234375
      ],
      [
        -2530.825439453125,
        -4036.0751953125,
        1115.6239013671875
      ],
      [
        -2530.148681640625,
        -4034.907958984375,
        1115.6239013671875
      ],
      [
        -2527.5322265625,
        -4028.199951171875,
        1115.6239013671875
      ],
      [
        -2530.148681640625,
        -4034.907958984375,
        1115.6239013671875
      ],
      [
        -2526.578857421875,
        -4028.750244140625,
        1115.6239013671875
      ],
      [
        -2516.548095703125,
        -4011.44775390625,
        1093.4176025390625
      ],
      [
        -2516.548095703125,
        -4011.44775390625,
        1166.623779296875
      ],
      [
        -2526.259765625,
        -4028.199951171875,
        1115.6239013671875
      ],
      [
        -2526.259765625,
        -4028.199951171875,
        1097.474609375
      ],
      [
        -2526.259765625,
        -4028.199951171875,
        1115.6239013671875
      ],
      [
        -2539.067626953125,
        -4021.5400390625,
        1142.623779296875
      ],
      [
        -2513.538818359375,
        -4006.2568359375,
        1092.160400390625
      ],
      [
        -2513.538818359375,
        -4006.2568359375,
        1158.5999755859375
      ],
      [
        -2521.800048828125,
        -4031.50927734375,
        1115.623779296875
      ],
      [
        -2521.800048828125,
        -4031.50927734375,
        1097.60791015625
      ],
      [
        -2521.800048828125,
        -4031.50927734375,
        1115.623779296875
      ],
      [
        -2526.578857421875,
        -4028.750244140625,
        1115.6239013671875
      ],
      [
        -2458.25927734375,
        -4063.575927734375,
        1096.7698974609375
      ],
      [
        -2458.25927734375,
        -4063.575927734375,
        1172.623779296875
      ],
      [
        -2501.560546875,
        -4038.575927734375,
        1166.623779296875
      ],
      [
        -2501.560546875,
        -4038.575927734375,
        1096.7698974609375
      ],
      [
        -2502.29248046875,
        -4035.84375,
        1166.623779296875
      ],
      [
        -2502.29248046875,
        -4035.84375,
        1096.350830078125
      ],
      [
        -1857.6810302734375,
        -3492.7607421875,
        1082.7611083984375
      ],
      [
        -2021.9903564453125,
        -3566.09375,
        1121.9991455078125
      ],
      [
        -2021.9903564453125,
        -3566.09375,
        1121.9991455078125
      ],
      [
        -2071.127197265625,
        -3537.124755859375,
        1052.5999755859375
      ],
      [
        -1991.4388427734375,
        -3517.48046875,
        1168.9072265625
      ],
      [
        -2067.511962890625,
        -3472.400146484375,
        1052.5999755859375
      ],
      [
        -2081.520263671875,
        -3475.025146484375,
        1052.5999755859375
      ],
      [
        -2017.416015625,
        -3513.012939453125,
        1150.6083984375
      ],
      [
        -1982.8216552734375,
        -3533.51318359375,
        1203.499267578125
      ],
      [
        -1958.65478515625,
        -3536.908203125,
        1219.0303955078125
      ],
      [
        -1958.65478515625,
        -3536.908203125,
        1219.0303955078125
      ],
      [
        -1982.8216552734375,
        -3533.51318359375,
        1203.499267578125
      ],
      [
        -1927.432373046875,
        -3566.33642578125,
        1234.0
      ],
      [
        -1851.7945556640625,
        -4222.4580078125,
        1206.1490478515625
      ],
      [
        -2014.9686279296875,
        -3689.6044921875,
        1080.0
      ],
      [
        -2011.17529296875,
        -3687.14111328125,
        1073.4464111328125
      ],
      [
        -2019.0828857421875,
        -3668.428955078125,
        1076.0538330078125
      ],
      [
        -2021.3670654296875,
        -3669.912353515625,
        1080.0
      ],
      [
        -2848.796875,
        -3363.318115234375,
        1119.5692138671875
      ],
      [
        -2921.3994140625,
        -3392.010498046875,
        1052.5999755859375
      ],
      [
        -2848.796875,
        -3363.318115234375,
        1119.5692138671875
      ],
      [
        -2675.971435546875,
        -3388.3564453125,
        1069.7086181640625
      ],
      [
        -2655.969970703125,
        -3389.390869140625,
        1068.115478515625
      ],
      [
        -2655.413818359375,
        -3384.099609375,
        1080.0
      ],
      [
        -2675.489990234375,
        -3383.7744140625,
        1080.0
      ],
      [
        -2675.971435546875,
        -3388.3564453125,
        1069.7086181640625
      ],
      [
        -2675.489990234375,
        -3383.7744140625,
        1080.0
      ],
      [
        -2655.413818359375,
        -3384.099609375,
        1080.0
      ],
      [
        -2655.969970703125,
        -3389.390869140625,
        1068.115478515625
      ],
      [
        -3080.897216796875,
        -3359.11669921875,
        1270.885009765625
      ],
      [
        -3056.01953125,
        -3390.484130859375,
        1161.1541748046875
      ],
      [
        -3080.897216796875,
        -3359.11669921875,
        1270.885009765625
      ],
      [
        -2936.673095703125,
        -3397.090087890625,
        1069.902587890625
      ],
      [
        -2956.347412109375,
        -3400.721923828125,
        1070.666748046875
      ],
      [
        -2937.185791015625,
        -3393.852783203125,
        1080.0
      ],
      [
        -2956.8212890625,
        -3397.729736328125,
        1080.0
      ],
      [
        -2956.347412109375,
        -3400.721923828125,
        1070.666748046875
      ],
      [
        -2956.8212890625,
        -3397.729736328125,
        1080.0
      ],
      [
        -2937.185791015625,
        -3393.852783203125,
        1080.0
      ],
      [
        -2936.673095703125,
        -3397.090087890625,
        1069.902587890625
      ],
      [
        -3749.99951171875,
        -4839.2734375,
        1302.5999755859375
      ],
      [
        -3963.99951171875,
        -4828.22119140625,
        1534.9000244140625
      ],
      [
        -2180.76025390625,
        -4906.98388671875,
        1334.2109375
      ],
      [
        -2214.77978515625,
        -4879.7685546875,
        1302.5999755859375
      ],
      [
        -2180.76025390625,
        -4906.98388671875,
        1334.2109375
      ],
      [
        -1964.797119140625,
        -5079.7685546875,
        1534.9000244140625
      ],
      [
        -3122.587646484375,
        -4905.60693359375,
        1332.611083984375
      ],
      [
        -3185.643798828125,
        -4879.7685546875,
        1302.5999755859375
      ],
      [
        -2962.83203125,
        -4894.427734375,
        1319.626708984375
      ],
      [
        -2997.05419921875,
        -4905.70068359375,
        1332.7203369140625
      ],
      [
        -2962.83203125,
        -4894.427734375,
        1319.626708984375
      ],
      [
        -2954.386962890625,
        -4879.7685546875,
        1302.5999755859375
      ],
      [
        -2170.537109375,
        -4888.11669921875,
        1343.7103271484375
      ],
      [
        -2214.77978515625,
        -4862.5732421875,
        1302.5999755859375
      ],
      [
        -2170.537109375,
        -4888.11669921875,
        1343.7103271484375
      ],
      [
        -1964.794921875,
        -5006.90185546875,
        1534.9000244140625
      ],
      [
        -3185.643798828125,
        -4861.4267578125,
        1302.5999755859375
      ],
      [
        -2954.386962890625,
        -4860.4365234375,
        1302.5999755859375
      ],
      [
        -3185.643798828125,
        -4860.693359375,
        1302.5999755859375
      ],
      [
        -1683.0428466796875,
        -4092.79296875,
        1507.3250732421875
      ],
      [
        -1675.3681640625,
        -4088.0654296875,
        1534.9000244140625
      ],
      [
        -1683.0428466796875,
        -4092.79296875,
        1507.3250732421875
      ],
      [
        -1721.60205078125,
        -3913.829345703125,
        1522.3487548828125
      ],
      [
        -1713.584716796875,
        -3930.347900390625,
        1534.9000244140625
      ],
      [
        -1721.60205078125,
        -3913.829345703125,
        1522.3487548828125
      ],
      [
        -1735.2222900390625,
        -3893.648193359375,
        1502.359130859375
      ],
      [
        -1787.0877685546875,
        -3816.79833984375,
        1426.2386474609375
      ],
      [
        -2071.58203125,
        -4476.22900390625,
        1435.653076171875
      ],
      [
        -2214.763427734375,
        -4433.12353515625,
        1302.5999755859375
      ],
      [
        -2132.705078125,
        -3282.2880859375,
        1341.522705078125
      ],
      [
        -2132.705078125,
        -3282.2880859375,
        1341.522705078125
      ],
      [
        -2166.9013671875,
        -3315.716064453125,
        1302.5999755859375
      ],
      [
        -2084.453369140625,
        -3195.6806640625,
        1471.4671630859375
      ],
      [
        -2018.7822265625,
        -3134.806884765625,
        1534.9000244140625
      ],
      [
        -2137.895263671875,
        -3234.538818359375,
        1428.4024658203125
      ],
      [
        -2084.453369140625,
        -3195.6806640625,
        1471.4671630859375
      ],
      [
        -2137.895263671875,
        -3234.538818359375,
        1428.4024658203125
      ],
      [
        -2278.3076171875,
        -3352.430908203125,
        1302.5999755859375
      ],
      [
        -2753.905029296875,
        -3284.06787109375,
        1302.5999755859375
      ],
      [
        -2842.10595703125,
        -3141.1943359375,
        1494.9527587890625
      ],
      [
        -2842.10595703125,
        -3141.194580078125,
        1494.9527587890625
      ],
      [
        -2860.00634765625,
        -3111.114501953125,
        1534.9000244140625
      ],
      [
        -3174.78125,
        -3345.46533203125,
        1457.6463623046875
      ],
      [
        -3174.781494140625,
        -3345.46533203125,
        1457.6466064453125
      ],
      [
        -3106.85986328125,
        -3381.18115234375,
        1327.955322265625
      ],
      [
        -3086.888427734375,
        -3384.146240234375,
        1302.5999755859375
      ],
      [
        -3106.85986328125,
        -3381.18115234375,
        1327.9552001953125
      ],
      [
        -3110.700927734375,
        -3586.492919921875,
        1342.072998046875
      ],
      [
        -3207.721435546875,
        -3536.609375,
        1463.6553955078125
      ],
      [
        -3081.143798828125,
        -3604.59033203125,
        1302.5999755859375
      ],
      [
        -3110.700927734375,
        -3586.492919921875,
        1342.072998046875
      ],
      [
        -3239.798583984375,
        -3483.112060546875,
        1534.9000244140625
      ],
      [
        -3207.721435546875,
        -3536.609375,
        1463.6553955078125
      ],
      [
        -3216.740966796875,
        -3521.56689453125,
        1483.6881103515625
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        -0.7746099233627319,
        -0.5822634696960449,
        0.2468777596950531
      ],
      "plane_d": -3030.36767578125,
      "bbox_min": [
        -1320.0,
        -3357.557373046875,
        715.0380249023438
      ],
      "bbox_max": [
        -755.7307739257812,
        -2930.939453125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14039453864097595,
        -0.9834563732147217,
        0.11446819454431534
      ],
      "plane_d": -2961.9658203125,
      "bbox_min": [
        -1320.0,
        -3350.7841796875,
        715.0380249023438
      ],
      "bbox_max": [
        -755.7307739257812,
        -2930.939453125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.060430631041526794,
        -0.9956679344177246,
        0.07066542655229568
      ],
      "plane_d": -3147.843994140625,
      "bbox_min": [
        -1320.0,
        -3103.500244140625,
        824.4576416015625
      ],
      "bbox_max": [
        -755.7307739257812,
        -2930.939453125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35227170586586,
        -0.9041997790336609,
        0.2415105253458023
      ],
      "plane_d": -2671.578125,
      "bbox_min": [
        -1026.85400390625,
        -3015.748291015625,
        995.3905029296875
      ],
      "bbox_max": [
        -755.7307739257812,
        -2930.939453125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9639432430267334,
        0.2661080062389374
      ],
      "plane_d": -3171.8916015625,
      "bbox_min": [
        -839.289306640625,
        -3015.748291015625,
        995.3905029296875
      ],
      "bbox_max": [
        -755.7307739257812,
        -2930.939453125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8007402420043945,
        -0.5945212841033936,
        0.073208749294281
      ],
      "plane_d": -2958.124267578125,
      "bbox_min": [
        -1320.0,
        -3103.500244140625,
        824.4576416015625
      ],
      "bbox_max": [
        -1314.5830078125,
        -3095.1962890625,
        833.0553588867188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12456259876489639,
        -0.9855428338050842,
        0.11484554409980774
      ],
      "plane_d": -2984.98828125,
      "bbox_min": [
        -1314.6207275390625,
        -3350.7841796875,
        715.0380249023438
      ],
      "bbox_max": [
        -833.4789428710938,
        -3006.767333984375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.060430631041526794,
        -0.9956679344177246,
        0.07066542655229568
      ],
      "plane_d": -3147.843994140625,
      "bbox_min": [
        -1026.85400390625,
        -3044.44287109375,
        860.7633056640625
      ],
      "bbox_max": [
        -833.4789428710938,
        -3006.767333984375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35227170586586,
        -0.9041997790336609,
        0.2415105253458023
      ],
      "plane_d": -2671.578125,
      "bbox_min": [
        -1026.85400390625,
        -3021.219970703125,
        975.822998046875
      ],
      "bbox_max": [
        -833.4789428710938,
        -3006.767333984375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.060430631041526794,
        -0.9956679344177246,
        0.07066542655229568
      ],
      "plane_d": -3147.843994140625,
      "bbox_min": [
        -1314.6207275390625,
        -3350.7841796875,
        715.0380249023438
      ],
      "bbox_max": [
        -839.9186401367188,
        -3006.767333984375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35227170586586,
        -0.9041997790336609,
        0.2415105253458023
      ],
      "plane_d": -2671.578125,
      "bbox_min": [
        -1026.85400390625,
        -3029.375244140625,
        956.3824462890625
      ],
      "bbox_max": [
        -839.9186401367188,
        -3006.767333984375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8007402420043945,
        -0.5945212841033936,
        0.073208749294281
      ],
      "plane_d": -2958.124267578125,
      "bbox_min": [
        -1314.6207275390625,
        -3350.7841796875,
        715.0380249023438
      ],
      "bbox_max": [
        -1126.0,
        -3102.52880859375,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -912.0,
      "bbox_min": [
        -1146.5478515625,
        -3319.810546875,
        860.0
      ],
      "bbox_max": [
        -1126.0,
        -3314.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9138116240501404,
        -0.0,
        -0.40613850951194763
      ],
      "plane_d": -697.9490356445312,
      "bbox_min": [
        -1146.5478515625,
        -3315.25146484375,
        860.0
      ],
      "bbox_max": [
        -1146.0,
        -3314.0,
        861.2327880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9845805764198303,
        -0.14805786311626434,
        0.09316641837358475
      ],
      "plane_d": -1703.1788330078125,
      "bbox_min": [
        -1162.702392578125,
        -3350.7841796875,
        715.0380249023438
      ],
      "bbox_max": [
        -1152.318115234375,
        -3321.587646484375,
        823.8451538085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7215278148651123,
        -0.4943443834781647,
        0.48478996753692627
      ],
      "plane_d": -2886.926513671875,
      "bbox_min": [
        -1320.0,
        -3357.557373046875,
        747.0778198242188
      ],
      "bbox_max": [
        -1126.0,
        -3033.836669921875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8007402420043945,
        -0.5945212841033936,
        0.073208749294281
      ],
      "plane_d": -2958.124267578125,
      "bbox_min": [
        -1320.0,
        -3357.557373046875,
        747.0778198242188
      ],
      "bbox_max": [
        -1135.1934814453125,
        -3095.03369140625,
        877.9901123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3322.0,
      "bbox_min": [
        -1148.6920166015625,
        -3322.0,
        860.0
      ],
      "bbox_max": [
        -1135.1934814453125,
        -3314.0,
        877.9901123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9138116240501404,
        -0.0,
        -0.40613850951194763
      ],
      "plane_d": -697.9490356445312,
      "bbox_min": [
        -1148.6920166015625,
        -3322.0,
        860.0
      ],
      "bbox_max": [
        -1146.0,
        -3314.0,
        866.0571899414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9845805764198303,
        -0.14805786311626434,
        0.09316641837358475
      ],
      "plane_d": -1703.1788330078125,
      "bbox_min": [
        -1155.2801513671875,
        -3357.557373046875,
        747.0778198242188
      ],
      "bbox_max": [
        -1147.3780517578125,
        -3322.175537109375,
        856.8275146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43772801756858826,
        -0.8991074562072754,
        0.0
      ],
      "plane_d": -2195.2607421875,
      "bbox_min": [
        -1320.0,
        -3350.929931640625,
        830.355224609375
      ],
      "bbox_max": [
        -1126.0,
        -3033.836669921875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.950871467590332,
        0.0,
        0.3095860481262207
      ],
      "plane_d": -1362.532470703125,
      "bbox_min": [
        -1150.0,
        -3350.929931640625,
        830.355224609375
      ],
      "bbox_max": [
        -1126.0,
        -3314.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3322.0,
      "bbox_min": [
        -1150.0,
        -3350.929931640625,
        830.355224609375
      ],
      "bbox_max": [
        -1126.0,
        -3314.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9138116240501404,
        -0.0,
        -0.40613850951194763
      ],
      "plane_d": -697.9490356445312,
      "bbox_min": [
        -1150.0,
        -3322.0,
        861.1472778320312
      ],
      "bbox_max": [
        -1146.5098876953125,
        -3314.0,
        869.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9533829092979431,
        -0.23182019591331482,
        0.1931847333908081
      ],
      "plane_d": -2031.31396484375,
      "bbox_min": [
        -1149.1702880859375,
        -3350.929931640625,
        830.355224609375
      ],
      "bbox_max": [
        -1134.300048828125,
        -3322.353759765625,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9845805764198303,
        -0.14805786311626434,
        0.09316641837358475
      ],
      "plane_d": -1703.1788330078125,
      "bbox_min": [
        -1149.1702880859375,
        -3350.929931640625,
        830.355224609375
      ],
      "bbox_max": [
        -1134.300048828125,
        -3322.353759765625,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8208402991294861,
        1.7694263831913304e-08,
        0.5711577534675598
      ],
      "plane_d": -1432.6689453125,
      "bbox_min": [
        -1149.1702880859375,
        -3344.6494140625,
        856.8275146484375
      ],
      "bbox_max": [
        -1134.300048828125,
        -3322.353759765625,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4566386640071869,
        0.6905266642570496,
        0.5609403848648071
      ],
      "plane_d": 1281.354736328125,
      "bbox_min": [
        -1153.5582275390625,
        -3503.1201171875,
        663.99609375
      ],
      "bbox_max": [
        -513.5322265625,
        -2930.939453125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5389724969863892,
        0.6360949873924255,
        0.5521700382232666
      ],
      "plane_d": 1050.81884765625,
      "bbox_min": [
        -1153.5582275390625,
        -3503.1201171875,
        663.99609375
      ],
      "bbox_max": [
        -704.468994140625,
        -3090.42138671875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9792153239250183,
        -0.19332727789878845,
        0.061334479600191116
      ],
      "plane_d": -1825.3980712890625,
      "bbox_min": [
        -1153.5582275390625,
        -3503.1201171875,
        663.99609375
      ],
      "bbox_max": [
        -1111.09814453125,
        -3349.96435546875,
        1029.9256591796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9931049346923828,
        0.0022958379704505205,
        0.11720679700374603
      ],
      "plane_d": -1221.6827392578125,
      "bbox_min": [
        -1153.5582275390625,
        -3441.16357421875,
        754.5106811523438
      ],
      "bbox_max": [
        -1124.3956298828125,
        -3349.96435546875,
        963.597900390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3374.0,
      "bbox_min": [
        -1136.467041015625,
        -3374.0,
        860.0
      ],
      "bbox_max": [
        -1126.0,
        -3366.0,
        884.6598510742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3366.0,
      "bbox_min": [
        -1136.448486328125,
        -3366.0,
        860.0
      ],
      "bbox_max": [
        -1126.0,
        -3366.0,
        875.4437255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9845805764198303,
        -0.14805786311626434,
        0.09316641837358475
      ],
      "plane_d": -1703.1788330078125,
      "bbox_min": [
        -1153.5582275390625,
        -3394.3984375,
        754.5106811523438
      ],
      "bbox_max": [
        -1134.5406494140625,
        -3349.96435546875,
        876.3234252929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9533829092979431,
        -0.23182019591331482,
        0.1931847333908081
      ],
      "plane_d": -2031.31396484375,
      "bbox_min": [
        -1147.20849609375,
        -3394.3984375,
        794.9396362304688
      ],
      "bbox_max": [
        -1134.5406494140625,
        -3349.96435546875,
        876.3234252929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3366.0,
      "bbox_min": [
        -1137.91455078125,
        -3366.0,
        860.0
      ],
      "bbox_max": [
        -1135.7489013671875,
        -3366.0,
        865.9278564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3374.0,
      "bbox_min": [
        -1141.822021484375,
        -3374.0,
        860.0
      ],
      "bbox_max": [
        -1134.5406494140625,
        -3366.0,
        876.3234252929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3366.0,
      "bbox_min": [
        -1141.822021484375,
        -3366.0,
        860.0
      ],
      "bbox_max": [
        -1136.951171875,
        -3366.0,
        864.7543334960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3374.0,
      "bbox_min": [
        -1144.144775390625,
        -3374.0,
        860.0
      ],
      "bbox_max": [
        -1140.0697021484375,
        -3374.0,
        870.926513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3374.0,
      "bbox_min": [
        -1147.5926513671875,
        -3374.0,
        860.0
      ],
      "bbox_max": [
        -1143.6812744140625,
        -3374.0,
        867.4013061523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2074883133172989,
        0.8826481699943542,
        0.42175933718681335
      ],
      "plane_d": 2287.469970703125,
      "bbox_min": [
        -1150.0,
        -3487.473388671875,
        836.982666015625
      ],
      "bbox_max": [
        -704.468994140625,
        -3231.95166015625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9931049346923828,
        0.0022958379704505205,
        0.11720679700374603
      ],
      "plane_d": -1221.6827392578125,
      "bbox_min": [
        -1148.5718994140625,
        -3487.473388671875,
        860.090576171875
      ],
      "bbox_max": [
        -1107.0994873046875,
        -3363.30712890625,
        1103.709716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9792153239250183,
        -0.19332727789878845,
        0.061334479600191116
      ],
      "plane_d": -1825.3980712890625,
      "bbox_min": [
        -1135.7489013671875,
        -3487.473388671875,
        865.9278564453125
      ],
      "bbox_max": [
        -1107.0994873046875,
        -3366.0,
        1103.709716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3374.0,
      "bbox_min": [
        -1135.7489013671875,
        -3374.0,
        865.9278564453125
      ],
      "bbox_max": [
        -1126.0,
        -3366.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -912.0,
      "bbox_min": [
        -1130.330078125,
        -3374.0,
        912.0
      ],
      "bbox_max": [
        -1126.0,
        -3369.84814453125,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9945406317710876,
        -0.05085870251059532,
        0.09111718833446503
      ],
      "plane_d": -1379.3016357421875,
      "bbox_min": [
        -1148.5718994140625,
        -3461.161865234375,
        860.090576171875
      ],
      "bbox_max": [
        -1111.71337890625,
        -3363.30712890625,
        1071.44775390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3374.0,
      "bbox_min": [
        -1134.22900390625,
        -3374.0,
        878.8062744140625
      ],
      "bbox_max": [
        -1130.3292236328125,
        -3366.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3366.0,
      "bbox_min": [
        -1134.22900390625,
        -3374.0,
        878.8062744140625
      ],
      "bbox_max": [
        -1130.3292236328125,
        -3366.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3374.0,
      "bbox_min": [
        -1148.5718994140625,
        -3374.0,
        860.090576171875
      ],
      "bbox_max": [
        -1130.78955078125,
        -3363.30712890625,
        911.8827514648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9533829092979431,
        -0.23182019591331482,
        0.1931847333908081
      ],
      "plane_d": -2031.31396484375,
      "bbox_min": [
        -1136.9512939453125,
        -3368.7138671875,
        864.7543334960938
      ],
      "bbox_max": [
        -1134.4034423828125,
        -3366.0,
        877.3278198242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9533829092979431,
        -0.23182019591331482,
        0.1931847333908081
      ],
      "plane_d": -2031.31396484375,
      "bbox_min": [
        -1138.5511474609375,
        -3366.0,
        860.090576171875
      ],
      "bbox_max": [
        -1134.300048828125,
        -3363.30712890625,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3374.0,
      "bbox_min": [
        -1150.0,
        -3374.0,
        836.982666015625
      ],
      "bbox_max": [
        -1126.0,
        -3336.9052734375,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3366.0,
      "bbox_min": [
        -1150.0,
        -3374.0,
        836.982666015625
      ],
      "bbox_max": [
        -1126.0,
        -3336.9052734375,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -912.0,
      "bbox_min": [
        -1136.0,
        -3374.0,
        912.0
      ],
      "bbox_max": [
        -1126.0,
        -3366.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9533829092979431,
        -0.23182019591331482,
        0.1931847333908081
      ],
      "plane_d": -2031.31396484375,
      "bbox_min": [
        -1146.477783203125,
        -3365.699951171875,
        836.982666015625
      ],
      "bbox_max": [
        -1134.300048828125,
        -3336.9052734375,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8208402991294861,
        1.7694263831913304e-08,
        0.5711577534675598
      ],
      "plane_d": -1432.6689453125,
      "bbox_min": [
        -1141.5216064453125,
        -3365.699951171875,
        867.8198852539062
      ],
      "bbox_max": [
        -1134.300048828125,
        -3336.9052734375,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7552521228790283,
        -0.561424732208252,
        0.3382256329059601
      ],
      "plane_d": -2654.937744140625,
      "bbox_min": [
        -1124.53173828125,
        -3484.318359375,
        831.763671875
      ],
      "bbox_max": [
        -513.5322265625,
        -2930.939453125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7832221984863281,
        -0.4408717155456543,
        0.43840065598487854
      ],
      "plane_d": -2407.586669921875,
      "bbox_min": [
        -840.498779296875,
        -3253.36376953125,
        942.820068359375
      ],
      "bbox_max": [
        -513.5322265625,
        -2930.939453125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9639432430267334,
        0.2661080062389374
      ],
      "plane_d": -3171.8916015625,
      "bbox_min": [
        -840.498779296875,
        -3030.260986328125,
        942.820068359375
      ],
      "bbox_max": [
        -695.023193359375,
        -2930.939453125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2074883133172989,
        0.8826481699943542,
        0.42175933718681335
      ],
      "plane_d": 2287.469970703125,
      "bbox_min": [
        -1124.53173828125,
        -3484.318359375,
        918.49560546875
      ],
      "bbox_max": [
        -704.468994140625,
        -2930.939453125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9945406317710876,
        -0.05085870251059532,
        0.09111718833446503
      ],
      "plane_d": -1379.3016357421875,
      "bbox_min": [
        -1124.53173828125,
        -3484.318359375,
        971.9285278320312
      ],
      "bbox_max": [
        -1090.06982421875,
        -3388.795166015625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9792153239250183,
        -0.19332727789878845,
        0.061334479600191116
      ],
      "plane_d": -1825.3980712890625,
      "bbox_min": [
        -1108.4205322265625,
        -3484.318359375,
        1097.0123291015625
      ],
      "bbox_max": [
        -1106.3704833984375,
        -3479.75146484375,
        1117.1605224609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9931049346923828,
        0.0022958379704505205,
        0.11720679700374603
      ],
      "plane_d": -1221.6827392578125,
      "bbox_min": [
        -1111.7132568359375,
        -3483.7431640625,
        1071.4483642578125
      ],
      "bbox_max": [
        -1106.3704833984375,
        -3461.162109375,
        1117.1605224609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9792153239250183,
        -0.19332727789878845,
        0.061334479600191116
      ],
      "plane_d": -1825.3980712890625,
      "bbox_min": [
        -1109.1981201171875,
        -3483.7431640625,
        1093.070556640625
      ],
      "bbox_max": [
        -1106.3704833984375,
        -3477.0634765625,
        1117.1605224609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9639432430267334,
        0.2661080062389374
      ],
      "plane_d": -3171.8916015625,
      "bbox_min": [
        -850.43994140625,
        -3032.502685546875,
        931.3502197265625
      ],
      "bbox_max": [
        -753.2093505859375,
        -2930.939453125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09297493100166321,
        -0.989263117313385,
        0.11275718361139297
      ],
      "plane_d": -3025.889892578125,
      "bbox_min": [
        -850.43994140625,
        -3032.502685546875,
        931.3502197265625
      ],
      "bbox_max": [
        -840.498779296875,
        -3030.260986328125,
        942.820068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35227170586586,
        -0.9041997790336609,
        0.2415105253458023
      ],
      "plane_d": -2671.578125,
      "bbox_min": [
        -849.7271118164062,
        -3031.73828125,
        937.4691772460938
      ],
      "bbox_max": [
        -839.728271484375,
        -3021.015869140625,
        976.3096313476562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09297493100166321,
        -0.989263117313385,
        0.11275718361139297
      ],
      "plane_d": -3025.889892578125,
      "bbox_min": [
        -849.7271118164062,
        -3031.73828125,
        937.4691772460938
      ],
      "bbox_max": [
        -840.498779296875,
        -3029.375244140625,
        956.3824462890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34272027015686035,
        0.9365004897117615,
        0.07422665506601334
      ],
      "plane_d": 2554.111572265625,
      "bbox_min": [
        -1888.3092041015625,
        -3571.833740234375,
        860.0
      ],
      "bbox_max": [
        -1332.0,
        -3323.0,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7289522290229797,
        0.6049720644950867,
        0.3203705847263336
      ],
      "plane_d": 411.9771423339844,
      "bbox_min": [
        -1857.6021728515625,
        -3571.833740234375,
        860.0
      ],
      "bbox_max": [
        -1332.0,
        -3323.0,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01903552934527397,
        0.9815307855606079,
        -0.19035546481609344
      ],
      "plane_d": 3524.079833984375,
      "bbox_min": [
        -1664.755859375,
        -3419.54296875,
        860.0
      ],
      "bbox_max": [
        -1332.0,
        -3323.0,
        1201.0750732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.038227956742048264,
        0.9232555031776428,
        0.3822798430919647
      ],
      "plane_d": 2820.343505859375,
      "bbox_min": [
        -1664.755859375,
        -3419.54296875,
        860.0
      ],
      "bbox_max": [
        -1332.0,
        -3363.79541015625,
        1047.4222412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1401.5,
      "bbox_min": [
        -1405.0,
        -3410.0,
        860.0
      ],
      "bbox_max": [
        -1332.0,
        -3366.0,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -894.0,
      "bbox_min": [
        -1401.5,
        -3410.0,
        860.0
      ],
      "bbox_max": [
        -1332.0,
        -3366.0,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3374.0,
      "bbox_min": [
        -1401.5,
        -3374.0,
        860.0
      ],
      "bbox_max": [
        -1332.0,
        -3366.0,
        887.4653930664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3368.0,
      "bbox_min": [
        -1401.5,
        -3374.0,
        860.0
      ],
      "bbox_max": [
        -1332.0,
        -3366.0,
        887.4653930664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1356.0,
      "bbox_min": [
        -1356.0,
        -3374.0,
        860.0
      ],
      "bbox_max": [
        -1356.0,
        -3368.0,
        887.4653930664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3366.0,
      "bbox_min": [
        -1356.0,
        -3368.0,
        860.0
      ],
      "bbox_max": [
        -1332.0,
        -3366.0,
        878.4959716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1356.0,
      "bbox_min": [
        -1356.0,
        -3368.0,
        860.0
      ],
      "bbox_max": [
        -1356.0,
        -3366.0,
        878.4959716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -918.5,
      "bbox_min": [
        -1401.5,
        -3410.0,
        915.0
      ],
      "bbox_max": [
        -1377.0,
        -3396.897216796875,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6585046052932739,
        0.0,
        0.7525767087936401
      ],
      "plane_d": -1611.501953125,
      "bbox_min": [
        -1401.5,
        -3410.0,
        915.0
      ],
      "bbox_max": [
        -1397.5,
        -3396.897216796875,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -894.0,
      "bbox_min": [
        -1405.0,
        -3410.0,
        870.0
      ],
      "bbox_max": [
        -1401.5,
        -3368.0,
        894.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3368.0,
      "bbox_min": [
        -1405.0,
        -3368.0,
        870.0
      ],
      "bbox_max": [
        -1401.5,
        -3368.0,
        884.3972778320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -894.0,
      "bbox_min": [
        -1405.0,
        -3401.7392578125,
        882.9113159179688
      ],
      "bbox_max": [
        -1337.604248046875,
        -3368.0,
        918.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3374.0,
      "bbox_min": [
        -1405.0,
        -3376.997314453125,
        882.9113159179688
      ],
      "bbox_max": [
        -1337.604248046875,
        -3368.0,
        894.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3368.0,
      "bbox_min": [
        -1405.0,
        -3374.0,
        882.9113159179688
      ],
      "bbox_max": [
        -1356.0,
        -3368.0,
        894.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1405.0,
      "bbox_min": [
        -1405.0,
        -3376.997314453125,
        890.801025390625
      ],
      "bbox_max": [
        -1405.0,
        -3374.0,
        894.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -918.5,
      "bbox_min": [
        -1401.5,
        -3401.7392578125,
        894.0
      ],
      "bbox_max": [
        -1373.0,
        -3374.5,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1401.5,
      "bbox_min": [
        -1401.5,
        -3400.431640625,
        894.0
      ],
      "bbox_max": [
        -1373.0,
        -3374.5,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6585046052932739,
        0.0,
        0.7525767087936401
      ],
      "plane_d": -1611.501953125,
      "bbox_min": [
        -1401.5,
        -3400.431640625,
        894.0
      ],
      "bbox_max": [
        -1373.0,
        -3374.5,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3374.5,
      "bbox_min": [
        -1401.5,
        -3374.5,
        894.0
      ],
      "bbox_max": [
        -1373.0,
        -3374.5,
        901.523681640625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.04649339243769646,
        0.7289394736289978,
        0.682997465133667
      ],
      "plane_d": 1916.3502197265625,
      "bbox_min": [
        -1551.188720703125,
        -3382.529541015625,
        860.0
      ],
      "bbox_max": [
        -1332.0,
        -3323.0,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3368.0,
      "bbox_min": [
        -1390.6510009765625,
        -3369.733154296875,
        873.400146484375
      ],
      "bbox_max": [
        -1356.0,
        -3366.0,
        883.42041015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05163498595356941,
        -0.004590269178152084,
        0.9986554980278015
      ],
      "plane_d": -822.7598266601562,
      "bbox_min": [
        -1551.188720703125,
        -3382.529541015625,
        860.0
      ],
      "bbox_max": [
        -1332.0,
        -3323.0,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05333402752876282,
        0.0,
        0.9985767602920532
      ],
      "plane_d": -804.9474487304688,
      "bbox_min": [
        -1430.7042236328125,
        -3365.699951171875,
        860.0
      ],
      "bbox_max": [
        -1332.0,
        -3323.0,
        882.5087280273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3323.0,
      "bbox_min": [
        -1343.357177734375,
        -3323.0,
        860.0
      ],
      "bbox_max": [
        -1332.0,
        -3323.0,
        877.843505859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3323.0,
      "bbox_min": [
        -1343.357177734375,
        -3323.0,
        877.3826293945312
      ],
      "bbox_max": [
        -1334.729248046875,
        -3323.0,
        878.0511474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22641703486442566,
        -0.020128117874264717,
        0.9738224148750305
      ],
      "plane_d": -595.3028564453125,
      "bbox_min": [
        -1551.188720703125,
        -3382.529541015625,
        877.4814453125
      ],
      "bbox_max": [
        -1334.7613525390625,
        -3323.0,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -894.0,
      "bbox_min": [
        -1405.0,
        -3382.529541015625,
        878.9274291992188
      ],
      "bbox_max": [
        -1339.2958984375,
        -3366.0,
        918.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3368.0,
      "bbox_min": [
        -1405.0,
        -3374.0,
        878.9274291992188
      ],
      "bbox_max": [
        -1339.2958984375,
        -3366.0,
        894.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1356.0,
      "bbox_min": [
        -1405.0,
        -3374.0,
        881.0618896484375
      ],
      "bbox_max": [
        -1356.0,
        -3368.0,
        894.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1405.0,
      "bbox_min": [
        -1405.0,
        -3371.351806640625,
        885.4597778320312
      ],
      "bbox_max": [
        -1405.0,
        -3368.0,
        894.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1356.0,
      "bbox_min": [
        -1356.0,
        -3368.0,
        878.9274291992188
      ],
      "bbox_max": [
        -1356.0,
        -3366.0,
        894.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3374.5,
      "bbox_min": [
        -1401.5,
        -3382.529541015625,
        894.0
      ],
      "bbox_max": [
        -1340.1395263671875,
        -3366.0,
        918.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -918.5,
      "bbox_min": [
        -1401.5,
        -3382.529541015625,
        901.523681640625
      ],
      "bbox_max": [
        -1377.0,
        -3374.5,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1401.5,
      "bbox_min": [
        -1401.5,
        -3381.385986328125,
        901.523681640625
      ],
      "bbox_max": [
        -1397.5,
        -3374.5,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6585046052932739,
        0.0,
        0.7525767087936401
      ],
      "plane_d": -1611.501953125,
      "bbox_min": [
        -1401.5,
        -3381.385986328125,
        915.0
      ],
      "bbox_max": [
        -1397.5,
        -3374.5,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3374.0,
      "bbox_min": [
        -1356.0,
        -3374.0,
        894.0
      ],
      "bbox_max": [
        -1340.1395263671875,
        -3366.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1356.0,
      "bbox_min": [
        -1356.0,
        -3374.0,
        894.0
      ],
      "bbox_max": [
        -1346.0,
        -3366.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -912.0,
      "bbox_min": [
        -1356.0,
        -3374.0,
        912.0
      ],
      "bbox_max": [
        -1346.0,
        -3366.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3323.0,
      "bbox_min": [
        -1343.357177734375,
        -3323.0,
        877.60888671875
      ],
      "bbox_max": [
        -1334.8028564453125,
        -3323.0,
        903.8826904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.056889183819293976,
        0.9831775426864624,
        -0.17356735467910767
      ],
      "plane_d": 3449.109619140625,
      "bbox_min": [
        -1888.3092041015625,
        -3492.940185546875,
        889.9683837890625
      ],
      "bbox_max": [
        -1495.9229736328125,
        -3345.277587890625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9661343693733215,
        0.24907872080802917,
        0.0674104243516922
      ],
      "plane_d": -827.2496337890625,
      "bbox_min": [
        -1876.72509765625,
        -3492.940185546875,
        1019.8193969726562
      ],
      "bbox_max": [
        -1543.630859375,
        -3371.47021484375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01903552934527397,
        0.9815307855606079,
        -0.19035546481609344
      ],
      "plane_d": 3524.079833984375,
      "bbox_min": [
        -1664.755859375,
        -3419.54296875,
        1047.4222412109375
      ],
      "bbox_max": [
        -1543.630859375,
        -3371.47021484375,
        1284.5732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14676129817962646,
        0.7160802483558655,
        0.6824150681495667
      ],
      "plane_d": 1489.5687255859375,
      "bbox_min": [
        -1876.72509765625,
        -3492.940185546875,
        1019.8193969726562
      ],
      "bbox_max": [
        -1664.755859375,
        -3419.54296875,
        1082.962646484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.043616753071546555,
        0.9218221306800842,
        0.38515132665634155
      ],
      "plane_d": 2676.18310546875,
      "bbox_min": [
        -1888.3092041015625,
        -3436.68115234375,
        889.9683837890625
      ],
      "bbox_max": [
        -1495.9229736328125,
        -3345.277587890625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14676129817962646,
        0.7160802483558655,
        0.6824150681495667
      ],
      "plane_d": 1489.5687255859375,
      "bbox_min": [
        -1888.2955322265625,
        -3436.68115234375,
        890.4221801757812
      ],
      "bbox_max": [
        -1497.943603515625,
        -3346.052978515625,
        1047.4222412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22641703486442566,
        -0.020128117874264717,
        0.9738224148750305
      ],
      "plane_d": -595.3028564453125,
      "bbox_min": [
        -1669.7366943359375,
        -3419.54296875,
        890.4221801757812
      ],
      "bbox_max": [
        -1497.943603515625,
        -3346.052978515625,
        1047.4222412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.038227956742048264,
        0.9232555031776428,
        0.3822798430919647
      ],
      "plane_d": 2820.343505859375,
      "bbox_min": [
        -1669.7366943359375,
        -3419.54296875,
        902.3794555664062
      ],
      "bbox_max": [
        -1551.188720703125,
        -3366.486328125,
        1047.4222412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05185391753911972,
        0.9296181201934814,
        0.36485806107521057
      ],
      "plane_d": 2880.741455078125,
      "bbox_min": [
        -1669.7366943359375,
        -3391.488037109375,
        902.3794555664062
      ],
      "bbox_max": [
        -1551.188720703125,
        -3366.486328125,
        973.598388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22641703486442566,
        -0.020128117874264717,
        0.9738224148750305
      ],
      "plane_d": -595.3028564453125,
      "bbox_min": [
        -1669.7366943359375,
        -3371.47021484375,
        889.9683837890625
      ],
      "bbox_max": [
        -1495.9229736328125,
        -3345.277587890625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39672571420669556,
        0.18136583268642426,
        -0.8998417854309082
      ],
      "plane_d": 1149.486572265625,
      "bbox_min": [
        -1597.9923095703125,
        -3371.47021484375,
        1284.5732421875
      ],
      "bbox_max": [
        -1557.488037109375,
        -3354.725341796875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0412130132317543,
        0.43465206027030945,
        -0.8996549844741821
      ],
      "plane_d": 2685.27783203125,
      "bbox_min": [
        -1566.66552734375,
        -3371.47021484375,
        1284.5732421875
      ],
      "bbox_max": [
        -1557.488037109375,
        -3354.725341796875,
        1292.5194091796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3377978503704071,
        -0.8362663984298706,
        0.4319157302379608
      ],
      "plane_d": -2702.277587890625,
      "bbox_min": [
        -1925.1641845703125,
        -3402.573486328125,
        828.3320922851562
      ],
      "bbox_max": [
        -1320.0,
        -3082.269287109375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11021039634943008,
        -0.9280050992965698,
        0.3558935821056366
      ],
      "plane_d": -3234.49072265625,
      "bbox_min": [
        -1925.1641845703125,
        -3402.573486328125,
        828.3320922851562
      ],
      "bbox_max": [
        -1320.0,
        -3082.269287109375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1012493446469307,
        -0.9274534583091736,
        0.35997048020362854
      ],
      "plane_d": -3251.482177734375,
      "bbox_min": [
        -1700.1717529296875,
        -3328.10009765625,
        828.3320922851562
      ],
      "bbox_max": [
        -1320.0,
        -3082.269287109375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43772801756858826,
        -0.8991074562072754,
        0.0
      ],
      "plane_d": -2195.2607421875,
      "bbox_min": [
        -1465.0,
        -3316.6494140625,
        828.3320922851562
      ],
      "bbox_max": [
        -1320.0,
        -3082.269287109375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7746099233627319,
        -0.5822634696960449,
        0.2468777596950531
      ],
      "plane_d": -3030.36767578125,
      "bbox_min": [
        -1327.09716796875,
        -3087.16064453125,
        832.6555786132812
      ],
      "bbox_max": [
        -1320.0,
        -3082.269287109375,
        863.54296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8007402420043945,
        -0.5945212841033936,
        0.073208749294281
      ],
      "plane_d": -2958.124267578125,
      "bbox_min": [
        -1327.09716796875,
        -3087.16064453125,
        832.6555786132812
      ],
      "bbox_max": [
        -1325.9539794921875,
        -3085.589599609375,
        833.44384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7215278148651123,
        -0.4943443834781647,
        0.48478996753692627
      ],
      "plane_d": -2886.926513671875,
      "bbox_min": [
        -1327.09716796875,
        -3087.136962890625,
        833.382080078125
      ],
      "bbox_max": [
        -1325.873046875,
        -3085.589599609375,
        833.7279663085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8007402420043945,
        -0.5945212841033936,
        0.073208749294281
      ],
      "plane_d": -2958.124267578125,
      "bbox_min": [
        -1327.09716796875,
        -3087.136962890625,
        833.382080078125
      ],
      "bbox_max": [
        -1325.9395751953125,
        -3085.589599609375,
        833.5960083007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.136230432370212e-05,
        0.0,
        1.0
      ],
      "plane_d": -929.9793701171875,
      "bbox_min": [
        -1465.0,
        -3316.6494140625,
        828.3320922851562
      ],
      "bbox_max": [
        -1320.0,
        -3084.238525390625,
        945.0027465820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7746099233627319,
        -0.5822634696960449,
        0.2468777596950531
      ],
      "plane_d": -3030.36767578125,
      "bbox_min": [
        -1445.0,
        -3316.6494140625,
        828.3320922851562
      ],
      "bbox_max": [
        -1320.0,
        -3084.238525390625,
        930.01025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8007402420043945,
        -0.5945212841033936,
        0.073208749294281
      ],
      "plane_d": -2958.124267578125,
      "bbox_min": [
        -1326.0028076171875,
        -3095.778076171875,
        828.3320922851562
      ],
      "bbox_max": [
        -1320.0,
        -3087.136962890625,
        833.382080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1445.0,
      "bbox_min": [
        -1445.0,
        -3316.6494140625,
        833.0553588867188
      ],
      "bbox_max": [
        -1320.0,
        -3087.09765625,
        930.01025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8007402420043945,
        -0.5945212841033936,
        0.073208749294281
      ],
      "plane_d": -2958.124267578125,
      "bbox_min": [
        -1356.0,
        -3316.6494140625,
        833.0553588867188
      ],
      "bbox_max": [
        -1320.0,
        -3087.09765625,
        864.3011474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7215278148651123,
        -0.4943443834781647,
        0.48478996753692627
      ],
      "plane_d": -2886.926513671875,
      "bbox_min": [
        -1325.9395751953125,
        -3095.03369140625,
        833.5960083007812
      ],
      "bbox_max": [
        -1320.0,
        -3087.09765625,
        835.09130859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1356.0,
      "bbox_min": [
        -1356.0,
        -3316.6494140625,
        860.0
      ],
      "bbox_max": [
        -1356.0,
        -3315.0,
        864.3011474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1445.0,
      "bbox_min": [
        -1445.0,
        -3300.369873046875,
        930.01025390625
      ],
      "bbox_max": [
        -1445.0,
        -3285.0,
        945.0027465820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21603241562843323,
        -0.9093504548072815,
        0.35554423928260803
      ],
      "plane_d": -2994.511962890625,
      "bbox_min": [
        -1700.1717529296875,
        -3328.10009765625,
        929.8560791015625
      ],
      "bbox_max": [
        -1678.0,
        -3184.333984375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24250808358192444,
        -0.909406840801239,
        0.3378889858722687
      ],
      "plane_d": -2927.0478515625,
      "bbox_min": [
        -1700.1717529296875,
        -3195.748291015625,
        1281.8350830078125
      ],
      "bbox_max": [
        -1686.3004150390625,
        -3184.333984375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21603241562843323,
        -0.9093504548072815,
        0.35554423928260803
      ],
      "plane_d": -2994.511962890625,
      "bbox_min": [
        -1925.1641845703125,
        -3402.573486328125,
        860.0
      ],
      "bbox_max": [
        -1343.357177734375,
        -3163.810791015625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.001288205268792808,
        -0.936079740524292,
        0.3517853915691376
      ],
      "plane_d": -3417.884521484375,
      "bbox_min": [
        -1900.942626953125,
        -3402.573486328125,
        860.0
      ],
      "bbox_max": [
        -1343.357177734375,
        -3163.810791015625,
        1302.5999755859375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1356.0,
      "bbox_min": [
        -1465.0,
        -3323.0,
        860.0
      ],
      "bbox_max": [
        -1343.357177734375,
        -3294.620361328125,
        945.0027465820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3323.0,
      "bbox_min": [
        -1356.0,
        -3323.0,
        860.0
      ],
      "bbox_max": [
        -1343.357177734375,
        -3323.0,
        878.4855346679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.136230432370212e-05,
        0.0,
        1.0
      ],
      "plane_d": -929.9793701171875,
      "bbox_min": [
        -1465.0,
        -3303.789306640625,
        930.0027465820312
      ],
      "bbox_max": [
        -1445.0,
        -3294.620361328125,
        945.0027465820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1445.0,
      "bbox_min": [
        -1445.0,
        -3303.761962890625,
        930.0027465820312
      ],
      "bbox_max": [
        -1445.0,
        -3300.369873046875,
        930.01025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1445.0,
      "bbox_min": [
        -1445.0,
        -3303.759033203125,
        930.01025390625
      ],
      "bbox_max": [
        -1445.0,
        -3294.620361328125,
        945.0027465820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21186989545822144,
        0.07687602192163467,
        0.9742696285247803
      ],
      "plane_d": -294.561767578125,
      "bbox_min": [
        -1900.942626953125,
        -3402.573486328125,
        878.1983032226562
      ],
      "bbox_max": [
        -1350.0,
        -3316.654541015625,
        981.4912109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2235765904188156,
        0.04341130331158638,
        0.9737191796302795
      ],
      "plane_d": -385.780029296875,
      "bbox_min": [
        -1888.3245849609375,
        -3402.563232421875,
        884.1797485351562
      ],
      "bbox_max": [
        -1463.448486328125,
        -3325.007568359375,
        981.4669799804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.043616753071546555,
        0.9218221306800842,
        0.38515132665634155
      ],
      "plane_d": 2676.18310546875,
      "bbox_min": [
        -1888.3131103515625,
        -3402.563232421875,
        884.1797485351562
      ],
      "bbox_max": [
        -1463.448486328125,
        -3325.007568359375,
        981.466064453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22641703486442566,
        -0.020128117874264717,
        0.9738224148750305
      ],
      "plane_d": -595.3028564453125,
      "bbox_min": [
        -1678.0,
        -3370.65771484375,
        884.1797485351562
      ],
      "bbox_max": [
        -1463.448486328125,
        -3325.007568359375,
        929.8560791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21167901158332825,
        0.041101183742284775,
        0.9764747023582458
      ],
      "plane_d": -415.9947204589844,
      "bbox_min": [
        -1678.0,
        -3370.65771484375,
        894.0480346679688
      ],
      "bbox_max": [
        -1512.2174072265625,
        -3328.10009765625,
        929.8560791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05163498595356941,
        -0.004590269178152084,
        0.9986554980278015
      ],
      "plane_d": -822.7598266601562,
      "bbox_min": [
        -1472.77197265625,
        -3341.89697265625,
        884.1797485351562
      ],
      "bbox_max": [
        -1463.448486328125,
        -3325.007568359375,
        884.6555786132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21167901158332825,
        0.041101183742284775,
        0.9764747023582458
      ],
      "plane_d": -415.9947204589844,
      "bbox_min": [
        -1888.3131103515625,
        -3402.573486328125,
        878.1983032226562
      ],
      "bbox_max": [
        -1350.0,
        -3316.654541015625,
        981.4912109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05163498595356941,
        -0.004590269178152084,
        0.9986554980278015
      ],
      "plane_d": -822.7598266601562,
      "bbox_min": [
        -1471.2705078125,
        -3332.021484375,
        884.440673828125
      ],
      "bbox_max": [
        -1467.7373046875,
        -3320.83935546875,
        884.6555786132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05333402752876282,
        0.0,
        0.9985767602920532
      ],
      "plane_d": -804.9474487304688,
      "bbox_min": [
        -1888.3131103515625,
        -3402.573486328125,
        878.1983032226562
      ],
      "bbox_max": [
        -1350.0,
        -3316.654541015625,
        981.4912109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05163498595356941,
        -0.004590269178152084,
        0.9986554980278015
      ],
      "plane_d": -822.7598266601562,
      "bbox_min": [
        -1470.9000244140625,
        -3340.53564453125,
        878.4830932617188
      ],
      "bbox_max": [
        -1355.3323974609375,
        -3320.83935546875,
        884.6555786132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1356.0,
      "bbox_min": [
        -1888.3131103515625,
        -3402.573486328125,
        878.4636840820312
      ],
      "bbox_max": [
        -1350.0914306640625,
        -3316.654541015625,
        981.4912109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3323.0,
      "bbox_min": [
        -1356.0,
        -3323.0,
        878.4636840820312
      ],
      "bbox_max": [
        -1350.0914306640625,
        -3323.0,
        883.084716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.043616753071546555,
        0.9218221306800842,
        0.38515132665634155
      ],
      "plane_d": 2676.18310546875,
      "bbox_min": [
        -1888.3131103515625,
        -3402.573486328125,
        980.7196044921875
      ],
      "bbox_max": [
        -1885.0430908203125,
        -3402.0966796875,
        981.4912109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39672571420669556,
        0.18136583268642426,
        -0.8998417854309082
      ],
      "plane_d": 1149.486572265625,
      "bbox_min": [
        -1592.8734130859375,
        -3359.43408203125,
        873.1968994140625
      ],
      "bbox_max": [
        -1343.357177734375,
        -3315.0,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0412130132317543,
        0.43465206027030945,
        -0.8996549844741821
      ],
      "plane_d": 2685.27783203125,
      "bbox_min": [
        -1580.328125,
        -3355.607421875,
        1291.816650390625
      ],
      "bbox_max": [
        -1560.625732421875,
        -3331.9921875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3323.0,
      "bbox_min": [
        -1356.0,
        -3324.52099609375,
        873.1968994140625
      ],
      "bbox_max": [
        -1343.357177734375,
        -3315.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -912.0,
      "bbox_min": [
        -1356.0,
        -3323.0,
        912.0
      ],
      "bbox_max": [
        -1346.0,
        -3315.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05333402752876282,
        0.0,
        0.9985767602920532
      ],
      "plane_d": -804.9474487304688,
      "bbox_min": [
        -1353.774658203125,
        -3324.52099609375,
        878.1983032226562
      ],
      "bbox_max": [
        -1350.0,
        -3323.10009765625,
        878.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8214666247367859,
        -0.2627931237220764,
        0.5060952305793762
      ],
      "plane_d": -1936.05078125,
      "bbox_min": [
        -1320.0,
        -3646.800048828125,
        1302.5999755859375
      ],
      "bbox_max": [
        -342.082275390625,
        -2670.834716796875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6356639862060547,
        -0.35781198740005493,
        0.6840335130691528
      ],
      "plane_d": -2381.548583984375,
      "bbox_min": [
        -1320.0,
        -3646.800048828125,
        1302.5999755859375
      ],
      "bbox_max": [
        -342.082275390625,
        -2670.834716796875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3113660216331482,
        -0.6430392861366272,
        0.6996798515319824
      ],
      "plane_d": -2525.14501953125,
      "bbox_min": [
        -1320.0,
        -3646.800048828125,
        1302.5999755859375
      ],
      "bbox_max": [
        -342.082275390625,
        -2670.834716796875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1512952446937561,
        -0.7088976502418518,
        0.6888933181762695
      ],
      "plane_d": -2873.484375,
      "bbox_min": [
        -1320.0,
        -3084.23828125,
        1302.5999755859375
      ],
      "bbox_max": [
        -1026.85400390625,
        -2802.316162109375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10619720071554184,
        -0.7439054846763611,
        0.6597930788993835
      ],
      "plane_d": -2987.148193359375,
      "bbox_min": [
        -1305.776123046875,
        -3057.69580078125,
        1302.5999755859375
      ],
      "bbox_max": [
        -1026.85400390625,
        -2840.551025390625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34675103425979614,
        -0.7122377753257751,
        0.6103124022483826
      ],
      "plane_d": -2533.99267578125,
      "bbox_min": [
        -1265.480712890625,
        -3057.69580078125,
        1302.5999755859375
      ],
      "bbox_max": [
        -1216.4732666015625,
        -3016.591552734375,
        1341.32421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34675103425979614,
        -0.7122377753257751,
        0.6103124022483826
      ],
      "plane_d": -2533.99267578125,
      "bbox_min": [
        -1320.0,
        -3084.23828125,
        1302.5999755859375
      ],
      "bbox_max": [
        -1249.2091064453125,
        -2979.299072265625,
        1425.064697265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24675478041172028,
        -0.633362352848053,
        0.7334604859352112
      ],
      "plane_d": -2606.39794921875,
      "bbox_min": [
        -1026.85400390625,
        -3646.800048828125,
        1302.5999755859375
      ],
      "bbox_max": [
        -342.082275390625,
        -2670.834716796875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.512399435043335,
        0.7244004011154175,
        0.4611842632293701
      ],
      "plane_d": 1486.495849609375,
      "bbox_min": [
        -873.099365234375,
        -3646.800048828125,
        1302.5999755859375
      ],
      "bbox_max": [
        -342.082275390625,
        -2670.834716796875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3404339551925659,
        0.7671160101890564,
        0.5437257885932922
      ],
      "plane_d": 1612.6265869140625,
      "bbox_min": [
        -704.468994140625,
        -3461.04345703125,
        1302.5999755859375
      ],
      "bbox_max": [
        -342.082275390625,
        -3253.36376953125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4902830421924591,
        0.7414035797119141,
        0.4581957757472992
      ],
      "plane_d": 1563.4337158203125,
      "bbox_min": [
        -704.468994140625,
        -3461.04345703125,
        1302.5999755859375
      ],
      "bbox_max": [
        -513.5322265625,
        -3253.36376953125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09165661036968231,
        -0.6677837371826172,
        0.7386906743049622
      ],
      "plane_d": -2995.730712890625,
      "bbox_min": [
        -855.087646484375,
        -2930.939453125,
        1302.5999755859375
      ],
      "bbox_max": [
        -511.1015625,
        -2670.834716796875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -7.739518537164258e-08,
        -0.6953417062759399,
        0.7186792492866516
      ],
      "plane_d": -2974.156005859375,
      "bbox_min": [
        -832.221435546875,
        -2930.939453125,
        1302.5999755859375
      ],
      "bbox_max": [
        -664.7411499023438,
        -2690.8427734375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4018848240375519,
        -0.6489609479904175,
        0.6460171937942505
      ],
      "plane_d": -3022.886474609375,
      "bbox_min": [
        -709.314697265625,
        -2930.939453125,
        1302.5999755859375
      ],
      "bbox_max": [
        -664.7411499023438,
        -2690.8427734375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4018848240375519,
        -0.6489609479904175,
        0.6460171937942505
      ],
      "plane_d": -3022.886474609375,
      "bbox_min": [
        -709.314697265625,
        -2911.618408203125,
        1340.847412109375
      ],
      "bbox_max": [
        -511.1015625,
        -2690.8427734375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23221024870872498,
        -0.8293224573135376,
        0.5082348585128784
      ],
      "plane_d": -2908.64794921875,
      "bbox_min": [
        -1958.299072265625,
        -3248.03076171875,
        1302.5999755859375
      ],
      "bbox_max": [
        -1320.0,
        -2930.3857421875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34675103425979614,
        -0.7122377753257751,
        0.6103124022483826
      ],
      "plane_d": -2533.99267578125,
      "bbox_min": [
        -1512.1971435546875,
        -3064.385498046875,
        1325.768310546875
      ],
      "bbox_max": [
        -1320.0,
        -2930.3857421875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.41471293568611145,
        -0.6906698942184448,
        0.5924426317214966
      ],
      "plane_d": -2347.342041015625,
      "bbox_min": [
        -1512.1971435546875,
        -3042.404052734375,
        1403.592529296875
      ],
      "bbox_max": [
        -1411.826904296875,
        -2930.3857421875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22038745880126953,
        -0.8264544606208801,
        0.5180755853652954
      ],
      "plane_d": -2934.9130859375,
      "bbox_min": [
        -1925.17431640625,
        -3248.03076171875,
        1302.5999755859375
      ],
      "bbox_max": [
        -1320.0,
        -2990.03857421875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.41471293568611145,
        -0.6906698942184448,
        0.5924426317214966
      ],
      "plane_d": -2347.342041015625,
      "bbox_min": [
        -1518.93115234375,
        -3089.58056640625,
        1302.5999755859375
      ],
      "bbox_max": [
        -1320.0,
        -2990.03857421875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34675103425979614,
        -0.7122377753257751,
        0.6103124022483826
      ],
      "plane_d": -2533.99267578125,
      "bbox_min": [
        -1411.826904296875,
        -3089.58056640625,
        1302.5999755859375
      ],
      "bbox_max": [
        -1320.0,
        -3042.403564453125,
        1403.593017578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08832583576440811,
        -0.8090729713439941,
        0.5810332894325256
      ],
      "plane_d": -3184.2685546875,
      "bbox_min": [
        -1686.3004150390625,
        -3184.333984375,
        1302.5999755859375
      ],
      "bbox_max": [
        -1330.9732666015625,
        -2994.08203125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.30647212266921997,
        -0.7587150931358337,
        0.5748271346092224
      ],
      "plane_d": -2690.01171875,
      "bbox_min": [
        -1529.423828125,
        -3163.810791015625,
        1302.5999755859375
      ],
      "bbox_max": [
        -1330.9732666015625,
        -2994.08203125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.41471293568611145,
        -0.6906698942184448,
        0.5924426317214966
      ],
      "plane_d": -2347.342041015625,
      "bbox_min": [
        -1529.423828125,
        -3128.560791015625,
        1302.5999755859375
      ],
      "bbox_max": [
        -1330.9732666015625,
        -2994.08203125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34675103425979614,
        -0.7122377753257751,
        0.6103124022483826
      ],
      "plane_d": -2533.99267578125,
      "bbox_min": [
        -1411.6416015625,
        -3128.560791015625,
        1302.5999755859375
      ],
      "bbox_max": [
        -1330.9732666015625,
        -3062.68896484375,
        1379.8145751953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20202520489692688,
        -0.8296098113059998,
        0.5205125212669373
      ],
      "plane_d": -2979.09912109375,
      "bbox_min": [
        -1686.3004150390625,
        -3184.333984375,
        1302.5999755859375
      ],
      "bbox_max": [
        -1529.423828125,
        -3000.38232421875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9898766279220581,
        0.1408064216375351,
        0.01782338321208954
      ],
      "plane_d": -1165.5235595703125,
      "bbox_min": [
        -1826.687255859375,
        -3663.7890625,
        1302.5999755859375
      ],
      "bbox_max": [
        -1550.0,
        -3382.0,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7432345151901245,
        0.5606855154037476,
        0.36501291394233704
      ],
      "plane_d": 169.5526123046875,
      "bbox_min": [
        -1648.033935546875,
        -3507.629150390625,
        1459.0
      ],
      "bbox_max": [
        -1550.0,
        -3382.0,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -3438.999755859375,
      "bbox_min": [
        -1632.0,
        -3439.0,
        1459.0
      ],
      "bbox_max": [
        -1550.0,
        -3382.0,
        1531.311767578125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -3629.7470703125,
      "bbox_min": [
        -1632.0,
        -3439.0,
        1459.0
      ],
      "bbox_max": [
        -1554.83740234375,
        -3382.0,
        1531.311767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1632.0,
      "bbox_min": [
        -1632.0,
        -3439.0,
        1459.0
      ],
      "bbox_max": [
        -1554.83740234375,
        -3382.0,
        1531.311767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5300085544586182,
        6.930902600288391e-06,
        -0.8479923009872437
      ],
      "plane_d": 469.93865966796875,
      "bbox_min": [
        -1624.184326171875,
        -3439.0,
        1505.0
      ],
      "bbox_max": [
        -1554.83740234375,
        -3382.0,
        1531.311767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5248578786849976,
        -0.5725721716880798,
        0.629829466342926
      ],
      "plane_d": -3767.23876953125,
      "bbox_min": [
        -1624.184326171875,
        -3439.0,
        1505.0
      ],
      "bbox_max": [
        -1620.0,
        -3433.10595703125,
        1510.358154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1632.0,
      "bbox_min": [
        -1648.033935546875,
        -3507.629150390625,
        1459.0
      ],
      "bbox_max": [
        -1606.5,
        -3384.5,
        1574.9000244140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        0.0,
        0.768221378326416
      ],
      "plane_d": -2200.9541015625,
      "bbox_min": [
        -1632.0,
        -3490.0068359375,
        1459.0
      ],
      "bbox_max": [
        -1606.5,
        -3384.5,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        0.768221378326416,
        0.0
      ],
      "plane_d": 1562.9464111328125,
      "bbox_min": [
        -1632.0,
        -3435.164306640625,
        1459.0
      ],
      "bbox_max": [
        -1606.5,
        -3384.5,
        1515.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -3629.7470703125,
      "bbox_min": [
        -1632.0,
        -3435.164306640625,
        1485.0
      ],
      "bbox_max": [
        -1606.5,
        -3384.5,
        1515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5076730251312256,
        0.6092076897621155,
        0.6092076897621155
      ],
      "plane_d": 322.5755615234375,
      "bbox_min": [
        -1632.0,
        -3435.164306640625,
        1497.5
      ],
      "bbox_max": [
        -1606.5,
        -3384.5,
        1515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5248578786849976,
        -0.5725721716880798,
        0.629829466342926
      ],
      "plane_d": -3767.23876953125,
      "bbox_min": [
        -1632.0,
        -3435.164306640625,
        1497.5
      ],
      "bbox_max": [
        -1606.5,
        -3384.5,
        1515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3384.5,
      "bbox_min": [
        -1620.0,
        -3433.10595703125,
        1497.5
      ],
      "bbox_max": [
        -1606.5,
        -3384.5,
        1515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6726728081703186,
        0.7399401068687439
      ],
      "plane_d": -3426.931640625,
      "bbox_min": [
        -1620.0,
        -3433.10595703125,
        1510.3582763671875
      ],
      "bbox_max": [
        -1613.8685302734375,
        -3428.0,
        1515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7031068801879883,
        0.6397297978401184,
        0.31046193838119507
      ],
      "plane_d": 596.2442626953125,
      "bbox_min": [
        -1632.0,
        -3490.0068359375,
        1568.722900390625
      ],
      "bbox_max": [
        -1627.48095703125,
        -3485.0400390625,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7031068801879883,
        0.6397297978401184,
        0.31046193838119507
      ],
      "plane_d": 596.2442626953125,
      "bbox_min": [
        -1648.033935546875,
        -3507.629150390625,
        1548.9510498046875
      ],
      "bbox_max": [
        -1632.0,
        -3487.009033203125,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7031068801879883,
        0.6397297978401184,
        0.31046193838119507
      ],
      "plane_d": 596.2442626953125,
      "bbox_min": [
        -1826.687255859375,
        -3663.7890625,
        1302.5999755859375
      ],
      "bbox_max": [
        -1632.6080322265625,
        -3382.0,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34272027015686035,
        0.9365004897117615,
        0.07422665506601334
      ],
      "plane_d": 2554.111572265625,
      "bbox_min": [
        -1727.3770751953125,
        -3462.68505859375,
        1302.5999755859375
      ],
      "bbox_max": [
        -1634.29931640625,
        -3382.0,
        1455.83544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9661343693733215,
        0.24907872080802917,
        0.0674104243516922
      ],
      "plane_d": -827.2496337890625,
      "bbox_min": [
        -1650.8538818359375,
        -3443.77099609375,
        1302.5999755859375
      ],
      "bbox_max": [
        -1634.29931640625,
        -3382.0,
        1455.83544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7432345151901245,
        0.5606855154037476,
        0.36501291394233704
      ],
      "plane_d": 169.5526123046875,
      "bbox_min": [
        -1826.687255859375,
        -3571.833740234375,
        1302.5999755859375
      ],
      "bbox_max": [
        -1632.6080322265625,
        -3382.0,
        1548.9510498046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7289522290229797,
        0.6049720644950867,
        0.3203705847263336
      ],
      "plane_d": 411.9771423339844,
      "bbox_min": [
        -1826.687255859375,
        -3571.833740234375,
        1302.5999755859375
      ],
      "bbox_max": [
        -1633.291748046875,
        -3382.0,
        1487.26513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34272027015686035,
        0.9365004897117615,
        0.07422665506601334
      ],
      "plane_d": 2554.111572265625,
      "bbox_min": [
        -1739.9085693359375,
        -3467.27099609375,
        1302.5999755859375
      ],
      "bbox_max": [
        -1634.7877197265625,
        -3386.785888671875,
        1487.26513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9661343693733215,
        0.24907872080802917,
        0.0674104243516922
      ],
      "plane_d": -827.2496337890625,
      "bbox_min": [
        -1642.5057373046875,
        -3445.635498046875,
        1355.8927001953125
      ],
      "bbox_max": [
        -1634.7877197265625,
        -3386.785888671875,
        1487.26513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9963745474815369,
        0.0845751017332077,
        0.009205454960465431
      ],
      "plane_d": -1354.2691650390625,
      "bbox_min": [
        -1633.395751953125,
        -3383.444091796875,
        1397.3492431640625
      ],
      "bbox_max": [
        -1633.291748046875,
        -3382.0,
        1406.7977294921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9963745474815369,
        0.0845751017332077,
        0.009205454960465431
      ],
      "plane_d": -1354.2691650390625,
      "bbox_min": [
        -1633.66796875,
        -3394.5849609375,
        1404.79150390625
      ],
      "bbox_max": [
        -1632.6080322265625,
        -3382.0,
        1479.697021484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9898766279220581,
        0.1408064216375351,
        0.01782338321208954
      ],
      "plane_d": -1165.5235595703125,
      "bbox_min": [
        -1637.2723388671875,
        -3382.0,
        1302.5999755859375
      ],
      "bbox_max": [
        -1547.0,
        -3283.58740234375,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9455833435058594,
        0.3179033696651459,
        -0.06935158371925354
      ],
      "plane_d": -381.4749755859375,
      "bbox_min": [
        -1633.74365234375,
        -3380.0,
        1302.5999755859375
      ],
      "bbox_max": [
        -1547.0,
        -3283.58740234375,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3380.0,
      "bbox_min": [
        -1627.0,
        -3380.0,
        1485.0
      ],
      "bbox_max": [
        -1547.0,
        -3332.0,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9958931803703308,
        0.09053574502468109
      ],
      "plane_d": -3499.34228515625,
      "bbox_min": [
        -1627.0,
        -3380.0,
        1485.0
      ],
      "bbox_max": [
        -1552.0,
        -3332.0,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9958931803703308,
        0.0,
        0.09053574502468109
      ],
      "plane_d": -1753.54150390625,
      "bbox_min": [
        -1627.0,
        -3378.772705078125,
        1485.0
      ],
      "bbox_max": [
        -1552.0,
        -3332.0,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1620.1156005859375,
      "bbox_min": [
        -1620.1156005859375,
        -3358.10009765625,
        1488.0
      ],
      "bbox_max": [
        -1552.0,
        -3332.0,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660150170326233,
        0.5000181198120117,
        0.0
      ],
      "plane_d": 272.766357421875,
      "bbox_min": [
        -1620.1156005859375,
        -3351.5,
        1488.0
      ],
      "bbox_max": [
        -1552.0,
        -3332.0,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999086856842041,
        0.0,
        0.013512278907001019
      ],
      "plane_d": -1574.96435546875,
      "bbox_min": [
        -1555.0,
        -3335.0,
        1488.0
      ],
      "bbox_max": [
        -1552.0,
        -3332.0,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999086856842041,
        0.013512278907001019
      ],
      "plane_d": -3354.8017578125,
      "bbox_min": [
        -1555.0,
        -3335.0,
        1488.0
      ],
      "bbox_max": [
        -1552.0,
        -3334.891845703125,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1627.0,
      "bbox_min": [
        -1627.0,
        -3378.772705078125,
        1485.0
      ],
      "bbox_max": [
        -1627.0,
        -3348.380615234375,
        1488.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1627.0,
      "bbox_min": [
        -1627.0,
        -3380.0,
        1485.0
      ],
      "bbox_max": [
        -1627.0,
        -3378.5,
        1488.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39672571420669556,
        0.18136583268642426,
        -0.8998417854309082
      ],
      "plane_d": 1149.486572265625,
      "bbox_min": [
        -1633.0650634765625,
        -3378.5,
        1302.5999755859375
      ],
      "bbox_max": [
        -1564.6063232421875,
        -3283.58740234375,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0412130132317543,
        0.43465206027030945,
        -0.8996549844741821
      ],
      "plane_d": 2685.27783203125,
      "bbox_min": [
        -1625.5,
        -3378.5,
        1302.5999755859375
      ],
      "bbox_max": [
        -1564.6063232421875,
        -3283.58740234375,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1625.0,
      "bbox_min": [
        -1625.5,
        -3378.5,
        1459.0
      ],
      "bbox_max": [
        -1621.5,
        -3329.5,
        1485.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3333.0,
      "bbox_min": [
        -1625.0,
        -3378.5,
        1459.0
      ],
      "bbox_max": [
        -1621.5,
        -3329.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1481.9998779296875,
      "bbox_min": [
        -1624.439453125,
        -3330.0,
        1482.0
      ],
      "bbox_max": [
        -1621.5,
        -3329.5,
        1482.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3333.5,
      "bbox_min": [
        -1625.0,
        -3378.5,
        1482.0
      ],
      "bbox_max": [
        -1621.5,
        -3333.0,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 1481.9998779296875,
      "bbox_min": [
        -1624.937255859375,
        -3333.5,
        1482.0
      ],
      "bbox_max": [
        -1621.5,
        -3333.0,
        1482.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3378.5,
      "bbox_min": [
        -1625.0,
        -3378.5,
        1482.0
      ],
      "bbox_max": [
        -1621.5,
        -3378.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1625.5,
      "bbox_min": [
        -1625.5,
        -3378.5,
        1482.0
      ],
      "bbox_max": [
        -1625.0,
        -3374.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3378.5,
      "bbox_min": [
        -1625.5,
        -3378.5,
        1482.0
      ],
      "bbox_max": [
        -1625.0,
        -3378.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.056889183819293976,
        0.9831775426864624,
        -0.17356735467910767
      ],
      "plane_d": 3449.109619140625,
      "bbox_min": [
        -1633.0650634765625,
        -3372.64794921875,
        1302.5999755859375
      ],
      "bbox_max": [
        -1597.9923095703125,
        -3369.9052734375,
        1318.2093505859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.056889183819293976,
        0.9831775426864624,
        -0.17356735467910767
      ],
      "plane_d": 3449.109619140625,
      "bbox_min": [
        -1633.74365234375,
        -3372.7001953125,
        1302.5999755859375
      ],
      "bbox_max": [
        -1632.84228515625,
        -3369.9052734375,
        1318.2093505859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9455833435058594,
        0.3179033696651459,
        -0.06935158371925354
      ],
      "plane_d": -381.4749755859375,
      "bbox_min": [
        -1637.2723388671875,
        -3382.0,
        1302.5999755859375
      ],
      "bbox_max": [
        -1622.605224609375,
        -3311.9482421875,
        1493.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1627.0,
      "bbox_min": [
        -1627.0,
        -3348.76025390625,
        1459.0
      ],
      "bbox_max": [
        -1624.1009521484375,
        -3328.0,
        1493.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1485.0,
      "bbox_min": [
        -1627.0,
        -3348.380615234375,
        1459.0
      ],
      "bbox_max": [
        -1624.1009521484375,
        -3328.0,
        1493.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9958931803703308,
        0.0,
        0.09053574502468109
      ],
      "plane_d": -1753.54150390625,
      "bbox_min": [
        -1625.5,
        -3338.21533203125,
        1488.0
      ],
      "bbox_max": [
        -1625.0,
        -3329.5,
        1493.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1625.0,
      "bbox_min": [
        -1625.5,
        -3333.5,
        1459.0
      ],
      "bbox_max": [
        -1624.3682861328125,
        -3329.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3333.0,
      "bbox_min": [
        -1625.0,
        -3333.5,
        1474.5706787109375
      ],
      "bbox_max": [
        -1624.3682861328125,
        -3329.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1481.9998779296875,
      "bbox_min": [
        -1625.0,
        -3330.0,
        1482.0
      ],
      "bbox_max": [
        -1624.3682861328125,
        -3329.5,
        1482.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1625.5,
      "bbox_min": [
        -1625.5,
        -3333.5,
        1482.0
      ],
      "bbox_max": [
        -1625.0,
        -3329.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1481.9998779296875,
      "bbox_min": [
        -1625.5,
        -3333.5,
        1482.0
      ],
      "bbox_max": [
        -1625.0,
        -3329.5,
        1485.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3333.5,
      "bbox_min": [
        -1625.5,
        -3333.5,
        1482.0
      ],
      "bbox_max": [
        -1625.0,
        -3333.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9661343693733215,
        0.24907872080802917,
        0.0674104243516922
      ],
      "plane_d": -827.2496337890625,
      "bbox_min": [
        -1636.6453857421875,
        -3382.0,
        1311.585205078125
      ],
      "bbox_max": [
        -1633.0650634765625,
        -3369.9052734375,
        1345.208984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9661343693733215,
        0.24907872080802917,
        0.0674104243516922
      ],
      "plane_d": -827.2496337890625,
      "bbox_min": [
        -1637.2723388671875,
        -3382.0,
        1302.5999755859375
      ],
      "bbox_max": [
        -1633.0650634765625,
        -3369.9052734375,
        1318.2093505859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.056889183819293976,
        0.9831775426864624,
        -0.17356735467910767
      ],
      "plane_d": 3449.109619140625,
      "bbox_min": [
        -1634.891845703125,
        -3372.7666015625,
        1302.5999755859375
      ],
      "bbox_max": [
        -1633.0650634765625,
        -3369.9052734375,
        1318.2093505859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7066444158554077,
        0.6241137385368347,
        -0.3333699703216553
      ],
      "plane_d": 1454.91064453125,
      "bbox_min": [
        -1643.3553466796875,
        -3382.0,
        1496.0
      ],
      "bbox_max": [
        -1552.108154296875,
        -3313.192626953125,
        1546.3753662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999086856842041,
        0.013512278907001019
      ],
      "plane_d": -3354.8017578125,
      "bbox_min": [
        -1633.6953125,
        -3382.0,
        1496.0
      ],
      "bbox_max": [
        -1552.108154296875,
        -3332.108154296875,
        1535.136474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999086856842041,
        0.0,
        0.013512278907001019
      ],
      "plane_d": -1574.96435546875,
      "bbox_min": [
        -1563.090576171875,
        -3334.891845703125,
        1496.0
      ],
      "bbox_max": [
        -1554.5,
        -3332.108154296875,
        1531.106689453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5300085544586182,
        6.930902600288391e-06,
        -0.8479923009872437
      ],
      "plane_d": 469.93841552734375,
      "bbox_min": [
        -1563.090576171875,
        -3334.48681640625,
        1525.973388671875
      ],
      "bbox_max": [
        -1554.8775634765625,
        -3334.10009765625,
        1531.106689453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3127959668636322,
        -0.826920747756958,
        -0.467290997505188
      ],
      "plane_d": -1572.509033203125,
      "bbox_min": [
        -1633.6953125,
        -3382.0,
        1496.0
      ],
      "bbox_max": [
        -1552.5,
        -3334.41748046875,
        1535.136474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10984108597040176,
        -0.8989793658256531,
        -0.423994243144989
      ],
      "plane_d": -2558.715087890625,
      "bbox_min": [
        -1633.6953125,
        -3373.803466796875,
        1499.86083984375
      ],
      "bbox_max": [
        -1552.5,
        -3334.41748046875,
        1535.136474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10984160006046295,
        -0.8989806175231934,
        -0.423991322517395
      ],
      "plane_d": -2205.47412109375,
      "bbox_min": [
        -1633.6953125,
        -3373.803466796875,
        1499.86083984375
      ],
      "bbox_max": [
        -1552.5,
        -3334.41748046875,
        1535.136474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3127978444099426,
        -0.8269219398498535,
        -0.467287540435791
      ],
      "plane_d": -2578.472900390625,
      "bbox_min": [
        -1633.6953125,
        -3371.49658203125,
        1499.86083984375
      ],
      "bbox_max": [
        -1552.5,
        -3334.41748046875,
        1533.7503662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5522068738937378,
        -0.5197986364364624,
        -0.6518258452415466
      ],
      "plane_d": 119.251708984375,
      "bbox_min": [
        -1633.6953125,
        -3365.4814453125,
        1499.86083984375
      ],
      "bbox_max": [
        -1552.5,
        -3334.41748046875,
        1532.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.46813642978668213,
        -0.6937713027000427,
        -0.5472930073738098
      ],
      "plane_d": -756.1793823242188,
      "bbox_min": [
        -1633.6953125,
        -3365.4814453125,
        1499.86083984375
      ],
      "bbox_max": [
        -1553.48388671875,
        -3334.41748046875,
        1532.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4681382179260254,
        -0.6937716007232666,
        -0.5472912192344666
      ],
      "plane_d": -2261.712890625,
      "bbox_min": [
        -1633.6953125,
        -3365.4814453125,
        1499.86083984375
      ],
      "bbox_max": [
        -1553.48388671875,
        -3334.41748046875,
        1532.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5150415301322937,
        -0.8571652173995972
      ],
      "plane_d": -437.427734375,
      "bbox_min": [
        -1622.4443359375,
        -3365.4814453125,
        1499.86083984375
      ],
      "bbox_max": [
        -1553.48388671875,
        -3334.41748046875,
        1532.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03878581523895264,
        -0.6718603372573853,
        -0.7396615743637085
      ],
      "plane_d": -1201.071044921875,
      "bbox_min": [
        -1622.4443359375,
        -3365.4814453125,
        1503.5301513671875
      ],
      "bbox_max": [
        -1553.48388671875,
        -3334.41748046875,
        1532.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16525734961032867,
        -0.5994216799736023,
        -0.7831881046295166
      ],
      "plane_d": -564.74462890625,
      "bbox_min": [
        -1622.4443359375,
        -3365.4814453125,
        1503.5301513671875
      ],
      "bbox_max": [
        -1553.48388671875,
        -3334.41748046875,
        1532.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1949397325515747,
        -0.5379992723464966,
        -0.820094645023346
      ],
      "plane_d": -255.6650390625,
      "bbox_min": [
        -1622.4443359375,
        -3365.4814453125,
        1503.5301513671875
      ],
      "bbox_max": [
        -1553.48388671875,
        -3334.41748046875,
        1532.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11041884869337082,
        -0.646426796913147,
        -0.7549437880516052
      ],
      "plane_d": -852.930908203125,
      "bbox_min": [
        -1622.4443359375,
        -3365.4814453125,
        1503.5301513671875
      ],
      "bbox_max": [
        -1553.48388671875,
        -3334.41748046875,
        1532.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.03878581151366234,
        -0.67186039686203,
        -0.7396616339683533
      ],
      "plane_d": -1076.3358154296875,
      "bbox_min": [
        -1622.4443359375,
        -3365.4814453125,
        1503.5301513671875
      ],
      "bbox_max": [
        -1553.48388671875,
        -3334.41748046875,
        1532.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11041881889104843,
        -0.646426796913147,
        -0.7549437284469604
      ],
      "plane_d": -1208.0379638671875,
      "bbox_min": [
        -1622.4443359375,
        -3364.23291015625,
        1503.5301513671875
      ],
      "bbox_max": [
        -1553.48388671875,
        -3334.41748046875,
        1532.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16525734961032867,
        -0.5994217395782471,
        -0.7831881046295166
      ],
      "plane_d": -1096.21240234375,
      "bbox_min": [
        -1622.4443359375,
        -3360.677734375,
        1503.5301513671875
      ],
      "bbox_max": [
        -1553.48388671875,
        -3334.41748046875,
        1532.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5300085544586182,
        6.930902600288391e-06,
        -0.8479923009872437
      ],
      "plane_d": 469.93841552734375,
      "bbox_min": [
        -1612.1478271484375,
        -3352.05322265625,
        1503.5301513671875
      ],
      "bbox_max": [
        -1553.48388671875,
        -3334.41748046875,
        1532.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.033905185759067535,
        -0.9992004632949829,
        0.021191386505961418
      ],
      "plane_d": -3426.876953125,
      "bbox_min": [
        -1563.4188232421875,
        -3344.294189453125,
        1525.4765625
      ],
      "bbox_max": [
        -1553.48388671875,
        -3334.5,
        1532.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3334.5,
      "bbox_min": [
        -1554.5999755859375,
        -3334.5,
        1525.4765625
      ],
      "bbox_max": [
        -1553.48388671875,
        -3334.5,
        1526.60009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1949397623538971,
        -0.5379993319511414,
        -0.8200947046279907
      ],
      "plane_d": -882.5914306640625,
      "bbox_min": [
        -1612.1478271484375,
        -3352.05322265625,
        1503.5301513671875
      ],
      "bbox_max": [
        -1554.082763671875,
        -3334.5,
        1525.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19493962824344635,
        -0.47151145339012146,
        -0.8600438833236694
      ],
      "plane_d": -599.68896484375,
      "bbox_min": [
        -1610.4500732421875,
        -3351.04052734375,
        1503.5301513671875
      ],
      "bbox_max": [
        -1554.082763671875,
        -3334.5,
        1525.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0387689471244812,
        -0.3376634418964386,
        -0.9404681921005249
      ],
      "plane_d": 220.9517822265625,
      "bbox_min": [
        -1609.736572265625,
        -3351.04052734375,
        1503.5301513671875
      ],
      "bbox_max": [
        -1554.082763671875,
        -3334.5,
        1525.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11042895913124084,
        -0.36310678720474243,
        -0.9251804947853088
      ],
      "plane_d": -2.5374755859375,
      "bbox_min": [
        -1609.736572265625,
        -3351.04052734375,
        1503.8004150390625
      ],
      "bbox_max": [
        -1554.082763671875,
        -3334.5,
        1525.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16526995599269867,
        -0.4101145565509796,
        -0.8969346284866333
      ],
      "plane_d": -290.7393798828125,
      "bbox_min": [
        -1609.736572265625,
        -3351.04052734375,
        1504.0377197265625
      ],
      "bbox_max": [
        -1554.082763671875,
        -3334.5,
        1525.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3334.5,
      "bbox_min": [
        -1554.5999755859375,
        -3334.5,
        1525.111328125
      ],
      "bbox_max": [
        -1554.082763671875,
        -3334.5,
        1525.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1614.199951171875,
      "bbox_min": [
        -1614.199951171875,
        -3355.456787109375,
        1507.474609375
      ],
      "bbox_max": [
        -1614.199951171875,
        -3353.53857421875,
        1509.0625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.307058275619056e-05,
        -0.8571455478668213,
        0.5150743126869202
      ],
      "plane_d": -3653.53125,
      "bbox_min": [
        -1614.199951171875,
        -3355.7421875,
        1507.1728515625
      ],
      "bbox_max": [
        -1610.609619140625,
        -3353.6025390625,
        1509.12841796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1614.199951171875,
      "bbox_min": [
        -1614.199951171875,
        -3355.6005859375,
        1507.1728515625
      ],
      "bbox_max": [
        -1614.199951171875,
        -3353.6025390625,
        1509.0625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -6.084522829041816e-05,
        -0.8571798205375671,
        0.5150172710418701
      ],
      "plane_d": -3653.62060546875,
      "bbox_min": [
        -1601.699951171875,
        -3355.93408203125,
        1508.4625244140625
      ],
      "bbox_max": [
        -1601.199951171875,
        -3355.484619140625,
        1509.21044921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8571724891662598,
        0.5150294899940491
      ],
      "plane_d": -3653.51708984375,
      "bbox_min": [
        -1614.199951171875,
        -3356.955810546875,
        1505.4095458984375
      ],
      "bbox_max": [
        -1601.199951171875,
        -3353.763671875,
        1508.9034423828125
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1614.199951171875,
      "bbox_min": [
        -1614.199951171875,
        -3356.955810546875,
        1505.4095458984375
      ],
      "bbox_max": [
        -1614.199951171875,
        -3353.763671875,
        1508.8416748046875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.8571632504463196,
        0.5150449872016907
      ],
      "plane_d": -3650.208984375,
      "bbox_min": [
        -1612.0,
        -3356.7021484375,
        1499.86083984375
      ],
      "bbox_max": [
        -1603.5,
        -3352.819580078125,
        1505.0621337890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1612.0,
      "bbox_min": [
        -1612.0,
        -3356.48486328125,
        1499.86083984375
      ],
      "bbox_max": [
        -1612.0,
        -3352.819580078125,
        1505.0621337890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1612.0,
      "bbox_min": [
        -1612.0,
        -3356.7021484375,
        1500.2021484375
      ],
      "bbox_max": [
        -1611.2552490234375,
        -3355.746337890625,
        1501.137939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8571632504463196,
        0.5150449872016907
      ],
      "plane_d": -3650.208984375,
      "bbox_min": [
        -1612.0,
        -3356.7021484375,
        1500.7763671875
      ],
      "bbox_max": [
        -1611.2552490234375,
        -3356.48486328125,
        1501.137939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8571632504463196,
        0.5150449872016907
      ],
      "plane_d": -3650.208984375,
      "bbox_min": [
        -1604.7454833984375,
        -3356.7021484375,
        1500.7763671875
      ],
      "bbox_max": [
        -1603.5,
        -3356.3388671875,
        1501.3812255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5300085544586182,
        6.930902600288391e-06,
        -0.8479923009872437
      ],
      "plane_d": 469.93841552734375,
      "bbox_min": [
        -1559.3818359375,
        -3344.4921875,
        1525.0
      ],
      "bbox_max": [
        -1552.5,
        -3334.5,
        1529.432861328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.033905185759067535,
        -0.9992004632949829,
        0.021191386505961418
      ],
      "plane_d": -3426.876953125,
      "bbox_min": [
        -1559.3818359375,
        -3344.4921875,
        1525.0
      ],
      "bbox_max": [
        -1552.5,
        -3334.5,
        1529.432861328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3334.5,
      "bbox_min": [
        -1554.082763671875,
        -3334.5,
        1525.0
      ],
      "bbox_max": [
        -1552.5,
        -3334.5,
        1525.9840087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3334.5,
      "bbox_min": [
        -1554.513916015625,
        -3334.5,
        1525.0
      ],
      "bbox_max": [
        -1553.320068359375,
        -3334.5,
        1525.4765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8571632504463196,
        0.5150449872016907
      ],
      "plane_d": -3650.208984375,
      "bbox_min": [
        -1612.0,
        -3356.7021484375,
        1500.5631103515625
      ],
      "bbox_max": [
        -1611.38037109375,
        -3356.34716796875,
        1500.9774169921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1612.0,
      "bbox_min": [
        -1612.0,
        -3356.7021484375,
        1500.5631103515625
      ],
      "bbox_max": [
        -1612.0,
        -3356.34716796875,
        1500.9774169921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5300086140632629,
        -6.929040864633862e-06,
        -0.8479923605918884
      ],
      "plane_d": 469.89190673828125,
      "bbox_min": [
        -1616.815673828125,
        -3382.0,
        1496.0
      ],
      "bbox_max": [
        -1554.5999755859375,
        -3356.484130859375,
        1532.1119384765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.847313404083252,
        -0.039971448481082916,
        0.5295870304107666
      ],
      "plane_d": -2270.10888671875,
      "bbox_min": [
        -1563.4188232421875,
        -3373.39990234375,
        1531.0999755859375
      ],
      "bbox_max": [
        -1562.5797119140625,
        -3363.407958984375,
        1532.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4851193130016327,
        -0.8401665091514587,
        0.24244487285614014
      ],
      "plane_d": -3973.2109375,
      "bbox_min": [
        -1616.815673828125,
        -3367.11572265625,
        1496.0
      ],
      "bbox_max": [
        -1603.5,
        -3356.484130859375,
        1501.1392822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8571632504463196,
        0.5150449872016907
      ],
      "plane_d": -3650.208984375,
      "bbox_min": [
        -1604.6185302734375,
        -3356.7021484375,
        1500.7763671875
      ],
      "bbox_max": [
        -1603.5,
        -3356.484130859375,
        1501.1392822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5522074103355408,
        -0.5197985172271729,
        -0.6518255472183228
      ],
      "plane_d": -1656.646484375,
      "bbox_min": [
        -1643.3553466796875,
        -3364.03515625,
        1496.0
      ],
      "bbox_max": [
        -1594.4700927734375,
        -3313.192626953125,
        1529.26708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1098410040140152,
        0.04768495261669159,
        -0.9928046464920044
      ],
      "plane_d": 1822.5477294921875,
      "bbox_min": [
        -1643.3553466796875,
        -3364.03515625,
        1497.7818603515625
      ],
      "bbox_max": [
        -1594.4700927734375,
        -3313.192626953125,
        1529.26708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10984069854021072,
        0.04768303781747818,
        -0.9928048253059387
      ],
      "plane_d": 1469.29345703125,
      "bbox_min": [
        -1643.3553466796875,
        -3364.03515625,
        1497.7818603515625
      ],
      "bbox_max": [
        -1604.624755859375,
        -3313.192626953125,
        1529.26708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31279879808425903,
        -0.024374349042773247,
        -0.9495065808296204
      ],
      "plane_d": 836.332763671875,
      "bbox_min": [
        -1643.3553466796875,
        -3364.03515625,
        1497.7818603515625
      ],
      "bbox_max": [
        -1604.624755859375,
        -3315.49951171875,
        1529.26708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4681382179260254,
        -0.6937716007232666,
        -0.5472912192344666
      ],
      "plane_d": -2261.712890625,
      "bbox_min": [
        -1643.3553466796875,
        -3364.03515625,
        1497.7818603515625
      ],
      "bbox_max": [
        -1604.624755859375,
        -3322.02294921875,
        1529.26708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5522040724754333,
        -0.33149459958076477,
        -0.7649718523025513
      ],
      "plane_d": -855.4124755859375,
      "bbox_min": [
        -1643.3553466796875,
        -3359.504638671875,
        1497.7818603515625
      ],
      "bbox_max": [
        -1604.624755859375,
        -3322.02294921875,
        1516.9271240234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4681406617164612,
        -0.15752869844436646,
        -0.8694992661476135
      ],
      "plane_d": 19.9765625,
      "bbox_min": [
        -1640.6640625,
        -3359.504638671875,
        1497.7818603515625
      ],
      "bbox_max": [
        -1604.624755859375,
        -3322.02294921875,
        1513.9002685546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6955071091651917,
        0.6805833578109741,
        0.23038241267204285
      ],
      "plane_d": 778.6747436523438,
      "bbox_min": [
        -1640.6640625,
        -3359.504638671875,
        1497.7818603515625
      ],
      "bbox_max": [
        -1604.624755859375,
        -3322.02294921875,
        1513.9002685546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5150415301322937,
        -0.8571652173995972
      ],
      "plane_d": -437.427734375,
      "bbox_min": [
        -1627.1341552734375,
        -3359.504638671875,
        1497.7818603515625
      ],
      "bbox_max": [
        -1604.624755859375,
        -3332.67919921875,
        1513.9002685546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19493962824344635,
        -0.47151145339012146,
        -0.8600438833236694
      ],
      "plane_d": -599.68896484375,
      "bbox_min": [
        -1627.1341552734375,
        -3359.504638671875,
        1497.7818603515625
      ],
      "bbox_max": [
        -1608.0,
        -3332.67919921875,
        1513.9002685546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16526995599269867,
        -0.4101145565509796,
        -0.8969346284866333
      ],
      "plane_d": -290.7393798828125,
      "bbox_min": [
        -1627.1341552734375,
        -3359.504638671875,
        1497.7818603515625
      ],
      "bbox_max": [
        -1608.0,
        -3332.67919921875,
        1513.9002685546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11042895913124084,
        -0.36310678720474243,
        -0.9251804947853088
      ],
      "plane_d": -2.5374755859375,
      "bbox_min": [
        -1627.1341552734375,
        -3359.504638671875,
        1497.7818603515625
      ],
      "bbox_max": [
        -1608.0,
        -3332.67919921875,
        1513.9002685546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0387689471244812,
        -0.3376634418964386,
        -0.9404681921005249
      ],
      "plane_d": 220.9517822265625,
      "bbox_min": [
        -1627.1341552734375,
        -3359.504638671875,
        1497.7818603515625
      ],
      "bbox_max": [
        -1608.0,
        -3332.67919921875,
        1513.9002685546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1949397623538971,
        -0.5379993319511414,
        -0.8200947046279907
      ],
      "plane_d": -882.5914306640625,
      "bbox_min": [
        -1627.1341552734375,
        -3359.504638671875,
        1504.7919921875
      ],
      "bbox_max": [
        -1610.4500732421875,
        -3349.080322265625,
        1513.9002685546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16525734961032867,
        -0.5994217395782471,
        -0.7831881046295166
      ],
      "plane_d": -1096.21240234375,
      "bbox_min": [
        -1625.6776123046875,
        -3359.504638671875,
        1506.024658203125
      ],
      "bbox_max": [
        -1612.1478271484375,
        -3352.05322265625,
        1513.9002685546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1614.199951171875,
      "bbox_min": [
        -1614.199951171875,
        -3353.5810546875,
        1506.8411865234375
      ],
      "bbox_max": [
        -1614.199951171875,
        -3352.554443359375,
        1507.5943603515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1614.1998291015625,
      "bbox_min": [
        -1614.199951171875,
        -3353.722412109375,
        1505.431396484375
      ],
      "bbox_max": [
        -1614.199951171875,
        -3350.4052734375,
        1507.5146484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1614.199951171875,
      "bbox_min": [
        -1614.199951171875,
        -3348.15185546875,
        1502.5927734375
      ],
      "bbox_max": [
        -1614.199951171875,
        -3345.102294921875,
        1504.19580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1614.1998291015625,
      "bbox_min": [
        -1614.199951171875,
        -3354.705322265625,
        1500.478271484375
      ],
      "bbox_max": [
        -1614.199951171875,
        -3345.227783203125,
        1507.2498779296875
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1612.0,
      "bbox_min": [
        -1612.0,
        -3355.178466796875,
        1498.1435546875
      ],
      "bbox_max": [
        -1612.0,
        -3349.41259765625,
        1504.276611328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1612.0,
      "bbox_min": [
        -1612.0,
        -3352.515869140625,
        1497.9661865234375
      ],
      "bbox_max": [
        -1612.0,
        -3351.86767578125,
        1498.2608642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1612.0,
      "bbox_min": [
        -1612.0,
        -3352.1572265625,
        1497.943603515625
      ],
      "bbox_max": [
        -1612.0,
        -3351.974365234375,
        1498.04541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1616.0,
      "bbox_min": [
        -1620.1156005859375,
        -3358.10009765625,
        1496.0
      ],
      "bbox_max": [
        -1616.0,
        -3351.5,
        1500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9701424837112427,
        0.0,
        0.24253562092781067
      ],
      "plane_d": -1934.576171875,
      "bbox_min": [
        -1620.1156005859375,
        -3358.10009765625,
        1496.0
      ],
      "bbox_max": [
        -1618.1156005859375,
        -3351.5,
        1498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2511899769306183,
        -0.9370437860488892,
        0.24259574711322784
      ],
      "plane_d": -3102.653564453125,
      "bbox_min": [
        -1620.1156005859375,
        -3358.10009765625,
        1496.0
      ],
      "bbox_max": [
        -1618.1156005859375,
        -3357.180419921875,
        1498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1302.5999755859375,
      "bbox_min": [
        -4035.11669921875,
        -5265.7685546875,
        980.9415283203125
      ],
      "bbox_max": [
        -1669.3681640625,
        -2979.77587890625,
        1880.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.1646440476179123,
        0.8786206841468811,
        0.44823890924453735
      ],
      "plane_d": 2238.702880859375,
      "bbox_min": [
        -2530.148681640625,
        -4036.266357421875,
        980.9415283203125
      ],
      "bbox_max": [
        -1866.806884765625,
        -3335.8984375,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.01847594976425171,
        0.1786024272441864,
        0.9837478995323181
      ],
      "plane_d": -353.90960693359375,
      "bbox_min": [
        -2530.148681640625,
        -4036.266357421875,
        981.466064453125
      ],
      "bbox_max": [
        -1866.806884765625,
        -3402.532470703125,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14676129817962646,
        0.7160802483558655,
        0.6824150681495667
      ],
      "plane_d": 1489.5687255859375,
      "bbox_min": [
        -2530.148681640625,
        -4036.266357421875,
        981.466064453125
      ],
      "bbox_max": [
        -1877.0391845703125,
        -3402.532470703125,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4028.199951171875,
      "bbox_min": [
        -2530.148681640625,
        -4036.266357421875,
        981.466064453125
      ],
      "bbox_max": [
        -1888.2955322265625,
        -3402.532470703125,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.043616753071546555,
        0.9218221306800842,
        0.38515132665634155
      ],
      "plane_d": 2676.18310546875,
      "bbox_min": [
        -1888.5152587890625,
        -3402.609375,
        981.466064453125
      ],
      "bbox_max": [
        -1888.2955322265625,
        -3402.532470703125,
        981.5785522460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2235765904188156,
        0.04341130331158638,
        0.9737191796302795
      ],
      "plane_d": -385.780029296875,
      "bbox_min": [
        -1888.5152587890625,
        -3402.5927734375,
        981.466064453125
      ],
      "bbox_max": [
        -1888.3131103515625,
        -3402.532470703125,
        981.5137939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4036.266357421875,
      "bbox_min": [
        -2530.148681640625,
        -4036.266357421875,
        1032.0
      ],
      "bbox_max": [
        -2521.800048828125,
        -4028.199951171875,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2521.800048828125,
      "bbox_min": [
        -2521.800048828125,
        -4036.266357421875,
        1041.5999755859375
      ],
      "bbox_max": [
        -2521.800048828125,
        -4028.199951171875,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45244094729423523,
        0.7295348644256592,
        0.5129094123840332
      ],
      "plane_d": 2833.32421875,
      "bbox_min": [
        -1896.9144287109375,
        -3435.805908203125,
        981.5137939453125
      ],
      "bbox_max": [
        -1877.2235107421875,
        -3402.5927734375,
        1018.7938842773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1103413850069046,
        0.05388505384325981,
        0.9924319386482239
      ],
      "plane_d": -604.18408203125,
      "bbox_min": [
        -2328.351806640625,
        -3600.0,
        1016.67626953125
      ],
      "bbox_max": [
        -1866.806884765625,
        -3422.105224609375,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06612364202737808,
        0.09650266915559769,
        0.9931338429450989
      ],
      "plane_d": -551.6007690429688,
      "bbox_min": [
        -2328.351806640625,
        -3551.60009765625,
        1040.6011962890625
      ],
      "bbox_max": [
        -2193.854736328125,
        -3489.9541015625,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7485790252685547,
        0.22469562292099,
        0.6238119602203369
      ],
      "plane_d": -1412.25048828125,
      "bbox_min": [
        -2090.0,
        -3600.0,
        1016.67626953125
      ],
      "bbox_max": [
        -1866.806884765625,
        -3422.105224609375,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14676129817962646,
        0.7160802483558655,
        0.6824150681495667
      ],
      "plane_d": 1489.5687255859375,
      "bbox_min": [
        -1877.2235107421875,
        -3465.924072265625,
        1018.7813720703125
      ],
      "bbox_max": [
        -1866.806884765625,
        -3435.756103515625,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5098043084144592,
        -0.8602903485298157,
        1.845117026277876e-06
      ],
      "plane_d": -4050.700439453125,
      "bbox_min": [
        -2090.0,
        -3489.6318359375,
        1028.05322265625
      ],
      "bbox_max": [
        -2054.08740234375,
        -3465.0,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5098023414611816,
        0.8602915406227112,
        0.0
      ],
      "plane_d": 4041.298828125,
      "bbox_min": [
        -2090.0,
        -3480.35546875,
        1028.05322265625
      ],
      "bbox_max": [
        -2054.08740234375,
        -3465.0,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.8944272398948669,
        0.0
      ],
      "plane_d": 2168.986083984375,
      "bbox_min": [
        -2090.0,
        -3470.0,
        1028.187255859375
      ],
      "bbox_max": [
        -2080.0,
        -3465.0,
        1039.635009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32936930656433105,
        -0.8532378077507019,
        0.40435269474983215
      ],
      "plane_d": -2643.852783203125,
      "bbox_min": [
        -2349.54345703125,
        -3521.27880859375,
        980.9415283203125
      ],
      "bbox_max": [
        -1888.322509765625,
        -3335.8984375,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3485427498817444,
        -0.8757609128952026,
        0.3340070843696594
      ],
      "plane_d": -2608.564453125,
      "bbox_min": [
        -2089.408203125,
        -3418.607421875,
        980.9415283203125
      ],
      "bbox_max": [
        -1899.192626953125,
        -3336.721435546875,
        1050.388427734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20575138926506042,
        0.1004783883690834,
        0.9734323620796204
      ],
      "plane_d": -226.04217529296875,
      "bbox_min": [
        -2089.408203125,
        -3418.607421875,
        980.9415283203125
      ],
      "bbox_max": [
        -1899.192626953125,
        -3336.721435546875,
        1050.388427734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21823850274085999,
        0.07879546284675598,
        0.9727092981338501
      ],
      "plane_d": -274.47198486328125,
      "bbox_min": [
        -1920.9259033203125,
        -3372.69189453125,
        980.9415283203125
      ],
      "bbox_max": [
        -1899.192626953125,
        -3361.09033203125,
        986.3633422851562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.21603241562843323,
        -0.9093504548072815,
        0.35554423928260803
      ],
      "plane_d": -2994.511962890625,
      "bbox_min": [
        -1901.143798828125,
        -3361.1201171875,
        980.9415283203125
      ],
      "bbox_max": [
        -1900.942626953125,
        -3360.975341796875,
        981.2509765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06612364202737808,
        0.09650266915559769,
        0.9931338429450989
      ],
      "plane_d": -551.6007690429688,
      "bbox_min": [
        -2349.54345703125,
        -3521.27880859375,
        981.014404296875
      ],
      "bbox_max": [
        -1888.322509765625,
        -3335.8984375,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21823850274085999,
        0.07879546284675598,
        0.9727092981338501
      ],
      "plane_d": -274.47198486328125,
      "bbox_min": [
        -2193.854736328125,
        -3489.9541015625,
        981.014404296875
      ],
      "bbox_max": [
        -1888.322509765625,
        -3366.8369140625,
        1040.6011962890625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.1103413850069046,
        0.05388505384325981,
        0.9924319386482239
      ],
      "plane_d": -604.18408203125,
      "bbox_min": [
        -2144.113037109375,
        -3478.30517578125,
        1026.71435546875
      ],
      "bbox_max": [
        -2069.41357421875,
        -3418.607421875,
        1036.0379638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4472135901451111,
        -0.8944271802902222,
        0.0
      ],
      "plane_d": -2126.50048828125,
      "bbox_min": [
        -2105.0,
        -3430.0,
        1027.470703125
      ],
      "bbox_max": [
        -2095.0,
        -3421.18310546875,
        1028.85546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8849280476570129,
        0.4657277762889862,
        -0.0
      ],
      "plane_d": 3449.0419921875,
      "bbox_min": [
        -2097.0087890625,
        -3425.0,
        1027.470703125
      ],
      "bbox_max": [
        -2095.0,
        -3421.18310546875,
        1027.6839599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4472135901451111,
        -0.8944271802902222,
        0.0
      ],
      "plane_d": -2126.50048828125,
      "bbox_min": [
        -2095.4931640625,
        -3425.24658203125,
        1027.6832275390625
      ],
      "bbox_max": [
        -2095.0,
        -3424.814697265625,
        1027.7513427734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8849280476570129,
        0.4657277762889862,
        -0.0
      ],
      "plane_d": 3449.0419921875,
      "bbox_min": [
        -2095.09765625,
        -3425.0,
        1027.6832275390625
      ],
      "bbox_max": [
        -2095.0,
        -3424.814697265625,
        1027.694091796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4472135901451111,
        -0.8944271802902222,
        0.0
      ],
      "plane_d": -2126.50048828125,
      "bbox_min": [
        -2105.0,
        -3430.0,
        1027.5908203125
      ],
      "bbox_max": [
        -2095.0,
        -3423.116943359375,
        1028.85546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8849280476570129,
        0.4657277762889862,
        -0.0
      ],
      "plane_d": 3449.0419921875,
      "bbox_min": [
        -2095.990966796875,
        -3425.0,
        1027.5908203125
      ],
      "bbox_max": [
        -2095.0,
        -3423.116943359375,
        1027.707763671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3485427498817444,
        -0.8757609128952026,
        0.3340070843696594
      ],
      "plane_d": -2608.564453125,
      "bbox_min": [
        -2113.288330078125,
        -3475.025146484375,
        1026.71435546875
      ],
      "bbox_max": [
        -1906.1572265625,
        -3335.8984375,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8618017435073853,
        0.5072331428527832,
        0.003500441089272499
      ],
      "plane_d": 3538.946533203125,
      "bbox_min": [
        -2113.288330078125,
        -3425.130126953125,
        1027.470703125
      ],
      "bbox_max": [
        -2096.940185546875,
        -3411.51708984375,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8840292096138,
        -0.46677976846694946,
        -0.02467990666627884
      ],
      "plane_d": -3436.5439453125,
      "bbox_min": [
        -2113.288330078125,
        -3425.130126953125,
        1027.470703125
      ],
      "bbox_max": [
        -2096.940185546875,
        -3415.558349609375,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8849280476570129,
        0.4657277762889862,
        -0.0
      ],
      "plane_d": 3449.0419921875,
      "bbox_min": [
        -2097.0087890625,
        -3421.313232421875,
        1027.470703125
      ],
      "bbox_max": [
        -2096.940185546875,
        -3421.18310546875,
        1027.819580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4472135901451111,
        -0.8944271802902222,
        0.0
      ],
      "plane_d": -2126.50048828125,
      "bbox_min": [
        -2112.11865234375,
        -3475.025146484375,
        1027.478759765625
      ],
      "bbox_max": [
        -1906.1572265625,
        -3335.8984375,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8618017435073853,
        0.5072331428527832,
        0.003500441089272499
      ],
      "plane_d": 3538.946533203125,
      "bbox_min": [
        -2112.11865234375,
        -3430.0,
        1027.478759765625
      ],
      "bbox_max": [
        -2095.0,
        -3413.5810546875,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8840292096138,
        -0.46677976846694946,
        -0.02467990666627884
      ],
      "plane_d": -3436.5439453125,
      "bbox_min": [
        -2112.11865234375,
        -3430.0,
        1027.478759765625
      ],
      "bbox_max": [
        -2095.0,
        -3417.773193359375,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8849280476570129,
        0.4657277762889862,
        -0.0
      ],
      "plane_d": 3449.0419921875,
      "bbox_min": [
        -2096.996826171875,
        -3425.0,
        1027.478759765625
      ],
      "bbox_max": [
        -2095.0,
        -3421.205810546875,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5098023414611816,
        0.8602915406227112,
        0.0
      ],
      "plane_d": 4041.298828125,
      "bbox_min": [
        -2090.0,
        -3475.025146484375,
        1033.507080078125
      ],
      "bbox_max": [
        -1906.1572265625,
        -3335.8984375,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5098043084144592,
        -0.8602903485298157,
        1.845117026277876e-06
      ],
      "plane_d": -4050.700439453125,
      "bbox_min": [
        -2090.0,
        -3475.025146484375,
        1039.635009765625
      ],
      "bbox_max": [
        -2081.520263671875,
        -3470.0,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24250808358192444,
        -0.909406840801239,
        0.3378889858722687
      ],
      "plane_d": -2927.0478515625,
      "bbox_min": [
        -1906.5107421875,
        -3336.752685546875,
        1050.1697998046875
      ],
      "bbox_max": [
        -1906.1572265625,
        -3335.8984375,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9805806875228882,
        0.1961161345243454
      ],
      "plane_d": 4617.79833984375,
      "bbox_min": [
        -3835.11669921875,
        -5065.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2214.77978515625,
        -3935.422119140625,
        1302.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9805806875228882,
        0.1961161345243454
      ],
      "plane_d": 4711.93408203125,
      "bbox_min": [
        -3291.52734375,
        -5065.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2908.47216796875,
        -4919.7685546875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6102267503738403,
        0.7675688862800598,
        0.19611582159996033
      ],
      "plane_d": 5575.14697265625,
      "bbox_min": [
        -3291.52734375,
        -5065.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2908.47216796875,
        -4919.7685546875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6102268099784851,
        0.7675688862800598,
        0.1961151361465454
      ],
      "plane_d": 1791.7420654296875,
      "bbox_min": [
        -3291.52734375,
        -5065.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2908.47216796875,
        -4919.7685546875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7123355865478516,
        0.6738817095756531,
        0.19611580669879913
      ],
      "plane_d": 5438.24755859375,
      "bbox_min": [
        -3291.52734375,
        -5008.603515625,
        1052.5999755859375
      ],
      "bbox_max": [
        -2908.47216796875,
        -4919.7685546875,
        1302.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7123335599899292,
        0.6738840341567993,
        0.19611519575119019
      ],
      "plane_d": 1021.7857055664062,
      "bbox_min": [
        -3175.552978515625,
        -5008.603515625,
        1052.5999755859375
      ],
      "bbox_max": [
        -2908.47216796875,
        -4919.7685546875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4965.7685546875,
      "bbox_min": [
        -3175.552978515625,
        -4965.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3054.07763671875,
        -4919.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8406816720962524,
        0.5415297150611877,
        0.0
      ],
      "plane_d": 5333.830078125,
      "bbox_min": [
        -3175.552978515625,
        -4965.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3145.921875,
        -4919.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -4.549466439129901e-07,
        -9.098932451934161e-08
      ],
      "plane_d": -2214.781982421875,
      "bbox_min": [
        -3835.11669921875,
        -4969.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2214.77978515625,
        -3935.422119140625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.00018243707017973065,
        1.0,
        0.0
      ],
      "plane_d": 4247.14404296875,
      "bbox_min": [
        -3835.11669921875,
        -4969.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2317.299072265625,
        -3935.422119140625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0007913371082395315,
        0.97135990858078,
        0.23761190474033356
      ],
      "plane_d": 3911.30615234375,
      "bbox_min": [
        -3835.11669921875,
        -4969.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2317.299072265625,
        -4247.71484375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9230950474739075,
        0.0,
        0.3845720887184143
      ],
      "plane_d": 2041.401123046875,
      "bbox_min": [
        -3835.11669921875,
        -4969.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2317.299072265625,
        -4281.10009765625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9805806279182434,
        0.1961161345243454
      ],
      "plane_d": 4421.68212890625,
      "bbox_min": [
        -3835.11669921875,
        -4969.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2649.999755859375,
        -4281.10009765625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9805806279182434,
        -0.0,
        0.1961161345243454
      ],
      "plane_d": 3049.095458984375,
      "bbox_min": [
        -3744.11083984375,
        -4969.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2724.999755859375,
        -4719.7685546875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9805806279182434,
        0.1961161196231842
      ],
      "plane_d": 4529.54541015625,
      "bbox_min": [
        -3744.11083984375,
        -4879.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3549.999755859375,
        -4719.7685546875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9852399826049805,
        0.06568368524312973,
        0.158075749874115
      ],
      "plane_d": 3796.234375,
      "bbox_min": [
        -3744.11083984375,
        -4879.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3699.999755859375,
        -4719.7685546875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.982647716999054,
        0.0,
        0.1854814738035202
      ],
      "plane_d": 3440.55859375,
      "bbox_min": [
        -3733.237548828125,
        -4829.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3699.999755859375,
        -4719.7685546875,
        1228.687255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2799.999755859375,
      "bbox_min": [
        -3319.999755859375,
        -4952.2685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2724.999755859375,
        -4719.7685546875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6298324465751648,
        0.776731014251709,
        0.0
      ],
      "plane_d": 5581.65966796875,
      "bbox_min": [
        -3319.999755859375,
        -4939.7734375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2799.999755859375,
        -4719.7685546875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01227299403399229,
        0.9982650876045227,
        0.05758681520819664
      ],
      "plane_d": 4736.61279296875,
      "bbox_min": [
        -3319.999755859375,
        -4939.7734375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2879.999755859375,
        -4719.76904296875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9987815618515015,
        0.04934954270720482
      ],
      "plane_d": 4789.1611328125,
      "bbox_min": [
        -3319.999755859375,
        -4939.7734375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2879.999755859375,
        -4845.10693359375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9395509958267212,
        0.0,
        -0.3424091041088104
      ],
      "plane_d": 3458.78271484375,
      "bbox_min": [
        -3269.999755859375,
        -4939.7734375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2879.999755859375,
        -4847.01220703125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.003976684529334307,
        0.9978758096694946,
        0.06502450257539749
      ],
      "plane_d": 4751.76220703125,
      "bbox_min": [
        -3221.847900390625,
        -4859.59814453125,
        1290.53515625
      ],
      "bbox_max": [
        -3206.59619140625,
        -4858.7685546875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8958584666252136,
        -0.0,
        0.44433948397636414
      ],
      "plane_d": 2067.916015625,
      "bbox_min": [
        -3219.999755859375,
        -4939.7734375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2879.999755859375,
        -4847.01220703125,
        1302.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8406816720962524,
        0.5415297150611877,
        0.0
      ],
      "plane_d": 5333.830078125,
      "bbox_min": [
        -3219.999755859375,
        -4939.7734375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2936.17822265625,
        -4847.01220703125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314704895019531,
        -0.5555691123008728,
        0.0
      ],
      "plane_d": -17.6025390625,
      "bbox_min": [
        -3219.999755859375,
        -4904.10400390625,
        1052.5999755859375
      ],
      "bbox_max": [
        -2936.17822265625,
        -4847.01220703125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.006341905798763037,
        0.997999370098114,
        0.06290493160486221
      ],
      "plane_d": 4786.82275390625,
      "bbox_min": [
        -3210.992919921875,
        -4904.10400390625,
        1265.8883056640625
      ],
      "bbox_max": [
        -2936.17822265625,
        -4857.55078125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4297522008419037,
        0.0,
        -0.902946949005127
      ],
      "plane_d": 2545.216064453125,
      "bbox_min": [
        -3210.992919921875,
        -4904.10400390625,
        1290.53515625
      ],
      "bbox_max": [
        -2978.151611328125,
        -4858.7685546875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.003976684529334307,
        0.9978758096694946,
        0.06502450257539749
      ],
      "plane_d": 4751.76220703125,
      "bbox_min": [
        -3210.992919921875,
        -4859.537109375,
        1290.53515625
      ],
      "bbox_max": [
        -3185.6435546875,
        -4858.7685546875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.003976674750447273,
        0.9978757500648499,
        0.06502451002597809
      ],
      "plane_d": 4776.4169921875,
      "bbox_min": [
        -3014.35595703125,
        -4859.59814453125,
        1290.53515625
      ],
      "bbox_max": [
        -2978.151611328125,
        -4858.7685546875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9983217716217041,
        0.05791091546416283
      ],
      "plane_d": 4775.87841796875,
      "bbox_min": [
        -3219.999755859375,
        -4858.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2879.999755859375,
        -4845.10693359375,
        1290.53515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.006341905798763037,
        0.997999370098114,
        0.06290493160486221
      ],
      "plane_d": 4786.82275390625,
      "bbox_min": [
        -3219.999755859375,
        -4858.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2879.999755859375,
        -4845.10693359375,
        1290.53515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314704895019531,
        -0.5555691123008728,
        0.0
      ],
      "plane_d": -17.6025390625,
      "bbox_min": [
        -3219.999755859375,
        -4851.95458984375,
        1052.5999755859375
      ],
      "bbox_max": [
        -3216.216796875,
        -4845.10693359375,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8406816720962524,
        0.5415297150611877,
        0.0
      ],
      "plane_d": 5333.830078125,
      "bbox_min": [
        -3219.999755859375,
        -4851.95458984375,
        1128.6246337890625
      ],
      "bbox_max": [
        -3219.23583984375,
        -4850.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314704895019531,
        -0.5555691123008728,
        0.0
      ],
      "plane_d": -17.6025390625,
      "bbox_min": [
        -3219.999755859375,
        -4850.92236328125,
        1052.5999755859375
      ],
      "bbox_max": [
        -3119.999755859375,
        -4719.76904296875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3119.999755859375,
      "bbox_min": [
        -3219.999755859375,
        -4850.92236328125,
        1052.5999755859375
      ],
      "bbox_max": [
        -3119.999755859375,
        -4719.76904296875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8406816720962524,
        0.5415297150611877,
        0.0
      ],
      "plane_d": 5333.830078125,
      "bbox_min": [
        -3219.999755859375,
        -4850.92236328125,
        1149.93603515625
      ],
      "bbox_max": [
        -3219.900634765625,
        -4850.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1232.623779296875,
      "bbox_min": [
        -3039.36572265625,
        -4869.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2799.999755859375,
        -4719.7685546875,
        1232.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7012491822242737,
        0.7129162549972534,
        0.0
      ],
      "plane_d": 5496.15234375,
      "bbox_min": [
        -3039.36572265625,
        -4729.86767578125,
        1052.5999755859375
      ],
      "bbox_max": [
        -3029.098876953125,
        -4719.7685546875,
        1103.0936279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1232.623779296875,
      "bbox_min": [
        -2749.999755859375,
        -4952.2685546875,
        1232.623779296875
      ],
      "bbox_max": [
        -2724.999755859375,
        -4755.7734375,
        1232.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.980492353439331,
        -0.0,
        0.19655711948871613
      ],
      "plane_d": 3504.267333984375,
      "bbox_min": [
        -3835.11669921875,
        -4769.76904296875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2649.999755859375,
        -4281.10009765625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9428800940513611,
        0.2659531235694885,
        0.20061436295509338
      ],
      "plane_d": 4566.60009765625,
      "bbox_min": [
        -3835.11669921875,
        -4769.76904296875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2649.999755859375,
        -4281.10009765625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9413501620292664,
        0.2744533121585846,
        0.19630339741706848
      ],
      "plane_d": 4605.08056640625,
      "bbox_min": [
        -3835.11669921875,
        -4668.23779296875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3750.459716796875,
        -4549.7685546875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7741605639457703,
        -0.6014260649681091,
        0.19738803803920746
      ],
      "plane_d": 94.33433532714844,
      "bbox_min": [
        -3835.11669921875,
        -4769.76904296875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2649.999755859375,
        -4281.10009765625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.770168125629425,
        -0.6076056361198425,
        0.19405239820480347
      ],
      "plane_d": 56.47296142578125,
      "bbox_min": [
        -3835.11669921875,
        -4769.76904296875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2649.999755859375,
        -4281.10009765625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1373203992843628,
        0.9674778580665588,
        0.21243742108345032
      ],
      "plane_d": 4807.8193359375,
      "bbox_min": [
        -3789.732666015625,
        -4769.76904296875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2649.999755859375,
        -4281.10009765625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13673339784145355,
        0.9675556421279907,
        0.21246233582496643
      ],
      "plane_d": 4805.955078125,
      "bbox_min": [
        -3789.732666015625,
        -4769.76904296875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3699.999755859375,
        -4668.23779296875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.982647716999054,
        0.0,
        0.1854814738035202
      ],
      "plane_d": 3440.55859375,
      "bbox_min": [
        -3747.18896484375,
        -4769.76904296875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3699.999755859375,
        -4675.39990234375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9852399826049805,
        0.06568368524312973,
        0.158075749874115
      ],
      "plane_d": 3796.234375,
      "bbox_min": [
        -3747.18896484375,
        -4769.76904296875,
        1228.687255859375
      ],
      "bbox_max": [
        -3733.237548828125,
        -4723.5966796875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0003918238799087703,
        -0.0
      ],
      "plane_d": 3071.875244140625,
      "bbox_min": [
        -3704.081298828125,
        -4755.77392578125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2649.999755859375,
        -4281.10009765625,
        1232.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9734168648719788,
        0.0016828934894874692,
        0.22903460264205933
      ],
      "plane_d": 2789.064697265625,
      "bbox_min": [
        -3704.081298828125,
        -4730.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3070.03759765625,
        -4281.10009765625,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9734182953834534,
        0.0,
        0.22903494536876678
      ],
      "plane_d": 2781.445556640625,
      "bbox_min": [
        -3704.081298828125,
        -4730.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3116.6005859375,
        -4281.10009765625,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35422706604003906,
        -0.0,
        0.93515944480896
      ],
      "plane_d": 179.48388671875,
      "bbox_min": [
        -3704.081298828125,
        -4730.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3119.999755859375,
        -4281.10009765625,
        1116.0718994140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7175806760787964,
        0.6964753270149231,
        0.0
      ],
      "plane_d": 5525.79736328125,
      "bbox_min": [
        -3704.081298828125,
        -4580.0,
        1052.5999755859375
      ],
      "bbox_max": [
        -3417.0,
        -4281.10009765625,
        1114.8896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3349817395210266,
        0.32512935996055603,
        0.8843518495559692
      ],
      "plane_d": 1604.658203125,
      "bbox_min": [
        -3704.081298828125,
        -4580.0,
        1052.5999755859375
      ],
      "bbox_max": [
        -3417.0,
        -4281.10009765625,
        1114.8896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3349817395210266,
        -0.32512933015823364,
        0.8843517899513245
      ],
      "plane_d": -1308.3056640625,
      "bbox_min": [
        -3704.081298828125,
        -4580.0,
        1052.5999755859375
      ],
      "bbox_max": [
        -3417.0,
        -4281.10009765625,
        1114.8896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9805806279182434,
        -0.0,
        0.1961161345243454
      ],
      "plane_d": 3421.71630859375,
      "bbox_min": [
        -3704.081298828125,
        -4289.7998046875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3699.999755859375,
        -4281.10009765625,
        1073.0081787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3119.999755859375,
      "bbox_min": [
        -3119.999755859375,
        -4730.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3119.999755859375,
        -4679.7998046875,
        1116.0718994140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3119.999755859375,
      "bbox_min": [
        -3119.999755859375,
        -4730.7685546875,
        1116.0711669921875
      ],
      "bbox_max": [
        -3119.999755859375,
        -4679.7998046875,
        1117.5472412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9755594730377197,
        -0.00016128552670124918,
        0.21973522007465363
      ],
      "plane_d": 2798.13330078125,
      "bbox_min": [
        -3128.600341796875,
        -4730.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3070.03759765625,
        -4295.22607421875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        4.787071247847052e-06
      ],
      "plane_d": 3070.0947265625,
      "bbox_min": [
        -3119.999755859375,
        -4730.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3070.03759765625,
        -4529.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7012491822242737,
        0.7129162549972534,
        0.0
      ],
      "plane_d": 5496.15234375,
      "bbox_min": [
        -3119.999755859375,
        -4730.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3070.099853515625,
        -4629.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3119.999755859375,
      "bbox_min": [
        -3119.999755859375,
        -4730.7685546875,
        1117.1722412109375
      ],
      "bbox_max": [
        -3119.999755859375,
        -4679.7998046875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.980980634689331,
        -0.19410614669322968,
        0.0
      ],
      "plane_d": 2113.042236328125,
      "bbox_min": [
        -3080.0,
        -4679.7998046875,
        1101.623779296875
      ],
      "bbox_max": [
        -3070.10009765625,
        -4629.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7012491822242737,
        0.7129162549972534,
        0.0
      ],
      "plane_d": 5496.15234375,
      "bbox_min": [
        -3070.100341796875,
        -4689.5986328125,
        1052.5999755859375
      ],
      "bbox_max": [
        -3070.03759765625,
        -4529.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.700103759765625,
        0.0,
        0.7140412330627441
      ],
      "plane_d": 1362.783935546875,
      "bbox_min": [
        -3070.10009765625,
        -4629.7685546875,
        1101.585693359375
      ],
      "bbox_max": [
        -3070.061279296875,
        -4529.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2799.999755859375,
      "bbox_min": [
        -3070.100341796875,
        -4755.77392578125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2649.999755859375,
        -4281.93603515625,
        1232.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8064050674438477,
        0.5913636684417725
      ],
      "plane_d": 3077.1162109375,
      "bbox_min": [
        -3070.100341796875,
        -4755.7734375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2799.999755859375,
        -4319.7685546875,
        1232.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7012491822242737,
        0.7129162549972534,
        0.0
      ],
      "plane_d": 5496.15234375,
      "bbox_min": [
        -3070.063720703125,
        -4755.7734375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2799.999755859375,
        -4587.7509765625,
        1232.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.700103759765625,
        0.0,
        0.7140412330627441
      ],
      "plane_d": 1362.783935546875,
      "bbox_min": [
        -3070.063720703125,
        -4755.7734375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2799.999755859375,
        -4587.7509765625,
        1232.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6298324465751648,
        0.776731014251709,
        0.0
      ],
      "plane_d": 5581.65966796875,
      "bbox_min": [
        -3029.098876953125,
        -4739.77392578125,
        1103.0936279296875
      ],
      "bbox_max": [
        -3016.882080078125,
        -4729.86767578125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1092.623779296875,
      "bbox_min": [
        -3070.100341796875,
        -4623.67578125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2799.999755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.700103759765625,
        0.0,
        0.7140412330627441
      ],
      "plane_d": 1362.783935546875,
      "bbox_min": [
        -3070.100341796875,
        -4617.10205078125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2799.999755859375,
        -4441.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4529.7685546875,
      "bbox_min": [
        -3070.100341796875,
        -4529.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3020.100341796875,
        -4529.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2909.999755859375,
      "bbox_min": [
        -2909.999755859375,
        -4559.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2799.999755859375,
        -4441.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4559.7685546875,
      "bbox_min": [
        -2909.999755859375,
        -4559.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2799.999755859375,
        -4499.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4499.7685546875,
      "bbox_min": [
        -2909.999755859375,
        -4499.7685546875,
        1081.623779296875
      ],
      "bbox_max": [
        -2884.999755859375,
        -4499.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1122.623779296875,
      "bbox_min": [
        -3070.10009765625,
        -4623.67578125,
        1092.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.700103759765625,
        0.0,
        0.7140412330627441
      ],
      "plane_d": 1362.783935546875,
      "bbox_min": [
        -3070.10009765625,
        -4623.67578125,
        1092.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4529.7685546875,
      "bbox_min": [
        -3070.10009765625,
        -4529.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -3060.9208984375,
        -4529.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4319.7685546875,
      "bbox_min": [
        -2909.999755859375,
        -4559.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2909.999755859375,
      "bbox_min": [
        -2909.999755859375,
        -4559.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4441.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4529.7685546875,
      "bbox_min": [
        -2909.999755859375,
        -4559.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4499.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4559.7685546875,
      "bbox_min": [
        -2839.999755859375,
        -4559.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4559.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2884.999755859375,
      "bbox_min": [
        -2909.999755859375,
        -4529.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2884.999755859375,
        -4499.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4499.7685546875,
      "bbox_min": [
        -2909.999755859375,
        -4499.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2884.999755859375,
        -4499.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4609.7685546875,
      "bbox_min": [
        -2799.999755859375,
        -4755.77392578125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2649.999755859375,
        -4281.93603515625,
        1232.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1232.623779296875,
      "bbox_min": [
        -2749.999755859375,
        -4755.77392578125,
        1232.623779296875
      ],
      "bbox_max": [
        -2724.999755859375,
        -4609.7685546875,
        1232.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1122.623779296875,
      "bbox_min": [
        -2799.999755859375,
        -4559.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2654.999755859375,
        -4281.93603515625,
        1142.5771484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8944272398948669,
        0.0,
        0.44721361994743347
      ],
      "plane_d": 1971.0384521484375,
      "bbox_min": [
        -2799.999755859375,
        -4559.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2654.999755859375,
        -4281.93603515625,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 2739.999755859375,
      "bbox_min": [
        -2799.999755859375,
        -4559.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2739.999755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1092.623779296875,
      "bbox_min": [
        -2799.999755859375,
        -4559.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2749.999755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4559.7685546875,
      "bbox_min": [
        -2799.999755859375,
        -4559.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2749.999755859375,
        -4559.7685546875,
        1092.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2759.999755859375,
      "bbox_min": [
        -2769.999755859375,
        -4509.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2759.999755859375,
        -4469.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4469.7685546875,
      "bbox_min": [
        -2769.999755859375,
        -4469.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2759.999755859375,
        -4469.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 2739.999755859375,
      "bbox_min": [
        -2764.999755859375,
        -4559.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2654.999755859375,
        -4281.93603515625,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1092.623779296875,
      "bbox_min": [
        -2764.999755859375,
        -4559.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2739.999755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4319.7685546875,
      "bbox_min": [
        -2764.999755859375,
        -4559.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2739.999755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4559.7685546875,
      "bbox_min": [
        -2759.999755859375,
        -4559.7685546875,
        1092.6239013671875
      ],
      "bbox_max": [
        -2749.999755859375,
        -4559.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8651316165924072,
        -0.5015451312065125,
        0.0
      ],
      "plane_d": 165.22314453125,
      "bbox_min": [
        -2739.999755859375,
        -4372.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2654.999755859375,
        -4281.93603515625,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4319.7685546875,
      "bbox_min": [
        -2739.999755859375,
        -4319.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2695.29150390625,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4319.7685546875,
      "bbox_min": [
        -2695.29150390625,
        -4372.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2654.999755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        3.2572361305938102e-06,
        0.7071068286895752
      ],
      "plane_d": 1104.781005859375,
      "bbox_min": [
        -2684.999755859375,
        -4372.7685546875,
        1112.635009765625
      ],
      "bbox_max": [
        -2675.010986328125,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8651316165924072,
        -0.5015451312065125,
        0.0
      ],
      "plane_d": 165.22314453125,
      "bbox_min": [
        -2687.4853515625,
        -4306.30322265625,
        1122.623779296875
      ],
      "bbox_max": [
        -2683.28466796875,
        -4299.0576171875,
        1142.5771484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9867106676101685,
        -0.16248691082000732
      ],
      "plane_d": 4841.689453125,
      "bbox_min": [
        -2687.4853515625,
        -4871.623046875,
        1064.6016845703125
      ],
      "bbox_max": [
        -2317.299072265625,
        -4302.71533203125,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6954664587974548,
        0.6954793930053711,
        -0.18065086007118225
      ],
      "plane_d": 1779.1229248046875,
      "bbox_min": [
        -2542.700439453125,
        -4871.623046875,
        1067.623779296875
      ],
      "bbox_max": [
        -2359.095947265625,
        -4707.20947265625,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6954665780067444,
        0.6954795122146606,
        -0.1806500405073166
      ],
      "plane_d": 5159.08935546875,
      "bbox_min": [
        -2542.700439453125,
        -4871.623046875,
        1067.623779296875
      ],
      "bbox_max": [
        -2359.095947265625,
        -4707.20947265625,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1212.623779296875,
      "bbox_min": [
        -2542.700439453125,
        -4871.623046875,
        1117.623779296875
      ],
      "bbox_max": [
        -2375.77587890625,
        -4707.20947265625,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1177.623779296875,
      "bbox_min": [
        -2542.700439453125,
        -4871.623046875,
        1117.623779296875
      ],
      "bbox_max": [
        -2375.77587890625,
        -4707.20947265625,
        1212.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.6628224849700928,
        0.671963095664978,
        -0.3303511142730713
      ],
      "plane_d": 5276.6708984375,
      "bbox_min": [
        -2533.74755859375,
        -4836.640625,
        1117.623779296875
      ],
      "bbox_max": [
        -2452.15087890625,
        -4712.97314453125,
        1177.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.24429009854793549,
        0.9116978049278259,
        -0.33034735918045044
      ],
      "plane_d": 4160.25830078125,
      "bbox_min": [
        -2533.74755859375,
        -4832.58544921875,
        1117.623779296875
      ],
      "bbox_max": [
        -2501.044921875,
        -4806.65185546875,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7865133881568909,
        0.5997427105903625,
        -0.14732742309570312
      ],
      "plane_d": 4934.0263671875,
      "bbox_min": [
        -2459.641845703125,
        -4721.82568359375,
        1165.623779296875
      ],
      "bbox_max": [
        -2452.15087890625,
        -4712.97314453125,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2375.77587890625,
      "bbox_min": [
        -2484.2236328125,
        -4784.70458984375,
        1192.5999755859375
      ],
      "bbox_max": [
        -2375.77587890625,
        -4707.20947265625,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6937940120697021,
        0.7201735377311707,
        0.0
      ],
      "plane_d": 1686.3616943359375,
      "bbox_min": [
        -2484.2236328125,
        -4734.83251953125,
        1192.623779296875
      ],
      "bbox_max": [
        -2375.77587890625,
        -4707.20947265625,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6937940120697021,
        0.7201735377311707,
        -0.0
      ],
      "plane_d": 5058.2001953125,
      "bbox_min": [
        -2404.44921875,
        -4734.83251953125,
        1192.623779296875
      ],
      "bbox_max": [
        -2375.77587890625,
        -4707.20947265625,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1177.623779296875,
      "bbox_min": [
        -2399.216796875,
        -4728.32373046875,
        1177.623779296875
      ],
      "bbox_max": [
        -2359.095947265625,
        -4712.97265625,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -1177.6236572265625,
      "bbox_min": [
        -2500.903564453125,
        -4728.32373046875,
        1177.623779296875
      ],
      "bbox_max": [
        -2460.7822265625,
        -4712.97265625,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9100018739700317,
        -0.2505292296409607,
        -0.3303510546684265
      ],
      "plane_d": 1327.403076171875,
      "bbox_min": [
        -2687.4853515625,
        -4714.94970703125,
        1064.6016845703125
      ],
      "bbox_max": [
        -2317.299072265625,
        -4302.71533203125,
        1212.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6628224849700928,
        0.671963095664978,
        -0.3303511142730713
      ],
      "plane_d": 5064.130859375,
      "bbox_min": [
        -2687.4853515625,
        -4714.94970703125,
        1064.6016845703125
      ],
      "bbox_max": [
        -2317.299072265625,
        -4302.71533203125,
        1212.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6628224849700928,
        0.671963095664978,
        -0.3303511142730713
      ],
      "plane_d": 1842.814208984375,
      "bbox_min": [
        -2675.010986328125,
        -4714.94970703125,
        1097.7069091796875
      ],
      "bbox_max": [
        -2317.299072265625,
        -4350.705078125,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24428068101406097,
        0.9116998314857483,
        -0.33034878969192505
      ],
      "plane_d": 5241.79541015625,
      "bbox_min": [
        -2542.700439453125,
        -4714.94970703125,
        1117.623779296875
      ],
      "bbox_max": [
        -2317.299072265625,
        -4647.9140625,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9100018739700317,
        0.2505292296409607,
        -0.3303510546684265
      ],
      "plane_d": 3817.9130859375,
      "bbox_min": [
        -2542.700439453125,
        -4714.94970703125,
        1117.623779296875
      ],
      "bbox_max": [
        -2325.060791015625,
        -4647.9140625,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1177.623779296875,
      "bbox_min": [
        -2542.700439453125,
        -4712.97314453125,
        1157.623779296875
      ],
      "bbox_max": [
        -2470.485107421875,
        -4647.9140625,
        1177.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7162401676177979,
        0.6266971230506897,
        -0.3070029318332672
      ],
      "plane_d": 5074.39013671875,
      "bbox_min": [
        -2488.228759765625,
        -4691.23291015625,
        1157.623779296875
      ],
      "bbox_max": [
        -2477.03076171875,
        -4686.197265625,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1177.623779296875,
      "bbox_min": [
        -2483.222412109375,
        -4714.94970703125,
        1159.0247802734375
      ],
      "bbox_max": [
        -2325.060791015625,
        -4684.6162109375,
        1212.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7162401676177979,
        0.6266971230506897,
        -0.3070029318332672
      ],
      "plane_d": 5074.39013671875,
      "bbox_min": [
        -2483.222412109375,
        -4714.94970703125,
        1159.0247802734375
      ],
      "bbox_max": [
        -2458.901123046875,
        -4689.19775390625,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7865133881568909,
        0.5997427105903625,
        -0.14732742309570312
      ],
      "plane_d": 4934.0263671875,
      "bbox_min": [
        -2477.03076171875,
        -4714.94970703125,
        1165.623779296875
      ],
      "bbox_max": [
        -2458.901123046875,
        -4689.19775390625,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4703.9345703125,
      "bbox_min": [
        -2458.969482421875,
        -4710.50341796875,
        1181.2305908203125
      ],
      "bbox_max": [
        -2401.030029296875,
        -4697.26611328125,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1212.623779296875,
      "bbox_min": [
        -2458.969482421875,
        -4710.50341796875,
        1192.623779296875
      ],
      "bbox_max": [
        -2401.030029296875,
        -4703.9345703125,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6937940120697021,
        0.7201735377311707,
        -0.0
      ],
      "plane_d": 5058.2001953125,
      "bbox_min": [
        -2458.969482421875,
        -4710.50341796875,
        1192.623779296875
      ],
      "bbox_max": [
        -2401.030029296875,
        -4703.9345703125,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6937940120697021,
        0.7201735377311707,
        0.0
      ],
      "plane_d": 1686.3616943359375,
      "bbox_min": [
        -2458.969482421875,
        -4710.50341796875,
        1192.623779296875
      ],
      "bbox_max": [
        -2452.15087890625,
        -4703.9345703125,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8630385398864746,
        0.5051382780075073
      ],
      "plane_d": 3457.23681640625,
      "bbox_min": [
        -2452.15087890625,
        -4703.9345703125,
        1181.2305908203125
      ],
      "bbox_max": [
        -2407.8486328125,
        -4697.26611328125,
        1192.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24429009854793549,
        0.9116978049278259,
        -0.33034735918045044
      ],
      "plane_d": 4054.558349609375,
      "bbox_min": [
        -2381.70751953125,
        -4699.79443359375,
        1117.623779296875
      ],
      "bbox_max": [
        -2317.299072265625,
        -4647.9140625,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1177.623779296875,
      "bbox_min": [
        -2381.70751953125,
        -4699.79443359375,
        1177.623779296875
      ],
      "bbox_max": [
        -2317.299072265625,
        -4647.9140625,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        3.2572361305938102e-06,
        0.7071068286895752
      ],
      "plane_d": 1104.781005859375,
      "bbox_min": [
        -2675.010986328125,
        -4372.7685546875,
        1097.7069091796875
      ],
      "bbox_max": [
        -2660.082763671875,
        -4350.705078125,
        1112.6351318359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        3.2572361305938102e-06,
        0.7071068286895752
      ],
      "plane_d": 1104.781005859375,
      "bbox_min": [
        -2687.4853515625,
        -4372.7685546875,
        1064.6016845703125
      ],
      "bbox_max": [
        -2654.999755859375,
        -4302.71533203125,
        1152.259033203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4319.7685546875,
      "bbox_min": [
        -2675.010986328125,
        -4319.7685546875,
        1064.6016845703125
      ],
      "bbox_max": [
        -2654.999755859375,
        -4319.7685546875,
        1112.635009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8651316165924072,
        -0.5015451312065125,
        0.0
      ],
      "plane_d": 165.22314453125,
      "bbox_min": [
        -2687.4853515625,
        -4306.30322265625,
        1137.584228515625
      ],
      "bbox_max": [
        -2685.4052734375,
        -4302.71533203125,
        1152.259033203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.000566598610021174,
        0.9717413783073425,
        0.23604734241962433
      ],
      "plane_d": 3914.062255859375,
      "bbox_min": [
        -3827.165283203125,
        -4342.15087890625,
        1052.5999755859375
      ],
      "bbox_max": [
        -2666.06884765625,
        -4247.71484375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.770168125629425,
        -0.6076056361198425,
        0.19405239820480347
      ],
      "plane_d": 56.47296142578125,
      "bbox_min": [
        -3827.165283203125,
        -4342.15087890625,
        1099.5777587890625
      ],
      "bbox_max": [
        -2680.017822265625,
        -4293.42236328125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8651316165924072,
        -0.5015451312065125,
        0.0
      ],
      "plane_d": 165.22314453125,
      "bbox_min": [
        -2687.4853515625,
        -4306.30322265625,
        1099.5777587890625
      ],
      "bbox_max": [
        -2680.017822265625,
        -4293.42236328125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9805806279182434,
        -0.0,
        0.1961161345243454
      ],
      "plane_d": 3421.71630859375,
      "bbox_min": [
        -3827.1015625,
        -4342.06982421875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2666.06884765625,
        -4247.71484375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.770168125629425,
        -0.6076056361198425,
        0.19405239820480347
      ],
      "plane_d": 56.47296142578125,
      "bbox_min": [
        -3827.1015625,
        -4342.06982421875,
        1073.0491943359375
      ],
      "bbox_max": [
        -3725.0927734375,
        -4247.82763671875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9734168648719788,
        0.0016828934894874692,
        0.22903460264205933
      ],
      "plane_d": 2789.064697265625,
      "bbox_min": [
        -3118.603759765625,
        -4295.22607421875,
        1101.623779296875
      ],
      "bbox_max": [
        -3117.009033203125,
        -4259.19970703125,
        1108.4144287109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4239.7685546875,
      "bbox_min": [
        -3752.752197265625,
        -4247.82861328125,
        1052.5999755859375
      ],
      "bbox_max": [
        -3046.499755859375,
        -3935.422119140625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9805806279182434,
        -0.0,
        0.1961161345243454
      ],
      "plane_d": 3421.71630859375,
      "bbox_min": [
        -3752.752197265625,
        -4247.82861328125,
        1052.5999755859375
      ],
      "bbox_max": [
        -3699.999755859375,
        -4239.7685546875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.770168125629425,
        -0.6076056361198425,
        0.19405239820480347
      ],
      "plane_d": 56.47296142578125,
      "bbox_min": [
        -3752.752197265625,
        -4247.82861328125,
        1283.418701171875
      ],
      "bbox_max": [
        -3747.91845703125,
        -4244.33984375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6399935483932495,
        -0.7400472164154053,
        0.20673252642154694
      ],
      "plane_d": -1128.05810546875,
      "bbox_min": [
        -3749.999755859375,
        -4239.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3348.9013671875,
        -3935.422119140625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9805806279182434,
        -0.0,
        0.1961161345243454
      ],
      "plane_d": 3421.71630859375,
      "bbox_min": [
        -3749.999755859375,
        -4239.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3348.9013671875,
        -3935.422119140625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.202193021774292,
        0.9521721005439758,
        0.22909876704216003
      ],
      "plane_d": 4294.4814453125,
      "bbox_min": [
        -3549.999755859375,
        -4192.001953125,
        1052.5999755859375
      ],
      "bbox_max": [
        -3348.9013671875,
        -3935.422119140625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7012690901756287,
        0.7012708783149719,
        0.12822175025939941
      ],
      "plane_d": 5107.23486328125,
      "bbox_min": [
        -3442.946533203125,
        -4192.001953125,
        1052.5999755859375
      ],
      "bbox_max": [
        -3348.9013671875,
        -4032.349609375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9412570595741272,
        -0.14917725324630737,
        0.30295413732528687
      ],
      "plane_d": 2217.72314453125,
      "bbox_min": [
        -3430.738037109375,
        -4192.001953125,
        1052.5999755859375
      ],
      "bbox_max": [
        -3348.9013671875,
        -4096.39453125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 5385.869140625,
      "bbox_min": [
        -3430.738037109375,
        -4192.001953125,
        1052.5999755859375
      ],
      "bbox_max": [
        -3424.76611328125,
        -4186.0302734375,
        1092.4654541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6948639154434204,
        -0.6925082802772522,
        0.19389794766902924
      ],
      "plane_d": -604.1531372070312,
      "bbox_min": [
        -3549.999755859375,
        -4069.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3386.928466796875,
        -3935.422119140625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6449734568595886,
        -0.7364493012428284,
        0.20408721268177032
      ],
      "plane_d": -1092.6890869140625,
      "bbox_min": [
        -3502.01513671875,
        -4239.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3376.999755859375,
        -4126.103515625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 5385.869140625,
      "bbox_min": [
        -3430.738037109375,
        -4239.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3376.999755859375,
        -4186.0302734375,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660281896591187,
        -0.4999951720237732,
        0.0
      ],
      "plane_d": 217.953369140625,
      "bbox_min": [
        -3416.10888671875,
        -4470.28857421875,
        1052.5999755859375
      ],
      "bbox_max": [
        -1846.745361328125,
        -3368.7841796875,
        1302.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9643577337265015,
        -0.2646018862724304,
        0.0
      ],
      "plane_d": 1616.414306640625,
      "bbox_min": [
        -3416.10888671875,
        -4027.424560546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2457.470458984375,
        -3368.7841796875,
        1302.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9875902533531189,
        -0.10195229202508926,
        0.11946217715740204
      ],
      "plane_d": 2521.177490234375,
      "bbox_min": [
        -3416.10888671875,
        -3984.973388671875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2737.60302734375,
        -3368.7841796875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9767470955848694,
        0.034353528171777725,
        0.2116248458623886
      ],
      "plane_d": 2855.7041015625,
      "bbox_min": [
        -3416.10888671875,
        -3984.973388671875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3031.9140625,
        -3368.7841796875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6948639154434204,
        -0.6925082802772522,
        0.19389794766902924
      ],
      "plane_d": -604.1531372070312,
      "bbox_min": [
        -3416.10888671875,
        -3948.4140625,
        1052.5999755859375
      ],
      "bbox_max": [
        -3083.144287109375,
        -3820.448974609375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1079990342259407,
        0.9941510558128357,
        0.0
      ],
      "plane_d": 3547.587646484375,
      "bbox_min": [
        -3086.49267578125,
        -3903.7587890625,
        1052.5999755859375
      ],
      "bbox_max": [
        -3083.144287109375,
        -3903.39501953125,
        1079.9710693359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9959433078765869,
        -0.08998323231935501,
        8.233218250097707e-05
      ],
      "plane_d": 2717.095458984375,
      "bbox_min": [
        -3110.8232421875,
        -3943.19287109375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2737.60302734375,
        -3580.0,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9951902031898499,
        -0.04628791660070419,
        0.08633600920438766
      ],
      "plane_d": 2787.013916015625,
      "bbox_min": [
        -3110.8232421875,
        -3943.19287109375,
        1052.5999755859375
      ],
      "bbox_max": [
        -3065.32470703125,
        -3580.0,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39677491784095764,
        -0.917915940284729,
        0.0
      ],
      "plane_d": -2385.22314453125,
      "bbox_min": [
        -3110.8232421875,
        -3943.19287109375,
        1052.5999755859375
      ],
      "bbox_max": [
        -3077.04150390625,
        -3860.439453125,
        1280.1251220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10799902677536011,
        0.9941509962081909,
        0.0
      ],
      "plane_d": 3547.587646484375,
      "bbox_min": [
        -3086.49267578125,
        -3903.7587890625,
        1052.5999755859375
      ],
      "bbox_max": [
        -3077.04150390625,
        -3860.439453125,
        1187.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1072.5999755859375,
      "bbox_min": [
        -3079.06787109375,
        -3880.383056640625,
        1052.5999755859375
      ],
      "bbox_max": [
        -3077.043212890625,
        -3860.439453125,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08715634047985077,
        -0.9961945414543152,
        -0.0
      ],
      "plane_d": -4133.95703125,
      "bbox_min": [
        -3079.06787109375,
        -3880.383056640625,
        1052.5999755859375
      ],
      "bbox_max": [
        -3078.841552734375,
        -3880.36328125,
        1072.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9927711486816406,
        0.04754962772130966,
        0.11020220816135406
      ],
      "plane_d": 3104.564453125,
      "bbox_min": [
        -3094.6171875,
        -3936.187744140625,
        1052.5999755859375
      ],
      "bbox_max": [
        -3065.32470703125,
        -3730.780029296875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39677491784095764,
        -0.917915940284729,
        0.0
      ],
      "plane_d": -2385.22314453125,
      "bbox_min": [
        -3094.6171875,
        -3936.187744140625,
        1139.7886962890625
      ],
      "bbox_max": [
        -3080.906005859375,
        -3903.15185546875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10799902677536011,
        0.9941509962081909,
        0.0
      ],
      "plane_d": 3547.587646484375,
      "bbox_min": [
        -3085.076904296875,
        -3903.60498046875,
        1139.7886962890625
      ],
      "bbox_max": [
        -3080.906005859375,
        -3903.15185546875,
        1187.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10800012946128845,
        0.9941508769989014,
        0.0
      ],
      "plane_d": 3547.583740234375,
      "bbox_min": [
        -3080.91015625,
        -3903.15234375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2737.60302734375,
        -3837.14013671875,
        1226.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.7476187348365784,
        0.6641281843185425,
        -0.0
      ],
      "plane_d": 4615.8681640625,
      "bbox_min": [
        -3039.767822265625,
        -3902.659423828125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2737.60302734375,
        -3866.09033203125,
        1226.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.10799754410982132,
        0.9941511750221252,
        0.0
      ],
      "plane_d": 3551.5927734375,
      "bbox_min": [
        -3039.767822265625,
        -3902.659423828125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2768.421630859375,
        -3869.205078125,
        1226.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9781494736671448,
        0.207903191447258,
        0.0
      ],
      "plane_d": -1903.510009765625,
      "bbox_min": [
        -2769.858154296875,
        -3875.96337890625,
        1203.623779296875
      ],
      "bbox_max": [
        -2769.29736328125,
        -3873.324462890625,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9941539168357849,
        -0.1079726293683052,
        0.0
      ],
      "plane_d": -3414.947998046875,
      "bbox_min": [
        -3039.767822265625,
        -3902.659423828125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2768.421630859375,
        -3869.205078125,
        1226.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9781494736671448,
        0.207903191447258,
        0.0
      ],
      "plane_d": -1903.510009765625,
      "bbox_min": [
        -2769.29736328125,
        -3873.324462890625,
        1203.623779296875
      ],
      "bbox_max": [
        -2768.421630859375,
        -3869.205078125,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9941473603248596,
        0.1080329641699791,
        -0.0
      ],
      "plane_d": 3443.163330078125,
      "bbox_min": [
        -3039.767822265625,
        -3902.659423828125,
        1052.5999755859375
      ],
      "bbox_max": [
        -3039.335693359375,
        -3898.682861328125,
        1187.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9963374137878418,
        0.08550950139760971,
        0.0
      ],
      "plane_d": -2499.986083984375,
      "bbox_min": [
        -3078.84326171875,
        -3882.977783203125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2739.749755859375,
        -3837.14013671875,
        1226.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.41285187005996704,
        0.910798192024231,
        0.0
      ],
      "plane_d": 2331.511962890625,
      "bbox_min": [
        -2839.33056640625,
        -3869.205078125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2739.749755859375,
        -3837.14013671875,
        1226.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7476187348365784,
        0.6641281843185425,
        -0.0
      ],
      "plane_d": 4615.8681640625,
      "bbox_min": [
        -2817.8349609375,
        -3869.205078125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2739.749755859375,
        -3837.14013671875,
        1226.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.20791609585285187,
        0.9781466722488403,
        -0.0
      ],
      "plane_d": 4339.15869140625,
      "bbox_min": [
        -2817.8349609375,
        -3869.205078125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2753.277099609375,
        -3837.14013671875,
        1226.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.9781447649002075,
        -0.2079254388809204,
        0.0
      ],
      "plane_d": 1947.4112548828125,
      "bbox_min": [
        -2812.896728515625,
        -3869.205078125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2764.036865234375,
        -3839.42724609375,
        1226.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9781488180160522,
        0.20790594816207886,
        0.0
      ],
      "plane_d": -1903.497802734375,
      "bbox_min": [
        -2809.5703125,
        -3869.205078125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2764.036865234375,
        -3848.5751953125,
        1226.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.2079077512025833,
        0.9781485199928284,
        -0.0
      ],
      "plane_d": 4351.14306640625,
      "bbox_min": [
        -2809.5703125,
        -3860.31298828125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2766.53173828125,
        -3851.1650390625,
        1203.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1072.5999755859375,
      "bbox_min": [
        -3078.84326171875,
        -3882.977783203125,
        1052.5999755859375
      ],
      "bbox_max": [
        -3047.438720703125,
        -3860.464111328125,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08714968711137772,
        0.9961952567100525,
        0.0
      ],
      "plane_d": 4113.939453125,
      "bbox_min": [
        -3078.84326171875,
        -3882.977783203125,
        1052.5999755859375
      ],
      "bbox_max": [
        -3047.438720703125,
        -3860.464111328125,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08715798705816269,
        -0.9961945414543152,
        0.0
      ],
      "plane_d": -4115.9619140625,
      "bbox_min": [
        -3078.84326171875,
        -3882.977783203125,
        1052.5999755859375
      ],
      "bbox_max": [
        -3047.438720703125,
        -3862.60595703125,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9961944818496704,
        -0.08715847134590149,
        0.0
      ],
      "plane_d": 2699.143798828125,
      "bbox_min": [
        -3047.613037109375,
        -3865.04638671875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3047.438720703125,
        -3863.053955078125,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1070.5999755859375,
      "bbox_min": [
        -3078.84326171875,
        -3882.977783203125,
        1052.5999755859375
      ],
      "bbox_max": [
        -3047.613037109375,
        -3862.60595703125,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08714968711137772,
        -0.9961951971054077,
        0.00011490872566355392
      ],
      "plane_d": -4134.06201171875,
      "bbox_min": [
        -3078.84326171875,
        -3882.977783203125,
        1070.5999755859375
      ],
      "bbox_max": [
        -3047.613037109375,
        -3865.04638671875,
        1072.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9961944818496704,
        -0.08715847134590149,
        0.0
      ],
      "plane_d": 2699.143798828125,
      "bbox_min": [
        -3049.181884765625,
        -3882.977783203125,
        1070.5999755859375
      ],
      "bbox_max": [
        -3047.613037109375,
        -3865.04638671875,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.99619460105896,
        0.08715753257274628,
        0.0
      ],
      "plane_d": -2701.14794921875,
      "bbox_min": [
        -3078.8427734375,
        -3882.977783203125,
        1052.5999755859375
      ],
      "bbox_max": [
        -3047.613037109375,
        -3862.60595703125,
        1070.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9961944818496704,
        -0.08715847134590149,
        0.0
      ],
      "plane_d": 2699.143798828125,
      "bbox_min": [
        -3051.17431640625,
        -3882.977783203125,
        1052.5999755859375
      ],
      "bbox_max": [
        -3047.613037109375,
        -3865.04638671875,
        1070.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08703521639108658,
        -0.9962052702903748,
        -0.0
      ],
      "plane_d": -4133.62939453125,
      "bbox_min": [
        -3051.17431640625,
        -3882.977783203125,
        1052.5999755859375
      ],
      "bbox_max": [
        -3049.181884765625,
        -3882.8037109375,
        1070.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.99619460105896,
        -0.08715753257274628,
        0.0
      ],
      "plane_d": 2727.14794921875,
      "bbox_min": [
        -3078.8427734375,
        -3880.53759765625,
        1052.5999755859375
      ],
      "bbox_max": [
        -3055.931396484375,
        -3862.60595703125,
        1070.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08715634047985077,
        -0.9961945414543152,
        -0.0
      ],
      "plane_d": -4133.95703125,
      "bbox_min": [
        -3078.8427734375,
        -3880.53759765625,
        1052.5999755859375
      ],
      "bbox_max": [
        -3077.075439453125,
        -3880.383056640625,
        1070.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1066.5999755859375,
      "bbox_min": [
        -3076.378173828125,
        -3874.31103515625,
        1052.5999755859375
      ],
      "bbox_max": [
        -3055.931396484375,
        -3866.5908203125,
        1070.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08715847134590149,
        -0.9961944818496704,
        0.0
      ],
      "plane_d": -4125.96337890625,
      "bbox_min": [
        -3076.378173828125,
        -3874.31103515625,
        1066.5999755859375
      ],
      "bbox_max": [
        -3055.931396484375,
        -3866.5908203125,
        1070.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08715847134590149,
        0.9961944818496704,
        0.0
      ],
      "plane_d": 4119.96337890625,
      "bbox_min": [
        -3075.855224609375,
        -3874.31103515625,
        1066.5999755859375
      ],
      "bbox_max": [
        -3055.931396484375,
        -3866.5908203125,
        1070.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9961944222450256,
        -0.0871598869562149,
        0.0
      ],
      "plane_d": 2707.13818359375,
      "bbox_min": [
        -3056.454345703125,
        -3874.31103515625,
        1066.5999755859375
      ],
      "bbox_max": [
        -3055.931396484375,
        -3868.333984375,
        1070.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1054.5999755859375,
      "bbox_min": [
        -3076.378173828125,
        -3874.31103515625,
        1052.5999755859375
      ],
      "bbox_max": [
        -3055.931396484375,
        -3866.5908203125,
        1054.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08715847134590149,
        -0.9961944818496704,
        0.0
      ],
      "plane_d": -4125.96337890625,
      "bbox_min": [
        -3076.378173828125,
        -3874.31103515625,
        1052.5999755859375
      ],
      "bbox_max": [
        -3055.931396484375,
        -3866.5908203125,
        1054.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08715847134590149,
        0.9961944818496704,
        0.0
      ],
      "plane_d": 4119.96337890625,
      "bbox_min": [
        -3075.855224609375,
        -3874.31103515625,
        1052.5999755859375
      ],
      "bbox_max": [
        -3055.931396484375,
        -3866.5908203125,
        1054.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9961944222450256,
        -0.0871598869562149,
        0.0
      ],
      "plane_d": 2707.13818359375,
      "bbox_min": [
        -3056.454345703125,
        -3874.31103515625,
        1052.5999755859375
      ],
      "bbox_max": [
        -3055.931396484375,
        -3868.333984375,
        1054.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10253556817770004,
        0.17759636044502258,
        0.9787472486495972
      ],
      "plane_d": -99.72515869140625,
      "bbox_min": [
        -2745.6064453125,
        -4027.424560546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2457.470458984375,
        -3820.558349609375,
        1194.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8662337064743042,
        0.49963513016700745,
        -0.0020118579268455505
      ],
      "plane_d": -217.8153076171875,
      "bbox_min": [
        -2745.6064453125,
        -4027.424560546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2457.556396484375,
        -3820.558349609375,
        1102.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8743014931678772,
        0.48538345098495483,
        0.0
      ],
      "plane_d": 4172.6533203125,
      "bbox_min": [
        -2574.9619140625,
        -4023.960693359375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2536.157470703125,
        -3956.8662109375,
        1101.79833984375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.01678922399878502,
        -0.999859094619751,
        0.0
      ],
      "plane_d": -3960.440673828125,
      "bbox_min": [
        -2574.9619140625,
        -4023.960693359375,
        1082.623779296875
      ],
      "bbox_max": [
        -2563.375,
        -4004.0419921875,
        1101.79833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.499998539686203,
        0.8660262227058411,
        -0.0
      ],
      "plane_d": 4772.2890625,
      "bbox_min": [
        -2574.9619140625,
        -4023.960693359375,
        1101.0238037109375
      ],
      "bbox_max": [
        -2574.874755859375,
        -4023.910400390625,
        1101.79833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1070.5999755859375,
      "bbox_min": [
        -2546.923828125,
        -3975.4541015625,
        1052.5999755859375
      ],
      "bbox_max": [
        -2536.157470703125,
        -3956.8662109375,
        1070.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4694700837135315,
        -0.8829484581947327,
        2.9206510134827113e-06
      ],
      "plane_d": -4684.39111328125,
      "bbox_min": [
        -2546.923828125,
        -3975.4541015625,
        1052.5999755859375
      ],
      "bbox_max": [
        -2536.157470703125,
        -3956.8662109375,
        1070.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4694770574569702,
        0.882944643497467,
        -1.0499577001610305e-05
      ],
      "plane_d": 4705.81396484375,
      "bbox_min": [
        -2546.923828125,
        -3975.4541015625,
        1052.5999755859375
      ],
      "bbox_max": [
        -2546.869873046875,
        -3975.42529296875,
        1070.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999997913837433,
        0.8660256266593933,
        0.0
      ],
      "plane_d": 4752.2900390625,
      "bbox_min": [
        -2745.6064453125,
        -4023.9111328125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2556.205322265625,
        -3897.67578125,
        1101.7984619140625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8660260438919067,
        -0.49999895691871643,
        0.0
      ],
      "plane_d": 222.9329833984375,
      "bbox_min": [
        -2596.52587890625,
        -4023.9111328125,
        1082.623779296875
      ],
      "bbox_max": [
        -2569.205322265625,
        -3994.139892578125,
        1101.7984619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660260438919067,
        0.49999895691871643,
        0.0
      ],
      "plane_d": -242.932861328125,
      "bbox_min": [
        -2596.52587890625,
        -4011.46044921875,
        1082.623779296875
      ],
      "bbox_max": [
        -2586.52587890625,
        -3994.139892578125,
        1101.7984619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.499998539686203,
        0.8660262227058411,
        -0.0
      ],
      "plane_d": 4772.2890625,
      "bbox_min": [
        -2579.205322265625,
        -4023.9111328125,
        1101.0238037109375
      ],
      "bbox_max": [
        -2574.960693359375,
        -4021.46044921875,
        1101.79833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000014901161194,
        0.8660245537757874,
        0.0
      ],
      "plane_d": 4746.2900390625,
      "bbox_min": [
        -2745.6064453125,
        -4004.139892578125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2556.205322265625,
        -3897.67578125,
        1097.6080322265625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.49999991059303284,
        0.8660255670547485,
        0.0
      ],
      "plane_d": 4748.2900390625,
      "bbox_min": [
        -2745.6064453125,
        -4004.139892578125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2563.458251953125,
        -3897.67578125,
        1097.6080322265625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.25882238149642944,
        0.9659250378608704,
        0.0
      ],
      "plane_d": 3174.44677734375,
      "bbox_min": [
        -2643.68359375,
        -4004.139892578125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2563.458251953125,
        -3957.67578125,
        1097.6080322265625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.01678922399878502,
        -0.999859094619751,
        0.0
      ],
      "plane_d": -3960.440673828125,
      "bbox_min": [
        -2569.205322265625,
        -4004.139892578125,
        1082.623779296875
      ],
      "bbox_max": [
        -2563.458251953125,
        -4004.04345703125,
        1097.6080322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660209774971008,
        -0.5000077486038208,
        0.0
      ],
      "plane_d": 308.884765625,
      "bbox_min": [
        -2643.68359375,
        -3961.139892578125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2641.68359375,
        -3957.67578125,
        1097.6080322265625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.25882238149642944,
        0.9659250378608704,
        0.0
      ],
      "plane_d": 3174.44677734375,
      "bbox_min": [
        -2695.376953125,
        -3982.67578125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2595.650146484375,
        -3924.94384765625,
        1096.7698974609375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660209774971008,
        -0.5000077486038208,
        0.0
      ],
      "plane_d": 308.884765625,
      "bbox_min": [
        -2695.376953125,
        -3957.67578125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2640.68359375,
        -3924.94384765625,
        1096.7698974609375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.866010844707489,
        0.5000253915786743,
        0.0
      ],
      "plane_d": -370.7880859375,
      "bbox_min": [
        -2695.376953125,
        -3926.67578125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2694.376953125,
        -3924.94384765625,
        1096.7698974609375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4999989867210388,
        0.8660261034965515,
        0.0
      ],
      "plane_d": 4732.2900390625,
      "bbox_min": [
        -2595.650146484375,
        -3991.900146484375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2556.205322265625,
        -3975.623291015625,
        1096.350830078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.25882238149642944,
        0.9659250378608704,
        0.0
      ],
      "plane_d": 3174.44677734375,
      "bbox_min": [
        -2595.650146484375,
        -3991.900146484375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2556.384521484375,
        -3976.8193359375,
        1096.350830078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8743014931678772,
        0.48538345098495483,
        0.0
      ],
      "plane_d": 4172.6533203125,
      "bbox_min": [
        -2559.205322265625,
        -3991.900146484375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2556.384521484375,
        -3986.8193359375,
        1094.033447265625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.49999895691871643,
        0.8660260438919067,
        0.0
      ],
      "plane_d": 4726.28955078125,
      "bbox_min": [
        -2569.59765625,
        -3986.8193359375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2556.205322265625,
        -3975.623291015625,
        1093.4176025390625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660209774971008,
        0.5000077486038208,
        0.0
      ],
      "plane_d": -234.8848876953125,
      "bbox_min": [
        -2569.59765625,
        -3986.8193359375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2556.205322265625,
        -3975.623291015625,
        1093.4176025390625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660209774971008,
        -0.5000077486038208,
        0.0
      ],
      "plane_d": 222.8848876953125,
      "bbox_min": [
        -2559.205322265625,
        -3986.8193359375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2556.205322265625,
        -3981.623291015625,
        1093.4176025390625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4999997615814209,
        0.8660255670547485,
        -0.0
      ],
      "plane_d": 4752.28955078125,
      "bbox_min": [
        -2745.6064453125,
        -4023.960693359375,
        1092.160400390625
      ],
      "bbox_max": [
        -2556.205322265625,
        -3897.67578125,
        1194.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660260438919067,
        -0.49999895691871643,
        0.0
      ],
      "plane_d": 222.9329833984375,
      "bbox_min": [
        -2596.52587890625,
        -4023.960693359375,
        1097.6080322265625
      ],
      "bbox_max": [
        -2564.875,
        -3994.139892578125,
        1194.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660260438919067,
        0.49999895691871643,
        0.0
      ],
      "plane_d": -242.932861328125,
      "bbox_min": [
        -2596.52587890625,
        -4011.46044921875,
        1097.6080322265625
      ],
      "bbox_max": [
        -2586.52587890625,
        -3994.139892578125,
        1187.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.499998539686203,
        0.8660262227058411,
        -0.0
      ],
      "plane_d": 4772.2890625,
      "bbox_min": [
        -2579.205322265625,
        -4023.960693359375,
        1101.79833984375
      ],
      "bbox_max": [
        -2564.875,
        -4004.139892578125,
        1142.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1104.623779296875,
      "bbox_min": [
        -2579.205322265625,
        -4023.96044921875,
        1104.623779296875
      ],
      "bbox_max": [
        -2564.875,
        -4004.139892578125,
        1104.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49999988079071045,
        0.8660255074501038,
        -0.0
      ],
      "plane_d": 4748.28955078125,
      "bbox_min": [
        -2745.6064453125,
        -4006.64013671875,
        1092.160400390625
      ],
      "bbox_max": [
        -2556.205322265625,
        -3897.67578125,
        1194.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866020917892456,
        -0.5000077486038208,
        0.0
      ],
      "plane_d": 308.884765625,
      "bbox_min": [
        -2643.68359375,
        -4006.64013671875,
        1096.769775390625
      ],
      "bbox_max": [
        -2563.375,
        -3957.67578125,
        1194.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25882238149642944,
        0.9659249782562256,
        0.0
      ],
      "plane_d": 3174.446533203125,
      "bbox_min": [
        -2603.84619140625,
        -4006.64013671875,
        1096.769775390625
      ],
      "bbox_max": [
        -2563.375,
        -3982.67578125,
        1194.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.01678922399878502,
        -0.999859094619751,
        0.0
      ],
      "plane_d": -3960.440673828125,
      "bbox_min": [
        -2569.205322265625,
        -4006.64013671875,
        1096.9793701171875
      ],
      "bbox_max": [
        -2563.375,
        -4004.0419921875,
        1194.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1142.623779296875,
      "bbox_min": [
        -2569.205322265625,
        -4006.64013671875,
        1104.623779296875
      ],
      "bbox_max": [
        -2563.375,
        -4004.0419921875,
        1142.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1104.623779296875,
      "bbox_min": [
        -2569.205322265625,
        -4006.64013671875,
        1104.623779296875
      ],
      "bbox_max": [
        -2563.375,
        -4004.0419921875,
        1104.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000015497207642,
        0.8660246133804321,
        -0.0
      ],
      "plane_d": 4746.29052734375,
      "bbox_min": [
        -2695.376953125,
        -3991.91748046875,
        1092.160400390625
      ],
      "bbox_max": [
        -2556.205322265625,
        -3924.94384765625,
        1172.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866020917892456,
        -0.5000077486038208,
        0.0
      ],
      "plane_d": 308.884765625,
      "bbox_min": [
        -2695.376953125,
        -3982.67578125,
        1096.350830078125
      ],
      "bbox_max": [
        -2595.650634765625,
        -3924.94384765625,
        1172.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660107851028442,
        0.5000253915786743,
        0.0
      ],
      "plane_d": -370.7879638671875,
      "bbox_min": [
        -2695.376953125,
        -3926.67578125,
        1096.350830078125
      ],
      "bbox_max": [
        -2694.376953125,
        -3924.94384765625,
        1172.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25882238149642944,
        0.9659249782562256,
        0.0
      ],
      "plane_d": 3174.446533203125,
      "bbox_min": [
        -2598.382080078125,
        -3982.67578125,
        1096.350830078125
      ],
      "bbox_max": [
        -2595.650634765625,
        -3981.94384765625,
        1166.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49999895691871643,
        0.8660260438919067,
        -0.0
      ],
      "plane_d": 4732.2890625,
      "bbox_min": [
        -2595.650634765625,
        -3991.91748046875,
        1092.160400390625
      ],
      "bbox_max": [
        -2556.205322265625,
        -3975.623291015625,
        1166.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25882238149642944,
        0.9659249782562256,
        0.0
      ],
      "plane_d": 3174.446533203125,
      "bbox_min": [
        -2595.650634765625,
        -3991.91748046875,
        1093.41748046875
      ],
      "bbox_max": [
        -2556.375,
        -3976.8193359375,
        1166.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8743014335632324,
        0.48538342118263245,
        -0.0
      ],
      "plane_d": 4172.65283203125,
      "bbox_min": [
        -2559.205322265625,
        -3991.91748046875,
        1093.4176025390625
      ],
      "bbox_max": [
        -2556.375,
        -3986.8193359375,
        1166.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999989867210388,
        0.8660261034965515,
        -0.0
      ],
      "plane_d": 4726.2900390625,
      "bbox_min": [
        -2569.59765625,
        -3986.8193359375,
        1092.160400390625
      ],
      "bbox_max": [
        -2556.205322265625,
        -3975.623291015625,
        1158.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866020917892456,
        0.5000077486038208,
        0.0
      ],
      "plane_d": -234.8848876953125,
      "bbox_min": [
        -2569.59765625,
        -3986.8193359375,
        1092.160400390625
      ],
      "bbox_max": [
        -2556.205322265625,
        -3975.623291015625,
        1158.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866020917892456,
        -0.5000077486038208,
        0.0
      ],
      "plane_d": 222.8848876953125,
      "bbox_min": [
        -2559.205322265625,
        -3986.8193359375,
        1092.160400390625
      ],
      "bbox_max": [
        -2556.205322265625,
        -3981.623291015625,
        1158.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7113276124000549,
        0.7028605937957764,
        0.0
      ],
      "plane_d": 1223.594482421875,
      "bbox_min": [
        -2666.06884765625,
        -4470.28857421875,
        1052.5999755859375
      ],
      "bbox_max": [
        -1846.745361328125,
        -3820.60791015625,
        1302.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.28943097591400146,
        0.9261792302131653,
        0.24170605838298798
      ],
      "plane_d": 3128.22509765625,
      "bbox_min": [
        -2333.07666015625,
        -4470.28857421875,
        1052.5999755859375
      ],
      "bbox_max": [
        -1846.745361328125,
        -4102.06005859375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5949307084083557,
        0.8035773038864136,
        0.017917240038514137
      ],
      "plane_d": 2235.076416015625,
      "bbox_min": [
        -2223.0869140625,
        -4470.28857421875,
        1052.5999755859375
      ],
      "bbox_max": [
        -1980.5394287109375,
        -4271.17578125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -4.549466439129901e-07,
        -9.098932451934161e-08
      ],
      "plane_d": -2214.781982421875,
      "bbox_min": [
        -2214.780029296875,
        -4470.28857421875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2214.780029296875,
        -4444.59619140625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5369734764099121,
        0.8435990810394287,
        0.0
      ],
      "plane_d": 2550.508544921875,
      "bbox_min": [
        -2223.0869140625,
        -4450.17041015625,
        1052.5999755859375
      ],
      "bbox_max": [
        -2104.367919921875,
        -4346.72216796875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.488786518573761,
        0.8719132542610168,
        0.029241390526294708
      ],
      "plane_d": 2744.662841796875,
      "bbox_min": [
        -2214.780029296875,
        -4450.17041015625,
        1052.5999755859375
      ],
      "bbox_max": [
        -2104.367919921875,
        -4362.8525390625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -4.549466439129901e-07,
        -9.098932451934161e-08
      ],
      "plane_d": -2214.781982421875,
      "bbox_min": [
        -2214.780029296875,
        -4450.17041015625,
        1052.5999755859375
      ],
      "bbox_max": [
        -2147.233154296875,
        -4390.62158203125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9149596691131592,
        0.4035453200340271,
        -0.0
      ],
      "plane_d": 3787.404296875,
      "bbox_min": [
        -2190.8857421875,
        -4421.83349609375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2147.233154296875,
        -4390.62158203125,
        1187.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8480495810508728,
        0.5299170613288879,
        -0.0
      ],
      "plane_d": 4148.27099609375,
      "bbox_min": [
        -2164.86669921875,
        -4402.4375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2147.233154296875,
        -4390.62158203125,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1072.5999755859375,
      "bbox_min": [
        -2164.86669921875,
        -4402.4375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2147.233154296875,
        -4390.62158203125,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8480120897293091,
        -0.529977023601532,
        0.0
      ],
      "plane_d": -4168.453125,
      "bbox_min": [
        -2164.86669921875,
        -4402.4375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2164.194091796875,
        -4401.361328125,
        1072.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9149596691131592,
        0.4035453200340271,
        -0.0
      ],
      "plane_d": 3787.404296875,
      "bbox_min": [
        -2223.0869140625,
        -4417.92333984375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2147.994140625,
        -4346.72216796875,
        1187.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9149577617645264,
        0.4035496115684509,
        0.0
      ],
      "plane_d": 3791.4189453125,
      "bbox_min": [
        -2223.0869140625,
        -4380.4443359375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2208.127685546875,
        -4353.21142578125,
        1187.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.40345239639282227,
        0.9150007367134094,
        0.0
      ],
      "plane_d": 3115.7587890625,
      "bbox_min": [
        -2223.0869140625,
        -4380.4443359375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2208.127685546875,
        -4353.21142578125,
        1187.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4035545587539673,
        -0.9149556159973145,
        0.0
      ],
      "plane_d": -3087.33544921875,
      "bbox_min": [
        -2223.0869140625,
        -4354.82568359375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2219.427001953125,
        -4353.21142578125,
        1082.6944580078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1072.5999755859375,
      "bbox_min": [
        -2180.091552734375,
        -4401.361328125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2147.994140625,
        -4366.39794921875,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8480495810508728,
        0.5299170613288879,
        -0.0
      ],
      "plane_d": 4148.27099609375,
      "bbox_min": [
        -2180.091552734375,
        -4401.361328125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2147.994140625,
        -4366.39794921875,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8480499982833862,
        -0.5299162268638611,
        -0.0
      ],
      "plane_d": -4150.267578125,
      "bbox_min": [
        -2180.091552734375,
        -4401.361328125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2149.989013671875,
        -4366.39794921875,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5299111604690552,
        0.8480532169342041,
        0.0
      ],
      "plane_d": 2556.670654296875,
      "bbox_min": [
        -2164.826416015625,
        -4367.45751953125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2163.130615234375,
        -4366.39794921875,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1070.5999755859375,
      "bbox_min": [
        -2180.091552734375,
        -4401.361328125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2149.989013671875,
        -4367.45751953125,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8480499386787415,
        -0.5299162268638611,
        5.770120696979575e-05
      ],
      "plane_d": -4168.32958984375,
      "bbox_min": [
        -2180.091552734375,
        -4401.361328125,
        1070.5999755859375
      ],
      "bbox_max": [
        -2164.826416015625,
        -4367.45751953125,
        1072.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.5299111604690552,
        0.8480532169342041,
        0.0
      ],
      "plane_d": 2556.670654296875,
      "bbox_min": [
        -2180.091552734375,
        -4376.99609375,
        1070.5999755859375
      ],
      "bbox_max": [
        -2164.826416015625,
        -4367.45751953125,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5299197435379028,
        -0.8480479121208191,
        0.0
      ],
      "plane_d": -2558.62890625,
      "bbox_min": [
        -2180.091552734375,
        -4401.361328125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2149.989013671875,
        -4367.45751953125,
        1070.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5299111604690552,
        0.8480532169342041,
        0.0
      ],
      "plane_d": 2556.670654296875,
      "bbox_min": [
        -2180.091552734375,
        -4378.6923828125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2164.826416015625,
        -4367.45751953125,
        1070.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8480806350708008,
        -0.5298672914505005,
        0.0
      ],
      "plane_d": -4168.12060546875,
      "bbox_min": [
        -2180.091552734375,
        -4378.6923828125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2179.03173828125,
        -4376.99609375,
        1070.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5299197435379028,
        0.8480479121208191,
        0.0
      ],
      "plane_d": 2584.62890625,
      "bbox_min": [
        -2169.06787109375,
        -4401.361328125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2149.989013671875,
        -4376.36181640625,
        1070.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8480120897293091,
        -0.529977023601532,
        0.0
      ],
      "plane_d": -4168.453125,
      "bbox_min": [
        -2165.25390625,
        -4401.361328125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2164.86669921875,
        -4400.74169921875,
        1070.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1066.5999755859375,
      "bbox_min": [
        -2169.06787109375,
        -4396.501953125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2153.381103515625,
        -4376.36181640625,
        1070.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8480477333068848,
        -0.5299199819564819,
        -0.0
      ],
      "plane_d": -4160.279296875,
      "bbox_min": [
        -2169.06787109375,
        -4396.501953125,
        1066.5999755859375
      ],
      "bbox_max": [
        -2153.381103515625,
        -4376.36181640625,
        1070.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8480477333068848,
        0.5299199819564819,
        -0.0
      ],
      "plane_d": 4154.279296875,
      "bbox_min": [
        -2169.06787109375,
        -4393.32275390625,
        1066.5999755859375
      ],
      "bbox_max": [
        -2153.381103515625,
        -4376.36181640625,
        1070.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5298746228218079,
        0.8480761051177979,
        0.0
      ],
      "plane_d": 2564.85009765625,
      "bbox_min": [
        -2169.06787109375,
        -4379.541015625,
        1066.5999755859375
      ],
      "bbox_max": [
        -2163.9794921875,
        -4376.36181640625,
        1070.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1054.5999755859375,
      "bbox_min": [
        -2169.06787109375,
        -4396.501953125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2153.381103515625,
        -4376.36181640625,
        1054.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8480477333068848,
        -0.5299199819564819,
        -0.0
      ],
      "plane_d": -4160.279296875,
      "bbox_min": [
        -2169.06787109375,
        -4396.501953125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2153.381103515625,
        -4376.36181640625,
        1054.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8480477333068848,
        0.5299199819564819,
        -0.0
      ],
      "plane_d": 4154.279296875,
      "bbox_min": [
        -2169.06787109375,
        -4393.32275390625,
        1052.5999755859375
      ],
      "bbox_max": [
        -2153.381103515625,
        -4376.36181640625,
        1054.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5298746228218079,
        0.8480761051177979,
        0.0
      ],
      "plane_d": 2564.85009765625,
      "bbox_min": [
        -2169.06787109375,
        -4379.541015625,
        1052.5999755859375
      ],
      "bbox_max": [
        -2163.9794921875,
        -4376.36181640625,
        1054.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6752628087997437,
        0.7349724173545837,
        0.061932362616062164
      ],
      "plane_d": 1778.242431640625,
      "bbox_min": [
        -2333.07666015625,
        -4378.89208984375,
        1052.5999755859375
      ],
      "bbox_max": [
        -1846.745361328125,
        -4102.06005859375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9149594306945801,
        0.4035460650920868,
        -0.0
      ],
      "plane_d": 3787.4072265625,
      "bbox_min": [
        -2333.07666015625,
        -4378.89208984375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2212.47216796875,
        -4102.06005859375,
        1226.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.39045250415802,
        0.9206230640411377,
        0.0
      ],
      "plane_d": 4687.40673828125,
      "bbox_min": [
        -2333.07666015625,
        -4378.89208984375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2212.47216796875,
        -4102.06005859375,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9149577617645264,
        0.4035496115684509,
        0.0
      ],
      "plane_d": 3791.4189453125,
      "bbox_min": [
        -2323.40673828125,
        -4378.89208984375,
        1080.8914794921875
      ],
      "bbox_max": [
        -2212.47216796875,
        -4129.09912109375,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6691350340843201,
        -0.7431408762931824,
        -2.7564244646782754e-06
      ],
      "plane_d": -1517.2618408203125,
      "bbox_min": [
        -2323.40673828125,
        -4133.72216796875,
        1203.623779296875
      ],
      "bbox_max": [
        -2321.402587890625,
        -4131.91748046875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4035545885562897,
        -0.9149556756019592,
        0.0
      ],
      "plane_d": -3087.335693359375,
      "bbox_min": [
        -2321.402587890625,
        -4354.82568359375,
        1080.8914794921875
      ],
      "bbox_max": [
        -2219.427001953125,
        -4129.09912109375,
        1226.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6691350340843201,
        -0.7431408762931824,
        -2.7564244646782754e-06
      ],
      "plane_d": -1517.2618408203125,
      "bbox_min": [
        -2321.402587890625,
        -4131.91748046875,
        1203.623779296875
      ],
      "bbox_max": [
        -2318.272705078125,
        -4129.09912109375,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20134730637073517,
        0.9795199036598206,
        -0.0
      ],
      "plane_d": 4487.80810546875,
      "bbox_min": [
        -2333.07666015625,
        -4102.71044921875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2329.91162109375,
        -4102.06005859375,
        1226.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5722227692604065,
        -0.8200982809066772,
        0.0
      ],
      "plane_d": -2132.25634765625,
      "bbox_min": [
        -2329.91162109375,
        -4196.75341796875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2263.487060546875,
        -4102.71044921875,
        1226.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.39045250415802,
        0.9206230640411377,
        0.0
      ],
      "plane_d": 4687.40673828125,
      "bbox_min": [
        -2329.91162109375,
        -4179.34716796875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2263.487060546875,
        -4102.71044921875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9952003359794617,
        0.09785871207714081,
        -0.0
      ],
      "plane_d": 2661.608642578125,
      "bbox_min": [
        -2318.272705078125,
        -4179.34716796875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2263.487060546875,
        -4114.986328125,
        1226.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7431374192237854,
        0.6691388487815857,
        -0.0
      ],
      "plane_d": 4464.6455078125,
      "bbox_min": [
        -2318.272705078125,
        -4166.4208984375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2265.796630859375,
        -4114.986328125,
        1226.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6691187024116516,
        0.7431555390357971,
        0.0
      ],
      "plane_d": 1561.3634033203125,
      "bbox_min": [
        -2318.272705078125,
        -4166.4208984375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2273.156982421875,
        -4114.986328125,
        1226.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.6691311001777649,
        -0.7431443929672241,
        0.0
      ],
      "plane_d": -1517.2886962890625,
      "bbox_min": [
        -2318.272705078125,
        -4155.71435546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2282.07470703125,
        -4114.986328125,
        1226.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7431418299674988,
        0.6691339612007141,
        -0.0
      ],
      "plane_d": 4476.634765625,
      "bbox_min": [
        -2311.5166015625,
        -4155.71435546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2282.07470703125,
        -4123.01611328125,
        1203.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.20134730637073517,
        0.9795199036598206,
        -0.0
      ],
      "plane_d": 4487.80810546875,
      "bbox_min": [
        -2329.91162109375,
        -4114.986328125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2302.5986328125,
        -4102.71044921875,
        1226.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.743126392364502,
        0.6691511273384094,
        -0.0
      ],
      "plane_d": 4464.66943359375,
      "bbox_min": [
        -2309.959228515625,
        -4114.986328125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2302.5986328125,
        -4106.81201171875,
        1226.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.10253556817770004,
        0.17759636044502258,
        0.9787472486495972
      ],
      "plane_d": -99.72515869140625,
      "bbox_min": [
        -2666.06884765625,
        -4269.361328125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2354.336181640625,
        -3820.60791015625,
        1194.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8651316165924072,
        -0.5015451312065125,
        0.0
      ],
      "plane_d": 165.22314453125,
      "bbox_min": [
        -2666.06884765625,
        -4269.361328125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2354.336181640625,
        -3835.6083984375,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8655998110771179,
        -0.500720739364624,
        -0.003989737946540117
      ],
      "plane_d": 188.32740783691406,
      "bbox_min": [
        -2574.874755859375,
        -4042.3720703125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2431.489013671875,
        -3835.6083984375,
        1102.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1070.5999755859375,
      "bbox_min": [
        -2574.874755859375,
        -4038.960205078125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2509.704833984375,
        -3956.89892578125,
        1101.7984619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.499998539686203,
        0.8660262227058411,
        -0.0
      ],
      "plane_d": 4772.2890625,
      "bbox_min": [
        -2574.874755859375,
        -4038.960205078125,
        1070.5999755859375
      ],
      "bbox_max": [
        -2530.334716796875,
        -4006.8134765625,
        1101.7984619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660240173339844,
        0.500002384185791,
        0.0
      ],
      "plane_d": -188.1138916015625,
      "bbox_min": [
        -2549.067626953125,
        -4038.8603515625,
        1070.5999755859375
      ],
      "bbox_max": [
        -2530.334716796875,
        -4006.8134765625,
        1101.7984619140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8743192553520203,
        -0.48535144329071045,
        0.0
      ],
      "plane_d": -4169.24365234375,
      "bbox_min": [
        -2537.567626953125,
        -4019.1455078125,
        1070.5999755859375
      ],
      "bbox_max": [
        -2530.334716796875,
        -4006.8134765625,
        1097.004638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01678992621600628,
        0.9998590350151062,
        0.0
      ],
      "plane_d": 3963.764404296875,
      "bbox_min": [
        -2530.567626953125,
        -4006.8173828125,
        1070.5999755859375
      ],
      "bbox_max": [
        -2530.334716796875,
        -4006.8134765625,
        1094.0460205078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.01678992621600628,
        0.9998590350151062,
        0.0
      ],
      "plane_d": 3963.764404296875,
      "bbox_min": [
        -2530.567626953125,
        -4006.8173828125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2530.443603515625,
        -4006.8154296875,
        1070.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5310013890266418,
        -0.847370982170105,
        -0.0
      ],
      "plane_d": -4698.8310546875,
      "bbox_min": [
        -2525.800048828125,
        -3964.16064453125,
        1055.4000244140625
      ],
      "bbox_max": [
        -2523.0,
        -3962.406005859375,
        1058.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2530.148681640625,
      "bbox_min": [
        -2548.897216796875,
        -4041.3603515625,
        1052.5999755859375
      ],
      "bbox_max": [
        -2513.538818359375,
        -4001.5234375,
        1101.7984619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01678992621600628,
        0.9998590350151062,
        0.0
      ],
      "plane_d": 3963.764404296875,
      "bbox_min": [
        -2548.897216796875,
        -4041.3603515625,
        1052.5999755859375
      ],
      "bbox_max": [
        -2530.148681640625,
        -4006.810302734375,
        1101.7984619140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660243153572083,
        0.5000017285346985,
        0.0
      ],
      "plane_d": -183.1175537109375,
      "bbox_min": [
        -2548.897216796875,
        -4041.3603515625,
        1082.623779296875
      ],
      "bbox_max": [
        -2530.148681640625,
        -4019.087158203125,
        1101.7984619140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.49999895691871643,
        0.8660260438919067,
        -0.0
      ],
      "plane_d": 4752.28955078125,
      "bbox_min": [
        -2534.737548828125,
        -4026.689453125,
        1082.623779296875
      ],
      "bbox_max": [
        -2530.148681640625,
        -4024.0400390625,
        1097.6080322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.499998539686203,
        0.8660262227058411,
        -0.0
      ],
      "plane_d": 4772.2890625,
      "bbox_min": [
        -2548.897216796875,
        -4041.3603515625,
        1101.0238037109375
      ],
      "bbox_max": [
        -2544.737548828125,
        -4038.958740234375,
        1101.79833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4028.199951171875,
      "bbox_min": [
        -2530.148681640625,
        -4028.75048828125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2513.538818359375,
        -4001.5234375,
        1097.882080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999989867210388,
        0.8660261034965515,
        -0.0
      ],
      "plane_d": 4732.2900390625,
      "bbox_min": [
        -2530.148681640625,
        -4028.199951171875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2513.538818359375,
        -4001.5234375,
        1097.6080322265625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.01678992621600628,
        0.9998590350151062,
        0.0
      ],
      "plane_d": 3963.764404296875,
      "bbox_min": [
        -2530.148681640625,
        -4028.199951171875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2524.737548828125,
        -4006.719482421875,
        1097.6080322265625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.49999895691871643,
        0.8660260438919067,
        -0.0
      ],
      "plane_d": 4752.28955078125,
      "bbox_min": [
        -2530.148681640625,
        -4028.199951171875,
        1082.623779296875
      ],
      "bbox_max": [
        -2527.532470703125,
        -4026.689453125,
        1097.6080322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999837279319763,
        0.8660348653793335,
        -0.0
      ],
      "plane_d": 4726.28662109375,
      "bbox_min": [
        -2524.737548828125,
        -4006.719482421875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2513.538818359375,
        -4001.5234375,
        1093.4176025390625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660209774971008,
        0.5000077486038208,
        0.0
      ],
      "plane_d": -183.0848388671875,
      "bbox_min": [
        -2524.737548828125,
        -4006.719482421875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2521.737548828125,
        -4001.5234375,
        1093.4176025390625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.49999895691871643,
        0.8660260438919067,
        -0.0
      ],
      "plane_d": 4752.28955078125,
      "bbox_min": [
        -2527.532470703125,
        -4028.75048828125,
        1082.623779296875
      ],
      "bbox_max": [
        -2526.578857421875,
        -4028.199951171875,
        1097.6080322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999997913837433,
        0.8660256266593933,
        -0.0
      ],
      "plane_d": 4752.2900390625,
      "bbox_min": [
        -2530.148681640625,
        -4123.57568359375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2354.336181640625,
        -4006.2568359375,
        1099.3458251953125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2530.148681640625,
      "bbox_min": [
        -2530.148681640625,
        -4036.266357421875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2521.800048828125,
        -4031.509521484375,
        1099.3458251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2521.800048828125,
      "bbox_min": [
        -2521.800048828125,
        -4036.266357421875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2521.800048828125,
        -4031.509521484375,
        1098.4710693359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999997913837433,
        0.8660255074501038,
        -0.0
      ],
      "plane_d": 4746.28955078125,
      "bbox_min": [
        -2526.259765625,
        -4123.57568359375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2354.336181640625,
        -4006.2568359375,
        1097.6080322265625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.49999675154685974,
        0.8660273551940918,
        -0.0
      ],
      "plane_d": 4748.28955078125,
      "bbox_min": [
        -2526.259765625,
        -4123.57568359375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2354.336181640625,
        -4028.199951171875,
        1097.6080322265625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4028.199951171875,
      "bbox_min": [
        -2526.259765625,
        -4067.0400390625,
        1052.5999755859375
      ],
      "bbox_max": [
        -2458.25927734375,
        -4028.199951171875,
        1097.6080322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2521.800048828125,
      "bbox_min": [
        -2521.800048828125,
        -4067.0400390625,
        1052.5999755859375
      ],
      "bbox_max": [
        -2458.25927734375,
        -4028.199951171875,
        1097.6080322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659255146980286,
        0.25882020592689514,
        0.0
      ],
      "plane_d": 3461.58642578125,
      "bbox_min": [
        -2501.560302734375,
        -4067.0400390625,
        1052.5999755859375
      ],
      "bbox_max": [
        -2458.25927734375,
        -4038.576416015625,
        1097.6080322265625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660311698913574,
        0.49999016523361206,
        0.0
      ],
      "plane_d": -97.1812744140625,
      "bbox_min": [
        -2460.25927734375,
        -4067.0400390625,
        1052.5999755859375
      ],
      "bbox_max": [
        -2458.25927734375,
        -4063.575927734375,
        1097.6080322265625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9659255146980286,
        0.25882020592689514,
        0.0
      ],
      "plane_d": 3461.58642578125,
      "bbox_min": [
        -2502.29248046875,
        -4094.575927734375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2403.565673828125,
        -4035.84375,
        1096.77001953125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660311698913574,
        0.49999016523361206,
        0.0
      ],
      "plane_d": -97.1812744140625,
      "bbox_min": [
        -2458.25927734375,
        -4094.575927734375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2403.565673828125,
        -4061.84375,
        1096.7698974609375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660413026809692,
        -0.49997255206108093,
        0.0
      ],
      "plane_d": 35.277587890625,
      "bbox_min": [
        -2404.565673828125,
        -4094.575927734375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2403.565673828125,
        -4092.84375,
        1096.7698974609375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9659255146980286,
        0.25882020592689514,
        0.0
      ],
      "plane_d": 3461.58642578125,
      "bbox_min": [
        -2516.548095703125,
        -4035.84375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2502.29248046875,
        -4006.2568359375,
        1096.350830078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4999989867210388,
        0.8660261034965515,
        -0.0
      ],
      "plane_d": 4732.2900390625,
      "bbox_min": [
        -2516.548095703125,
        -4016.719482421875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2507.4169921875,
        -4006.2568359375,
        1093.4176025390625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660311698913574,
        -0.49999016523361206,
        0.0
      ],
      "plane_d": 171.18115234375,
      "bbox_min": [
        -2514.34521484375,
        -4012.719482421875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2511.34521484375,
        -4006.2568359375,
        1093.41748046875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4999837279319763,
        0.8660348653793335,
        -0.0
      ],
      "plane_d": 4726.28662109375,
      "bbox_min": [
        -2513.538818359375,
        -4007.523193359375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2511.34521484375,
        -4006.2568359375,
        1092.160400390625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8651316165924072,
        -0.5015451312065125,
        0.0
      ],
      "plane_d": 165.22314453125,
      "bbox_min": [
        -2658.272705078125,
        -4255.91357421875,
        1092.160400390625
      ],
      "bbox_max": [
        -2354.336181640625,
        -3993.736083984375,
        1194.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49999895691871643,
        0.8660260438919067,
        -0.0
      ],
      "plane_d": 4752.28955078125,
      "bbox_min": [
        -2574.874755859375,
        -4041.3603515625,
        1092.160400390625
      ],
      "bbox_max": [
        -2513.538818359375,
        -3993.736083984375,
        1194.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 183.10400390625,
      "bbox_min": [
        -2574.874755859375,
        -4041.3603515625,
        1097.60791015625
      ],
      "bbox_max": [
        -2526.578857421875,
        -4006.64013671875,
        1194.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.499998539686203,
        0.8660262227058411,
        -0.0
      ],
      "plane_d": 4772.2890625,
      "bbox_min": [
        -2574.874755859375,
        -4041.3603515625,
        1097.60791015625
      ],
      "bbox_max": [
        -2534.737548828125,
        -4006.64013671875,
        1142.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660240173339844,
        0.500002384185791,
        0.0
      ],
      "plane_d": -188.1138916015625,
      "bbox_min": [
        -2549.067626953125,
        -4041.3603515625,
        1097.60791015625
      ],
      "bbox_max": [
        -2534.737548828125,
        -4021.5400390625,
        1104.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1104.623779296875,
      "bbox_min": [
        -2549.067626953125,
        -4041.3603515625,
        1104.623779296875
      ],
      "bbox_max": [
        -2534.737548828125,
        -4021.5400390625,
        1104.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2717772424221039,
        0.9623602032661438,
        0.0
      ],
      "plane_d": 4571.97900390625,
      "bbox_min": [
        -2539.90771484375,
        -4036.0751953125,
        1097.60791015625
      ],
      "bbox_max": [
        -2526.578857421875,
        -4027.18896484375,
        1115.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4028.199951171875,
      "bbox_min": [
        -2539.90771484375,
        -4036.0751953125,
        1097.60791015625
      ],
      "bbox_max": [
        -2526.578857421875,
        -4027.18896484375,
        1115.6239013671875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1104.6239013671875,
      "bbox_min": [
        -2537.139404296875,
        -4028.199951171875,
        1104.6239013671875
      ],
      "bbox_max": [
        -2534.8115234375,
        -4027.18896484375,
        1115.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5015212297439575,
        0.8651454448699951,
        0.0
      ],
      "plane_d": 4762.94482421875,
      "bbox_min": [
        -2539.90771484375,
        -4036.0751953125,
        1097.882080078125
      ],
      "bbox_max": [
        -2526.578857421875,
        -4028.199951171875,
        1115.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1104.6239013671875,
      "bbox_min": [
        -2539.90771484375,
        -4036.0751953125,
        1097.882080078125
      ],
      "bbox_max": [
        -2526.578857421875,
        -4028.199951171875,
        1115.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2530.148681640625,
      "bbox_min": [
        -2530.148681640625,
        -4034.907958984375,
        1097.882080078125
      ],
      "bbox_max": [
        -2530.148681640625,
        -4028.199951171875,
        1104.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -5.10749896420748e-06,
        -1.8085596821038052e-05,
        -1.0
      ],
      "plane_d": 1115.5379638671875,
      "bbox_min": [
        -2539.90771484375,
        -4036.0751953125,
        1115.623779296875
      ],
      "bbox_max": [
        -2526.578857421875,
        -4028.199951171875,
        1115.6239013671875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.49999895691871643,
        0.8660260438919067,
        -0.0
      ],
      "plane_d": 4732.28955078125,
      "bbox_min": [
        -2564.875,
        -4028.750244140625,
        1092.160400390625
      ],
      "bbox_max": [
        -2513.538818359375,
        -3993.736083984375,
        1194.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.016789928078651428,
        0.999859094619751,
        0.0
      ],
      "plane_d": 3963.764892578125,
      "bbox_min": [
        -2539.067626953125,
        -4028.750244140625,
        1093.4176025390625
      ],
      "bbox_max": [
        -2524.737548828125,
        -4006.719482421875,
        1194.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8743192553520203,
        -0.48535144329071045,
        0.0
      ],
      "plane_d": -4169.24365234375,
      "bbox_min": [
        -2539.067626953125,
        -4028.750244140625,
        1096.9794921875
      ],
      "bbox_max": [
        -2526.259765625,
        -4018.94189453125,
        1194.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4028.199951171875,
      "bbox_min": [
        -2527.5322265625,
        -4028.750244140625,
        1097.474609375
      ],
      "bbox_max": [
        -2526.259765625,
        -4028.199951171875,
        1115.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.462159343645908e-05,
        0.0,
        -1.0
      ],
      "plane_d": 1115.5869140625,
      "bbox_min": [
        -2527.5322265625,
        -4028.750244140625,
        1115.6239013671875
      ],
      "bbox_max": [
        -2526.259765625,
        -4028.199951171875,
        1115.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1142.623779296875,
      "bbox_min": [
        -2539.067626953125,
        -4024.0400390625,
        1104.623779296875
      ],
      "bbox_max": [
        -2534.737548828125,
        -4018.94189453125,
        1142.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1104.623779296875,
      "bbox_min": [
        -2539.067626953125,
        -4024.0400390625,
        1104.623779296875
      ],
      "bbox_max": [
        -2534.737548828125,
        -4018.94189453125,
        1104.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48740285634994507,
        0.8442001342773438,
        0.2230798602104187
      ],
      "plane_d": 4363.11279296875,
      "bbox_min": [
        -2564.875,
        -4021.5400390625,
        1142.623779296875
      ],
      "bbox_max": [
        -2531.61767578125,
        -3993.736083984375,
        1194.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000002384185791,
        0.8660253882408142,
        -0.0
      ],
      "plane_d": 4749.2900390625,
      "bbox_min": [
        -2564.875,
        -4021.5400390625,
        1142.623779296875
      ],
      "bbox_max": [
        -2531.61767578125,
        -3993.736083984375,
        1194.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1142.623779296875,
      "bbox_min": [
        -2564.875,
        -4021.5400390625,
        1142.623779296875
      ],
      "bbox_max": [
        -2537.567626953125,
        -4004.0419921875,
        1142.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1142.623779296875,
      "bbox_min": [
        -2563.375,
        -4018.94189453125,
        1142.623779296875
      ],
      "bbox_max": [
        -2531.61767578125,
        -3993.736083984375,
        1142.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49998369812965393,
        0.8660348653793335,
        -0.0
      ],
      "plane_d": 4726.2861328125,
      "bbox_min": [
        -2524.737548828125,
        -4006.719482421875,
        1092.160400390625
      ],
      "bbox_max": [
        -2513.538818359375,
        -4001.5234375,
        1158.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866020917892456,
        0.5000077486038208,
        0.0
      ],
      "plane_d": -183.0848388671875,
      "bbox_min": [
        -2524.737548828125,
        -4006.719482421875,
        1092.160400390625
      ],
      "bbox_max": [
        -2521.737548828125,
        -4001.5234375,
        1158.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999997615814209,
        0.8660255670547485,
        -0.0
      ],
      "plane_d": 4752.28955078125,
      "bbox_min": [
        -2530.825439453125,
        -4123.57568359375,
        1092.160400390625
      ],
      "bbox_max": [
        -2354.336181640625,
        -4006.2568359375,
        1187.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.2717772424221039,
        0.9623602032661438,
        0.0
      ],
      "plane_d": 4571.97900390625,
      "bbox_min": [
        -2530.825439453125,
        -4036.266357421875,
        1099.099365234375
      ],
      "bbox_max": [
        -2521.800048828125,
        -4028.750244140625,
        1115.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.462159343645908e-05,
        0.0,
        -1.0
      ],
      "plane_d": 1115.5869140625,
      "bbox_min": [
        -2530.825439453125,
        -4036.266357421875,
        1099.099365234375
      ],
      "bbox_max": [
        -2521.800048828125,
        -4028.750244140625,
        1115.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2530.148681640625,
      "bbox_min": [
        -2530.825439453125,
        -4036.266357421875,
        1099.099365234375
      ],
      "bbox_max": [
        -2530.148681640625,
        -4034.907958984375,
        1104.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1104.6239013671875,
      "bbox_min": [
        -2530.825439453125,
        -4036.266357421875,
        1104.6239013671875
      ],
      "bbox_max": [
        -2530.148681640625,
        -4034.907958984375,
        1104.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49999672174453735,
        0.866027295589447,
        -0.0
      ],
      "plane_d": 4748.2890625,
      "bbox_min": [
        -2526.578857421875,
        -4123.57568359375,
        1092.160400390625
      ],
      "bbox_max": [
        -2354.336181640625,
        -4006.2568359375,
        1187.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4028.199951171875,
      "bbox_min": [
        -2526.578857421875,
        -4031.50927734375,
        1097.0074462890625
      ],
      "bbox_max": [
        -2521.800048828125,
        -4028.199951171875,
        1115.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2521.800048828125,
      "bbox_min": [
        -2526.578857421875,
        -4031.50927734375,
        1097.0074462890625
      ],
      "bbox_max": [
        -2521.800048828125,
        -4028.199951171875,
        1115.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.462159343645908e-05,
        0.0,
        -1.0
      ],
      "plane_d": 1115.5869140625,
      "bbox_min": [
        -2526.578857421875,
        -4031.50927734375,
        1115.623779296875
      ],
      "bbox_max": [
        -2521.800048828125,
        -4028.199951171875,
        1115.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999998211860657,
        0.8660255670547485,
        -0.0
      ],
      "plane_d": 4746.2900390625,
      "bbox_min": [
        -2516.548095703125,
        -4094.575927734375,
        1092.160400390625
      ],
      "bbox_max": [
        -2403.565673828125,
        -4006.2568359375,
        1172.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660311102867126,
        0.4999901354312897,
        0.0
      ],
      "plane_d": -97.1812744140625,
      "bbox_min": [
        -2502.29248046875,
        -4094.575927734375,
        1096.350830078125
      ],
      "bbox_max": [
        -2403.565673828125,
        -4035.84375,
        1172.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866041362285614,
        -0.4999725818634033,
        0.0
      ],
      "plane_d": 35.2777099609375,
      "bbox_min": [
        -2404.565673828125,
        -4094.575927734375,
        1096.350830078125
      ],
      "bbox_max": [
        -2403.565673828125,
        -4092.84375,
        1172.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659255743026733,
        0.25882023572921753,
        0.0
      ],
      "plane_d": 3461.58642578125,
      "bbox_min": [
        -2502.29248046875,
        -4038.575927734375,
        1096.350830078125
      ],
      "bbox_max": [
        -2501.560546875,
        -4035.84375,
        1166.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49999895691871643,
        0.8660260438919067,
        -0.0
      ],
      "plane_d": 4732.28955078125,
      "bbox_min": [
        -2516.548095703125,
        -4016.719482421875,
        1092.160400390625
      ],
      "bbox_max": [
        -2507.4169921875,
        -4006.2568359375,
        1166.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49998369812965393,
        0.8660348653793335,
        -0.0
      ],
      "plane_d": 4726.2861328125,
      "bbox_min": [
        -2514.34521484375,
        -4012.719482421875,
        1092.160400390625
      ],
      "bbox_max": [
        -2511.34521484375,
        -4006.2568359375,
        1158.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660310506820679,
        -0.4999901354312897,
        0.0
      ],
      "plane_d": 171.1807861328125,
      "bbox_min": [
        -2514.34521484375,
        -4012.719482421875,
        1092.160400390625
      ],
      "bbox_max": [
        -2511.34521484375,
        -4007.523193359375,
        1158.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.8944272398948669,
        0.0
      ],
      "plane_d": 2168.986083984375,
      "bbox_min": [
        -3088.01416015625,
        -4225.9462890625,
        1052.5999755859375
      ],
      "bbox_max": [
        -1784.5677490234375,
        -3248.03076171875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1646440476179123,
        0.8786206841468811,
        0.44823890924453735
      ],
      "plane_d": 2238.702880859375,
      "bbox_min": [
        -2090.0,
        -4225.9462890625,
        1052.5999755859375
      ],
      "bbox_max": [
        -1784.5677490234375,
        -3442.0400390625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8329792022705078,
        -0.3015960454940796,
        0.4638807773590088
      ],
      "plane_d": -3280.26953125,
      "bbox_min": [
        -2090.0,
        -4225.9462890625,
        1052.5999755859375
      ],
      "bbox_max": [
        -1784.5677490234375,
        -3442.0400390625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9302219748497009,
        -0.058351412415504456,
        0.3623287081718445
      ],
      "plane_d": -2448.154296875,
      "bbox_min": [
        -2081.520263671875,
        -3775.0,
        1052.5999755859375
      ],
      "bbox_max": [
        -1826.687255859375,
        -3442.0400390625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7289522290229797,
        0.6049720644950867,
        0.3203705847263336
      ],
      "plane_d": 411.9771423339844,
      "bbox_min": [
        -1941.6544189453125,
        -3635.20458984375,
        1052.5999755859375
      ],
      "bbox_max": [
        -1826.687255859375,
        -3442.0400390625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14676129817962646,
        0.7160802483558655,
        0.6824150681495667
      ],
      "plane_d": 1489.5687255859375,
      "bbox_min": [
        -1857.778564453125,
        -3493.00048828125,
        1082.7611083984375
      ],
      "bbox_max": [
        -1857.6201171875,
        -3492.7607421875,
        1082.9918212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0967860147356987,
        0.9410552978515625,
        0.324110209941864
      ],
      "plane_d": 3115.90478515625,
      "bbox_min": [
        -1941.6544189453125,
        -3635.20458984375,
        1052.5999755859375
      ],
      "bbox_max": [
        -1826.687255859375,
        -3442.0400390625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4463079273700714,
        0.49091777205467224,
        0.7482037544250488
      ],
      "plane_d": -36.39849853515625,
      "bbox_min": [
        -1941.6544189453125,
        -3635.20458984375,
        1203.9764404296875
      ],
      "bbox_max": [
        -1826.687255859375,
        -3526.04248046875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45244094729423523,
        0.7295348644256592,
        0.5129094123840332
      ],
      "plane_d": 2833.32421875,
      "bbox_min": [
        -1941.6544189453125,
        -3526.04248046875,
        1052.5999755859375
      ],
      "bbox_max": [
        -1857.6810302734375,
        -3442.0400390625,
        1203.9764404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14676129817962646,
        0.7160802483558655,
        0.6824150681495667
      ],
      "plane_d": 1489.5687255859375,
      "bbox_min": [
        -1866.9840087890625,
        -3493.00048828125,
        1052.5999755859375
      ],
      "bbox_max": [
        -1857.6810302734375,
        -3465.8876953125,
        1082.9918212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7485790252685547,
        0.22469562292099,
        0.6238119602203369
      ],
      "plane_d": -1412.25048828125,
      "bbox_min": [
        -2081.520263671875,
        -3566.09375,
        1052.5999755859375
      ],
      "bbox_max": [
        -1941.6544189453125,
        -3469.260498046875,
        1203.9764404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5098043084144592,
        -0.8602903485298157,
        1.845117026277876e-06
      ],
      "plane_d": -4050.700439453125,
      "bbox_min": [
        -2017.416015625,
        -3575.815185546875,
        1150.6083984375
      ],
      "bbox_max": [
        -1926.837890625,
        -3513.012939453125,
        1234.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5098023414611816,
        0.8602915406227112,
        0.0
      ],
      "plane_d": 4041.298828125,
      "bbox_min": [
        -1991.4388427734375,
        -3566.33642578125,
        1168.9072265625
      ],
      "bbox_max": [
        -1927.432373046875,
        -3517.48046875,
        1234.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6757248044013977,
        0.7371538877487183,
        -0.0
      ],
      "plane_d": 3927.4951171875,
      "bbox_min": [
        -1982.8216552734375,
        -3566.33642578125,
        1192.4141845703125
      ],
      "bbox_max": [
        -1927.432373046875,
        -3533.51318359375,
        1234.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33383411169052124,
        0.6676682233810425,
        0.6654126048088074
      ],
      "plane_d": 896.4573974609375,
      "bbox_min": [
        -1982.8216552734375,
        -3566.33642578125,
        1203.499267578125
      ],
      "bbox_max": [
        -1927.432373046875,
        -3533.51318359375,
        1234.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1234.0,
      "bbox_min": [
        -1955.0,
        -3566.33642578125,
        1234.0
      ],
      "bbox_max": [
        -1927.432373046875,
        -3545.0,
        1234.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6757234930992126,
        -0.7371551990509033,
        2.1866433144168695e-06
      ],
      "plane_d": -3937.943115234375,
      "bbox_min": [
        -1955.0,
        -3575.815185546875,
        1182.2030029296875
      ],
      "bbox_max": [
        -1926.837890625,
        -3550.0,
        1234.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1234.0,
      "bbox_min": [
        -1955.0,
        -3575.815185546875,
        1234.0
      ],
      "bbox_max": [
        -1926.837890625,
        -3550.0,
        1234.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8323912620544434,
        -0.27746376395225525,
        0.4797278940677643
      ],
      "plane_d": -3204.68408203125,
      "bbox_min": [
        -2090.0,
        -4225.9462890625,
        1052.5999755859375
      ],
      "bbox_max": [
        -1784.5677490234375,
        -3537.124755859375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8889487981796265,
        0.05722672864794731,
        0.45441731810569763
      ],
      "plane_d": -1952.608154296875,
      "bbox_min": [
        -2090.0,
        -4225.9462890625,
        1052.5999755859375
      ],
      "bbox_max": [
        -1784.5677490234375,
        -3537.124755859375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9405150413513184,
        -0.22373665869235992,
        0.25568222999572754
      ],
      "plane_d": -2961.807861328125,
      "bbox_min": [
        -1915.0,
        -4222.4580078125,
        1052.5999755859375
      ],
      "bbox_max": [
        -1799.9468994140625,
        -3985.0,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6752628087997437,
        0.7349724173545837,
        0.061932362616062164
      ],
      "plane_d": 1778.242431640625,
      "bbox_min": [
        -1896.360595703125,
        -4222.4580078125,
        1052.5999755859375
      ],
      "bbox_max": [
        -1799.9468994140625,
        -4098.91650390625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1080.0,
      "bbox_min": [
        -1896.360595703125,
        -4121.8603515625,
        1062.016845703125
      ],
      "bbox_max": [
        -1875.8221435546875,
        -4098.91650390625,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20792335271835327,
        -0.9781450629234314,
        4.35439369539381e-06
      ],
      "plane_d": -3638.348876953125,
      "bbox_min": [
        -1896.360595703125,
        -4121.8603515625,
        1062.016845703125
      ],
      "bbox_max": [
        -1875.8221435546875,
        -4098.91650390625,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2079029083251953,
        0.9781494736671448,
        9.210622010868974e-06
      ],
      "plane_d": 3618.3916015625,
      "bbox_min": [
        -1896.360595703125,
        -4102.2978515625,
        1062.53466796875
      ],
      "bbox_max": [
        -1880.451904296875,
        -4098.91650390625,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5792039036750793,
        -0.3475223183631897,
        0.7373947501182556
      ],
      "plane_d": -3237.798095703125,
      "bbox_min": [
        -2090.0,
        -4225.9462890625,
        1052.5999755859375
      ],
      "bbox_max": [
        -1799.9468994140625,
        -3537.124755859375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7485790252685547,
        0.22469562292099,
        0.6238119602203369
      ],
      "plane_d": -1412.25048828125,
      "bbox_min": [
        -2090.0,
        -3600.0,
        1052.5999755859375
      ],
      "bbox_max": [
        -2021.9903564453125,
        -3537.124755859375,
        1121.9991455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6752628087997437,
        0.7349724173545837,
        0.061932362616062164
      ],
      "plane_d": 1778.242431640625,
      "bbox_min": [
        -2030.8330078125,
        -4225.9462890625,
        1065.12939453125
      ],
      "bbox_max": [
        -1799.9468994140625,
        -3666.081298828125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1079.9998779296875,
      "bbox_min": [
        -2030.8330078125,
        -3894.71875,
        1065.12939453125
      ],
      "bbox_max": [
        -1931.1611328125,
        -3666.081298828125,
        1080.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7913262248039246,
        -0.2571197748184204,
        -0.5547002553939819
      ],
      "plane_d": -1944.091552734375,
      "bbox_min": [
        -2030.8330078125,
        -3894.71875,
        1065.12939453125
      ],
      "bbox_max": [
        -1931.1611328125,
        -3666.081298828125,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.30902212858200073,
        -0.9510548114776611,
        7.302739504666533e-06
      ],
      "plane_d": -3102.024169921875,
      "bbox_min": [
        -2021.3670654296875,
        -3894.71875,
        1065.12939453125
      ],
      "bbox_max": [
        -1931.1611328125,
        -3666.081298828125,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30902454257011414,
        0.951054036617279,
        4.4575691049431043e-07
      ],
      "plane_d": 3082.00830078125,
      "bbox_min": [
        -2021.3670654296875,
        -3875.69775390625,
        1065.25439453125
      ],
      "bbox_max": [
        -1937.48583984375,
        -3666.081298828125,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.544626772403717,
        -0.8386785984039307,
        -1.0460266821610276e-05
      ],
      "plane_d": -1996.9752197265625,
      "bbox_min": [
        -2021.3670654296875,
        -3689.6044921875,
        1073.4464111328125
      ],
      "bbox_max": [
        -2005.1712646484375,
        -3666.081298828125,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5446348786354065,
        0.8386732339859009,
        3.4076094834745163e-06
      ],
      "plane_d": 1976.946533203125,
      "bbox_min": [
        -2021.3670654296875,
        -3669.912353515625,
        1076.0538330078125
      ],
      "bbox_max": [
        -2015.4676513671875,
        -3666.081298828125,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6978153586387634,
        -0.4531625211238861,
        -0.5547048449516296
      ],
      "plane_d": -2483.917724609375,
      "bbox_min": [
        -2030.8330078125,
        -3692.8330078125,
        1069.584716796875
      ],
      "bbox_max": [
        -2011.17529296875,
        -3668.428955078125,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5446348786354065,
        0.8386732339859009,
        3.4076094834745163e-06
      ],
      "plane_d": 1976.946533203125,
      "bbox_min": [
        -2030.8330078125,
        -3692.8330078125,
        1069.584716796875
      ],
      "bbox_max": [
        -2011.17529296875,
        -3668.428955078125,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.544626772403717,
        -0.8386785984039307,
        -1.0460266821610276e-05
      ],
      "plane_d": -1996.9752197265625,
      "bbox_min": [
        -2019.9403076171875,
        -3692.8330078125,
        1069.9888916015625
      ],
      "bbox_max": [
        -2011.17529296875,
        -3687.14111328125,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5098023414611816,
        0.8602915406227112,
        0.0
      ],
      "plane_d": 4041.298828125,
      "bbox_min": [
        -2090.0,
        -3536.908203125,
        1052.5999755859375
      ],
      "bbox_max": [
        -1958.65478515625,
        -3465.0,
        1219.0303955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5098043084144592,
        -0.8602903485298157,
        1.845117026277876e-06
      ],
      "plane_d": -4050.700439453125,
      "bbox_min": [
        -2090.0,
        -3533.51318359375,
        1052.5999755859375
      ],
      "bbox_max": [
        -1982.8216552734375,
        -3470.0,
        1203.499267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32936930656433105,
        -0.8532378077507019,
        0.40435269474983215
      ],
      "plane_d": -2643.852783203125,
      "bbox_min": [
        -3088.01416015625,
        -3506.75830078125,
        1052.5999755859375
      ],
      "bbox_max": [
        -1906.3402099609375,
        -3248.03076171875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4137550890445709,
        -0.7705957889556885,
        0.48475658893585205
      ],
      "plane_d": -4184.68359375,
      "bbox_min": [
        -3088.01416015625,
        -3506.75830078125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2319.057373046875,
        -3283.287109375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.014795297756791115,
        -0.9131819009780884,
        0.4072834253311157
      ],
      "plane_d": -3569.4521484375,
      "bbox_min": [
        -3088.01416015625,
        -3464.87158203125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2319.057373046875,
        -3283.287109375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09112545102834702,
        -0.9304839968681335,
        0.35481786727905273
      ],
      "plane_d": -3767.822265625,
      "bbox_min": [
        -2921.3994140625,
        -3397.99365234375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2552.111572265625,
        -3283.287109375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18425501883029938,
        -0.9331962466239929,
        0.3085367977619171
      ],
      "plane_d": -2959.1591796875,
      "bbox_min": [
        -2921.3994140625,
        -3392.010498046875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2654.7197265625,
        -3283.287109375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1306823045015335,
        -0.9546955227851868,
        0.2673548758029938
      ],
      "plane_d": -3137.979736328125,
      "bbox_min": [
        -2921.3994140625,
        -3392.010498046875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2792.86328125,
        -3363.318115234375,
        1119.5692138671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08697842806577682,
        -0.8274903893470764,
        -0.5547022819519043
      ],
      "plane_d": -2443.21435546875,
      "bbox_min": [
        -2675.971435546875,
        -3389.390869140625,
        1060.994873046875
      ],
      "bbox_max": [
        -2654.7197265625,
        -3375.547119140625,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1080.0,
      "bbox_min": [
        -2675.971435546875,
        -3389.390869140625,
        1060.994873046875
      ],
      "bbox_max": [
        -2654.7197265625,
        -3375.547119140625,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9945220351219177,
        0.10452769696712494,
        -1.0024543826148147e-06
      ],
      "plane_d": -2307.134521484375,
      "bbox_min": [
        -2675.971435546875,
        -3389.390869140625,
        1060.994873046875
      ],
      "bbox_max": [
        -2654.7197265625,
        -3375.547119140625,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9945216774940491,
        -0.10453074425458908,
        3.076078201047494e-06
      ],
      "plane_d": 2287.120849609375,
      "bbox_min": [
        -2655.969970703125,
        -3389.390869140625,
        1060.994873046875
      ],
      "bbox_max": [
        -2654.7197265625,
        -3377.49658203125,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34101659059524536,
        -0.8381780385971069,
        0.42563509941101074
      ],
      "plane_d": -4166.45947265625,
      "bbox_min": [
        -3088.01416015625,
        -3464.87158203125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2319.057373046875,
        -3283.287109375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18425501883029938,
        -0.9331962466239929,
        0.3085367977619171
      ],
      "plane_d": -2959.1591796875,
      "bbox_min": [
        -3088.01416015625,
        -3464.87158203125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2425.917724609375,
        -3283.287109375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20940233767032623,
        -0.9440802931785583,
        0.25468209385871887
      ],
      "plane_d": -2849.800537109375,
      "bbox_min": [
        -3080.897216796875,
        -3407.13818359375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2936.673095703125,
        -3332.9873046875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1301591396331787,
        -0.8218053579330444,
        -0.5547022819519043
      ],
      "plane_d": -1816.0345458984375,
      "bbox_min": [
        -2958.145751953125,
        -3400.721923828125,
        1061.234375
      ],
      "bbox_max": [
        -2936.673095703125,
        -3386.654296875,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1080.0,
      "bbox_min": [
        -2958.145751953125,
        -3400.721923828125,
        1061.234375
      ],
      "bbox_max": [
        -2936.673095703125,
        -3386.654296875,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9876883029937744,
        -0.15643449127674103,
        -2.0004463294753805e-06
      ],
      "plane_d": -3451.937744140625,
      "bbox_min": [
        -2958.145751953125,
        -3400.721923828125,
        1061.234375
      ],
      "bbox_max": [
        -2936.673095703125,
        -3386.654296875,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.987689197063446,
        0.15642857551574707,
        -6.9202828854031395e-06
      ],
      "plane_d": 3431.929931640625,
      "bbox_min": [
        -2938.325927734375,
        -3397.090087890625,
        1061.6800537109375
      ],
      "bbox_max": [
        -2936.673095703125,
        -3386.654296875,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9767470955848694,
        0.034353528171777725,
        0.2116248458623886
      ],
      "plane_d": 2855.7041015625,
      "bbox_min": [
        -3088.01416015625,
        -3464.87158203125,
        1064.460205078125
      ],
      "bbox_max": [
        -2425.917724609375,
        -3332.9873046875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20940233767032623,
        -0.9440802931785583,
        0.25468209385871887
      ],
      "plane_d": -2849.800537109375,
      "bbox_min": [
        -3088.01416015625,
        -3464.87158203125,
        1064.460205078125
      ],
      "bbox_max": [
        -2425.917724609375,
        -3332.9873046875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1080.0,
      "bbox_min": [
        -2956.8212890625,
        -3464.87158203125,
        1064.460205078125
      ],
      "bbox_max": [
        -2425.917724609375,
        -3383.7744140625,
        1080.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.36474671959877014,
        -0.7478470802307129,
        -0.5546931624412537
      ],
      "plane_d": -2879.881103515625,
      "bbox_min": [
        -2956.8212890625,
        -3464.87158203125,
        1064.460205078125
      ],
      "bbox_max": [
        -2425.917724609375,
        -3383.7744140625,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8987934589385986,
        0.4383724629878998,
        -4.217206878820434e-06
      ],
      "plane_d": -688.6605834960938,
      "bbox_min": [
        -2451.87158203125,
        -3464.87158203125,
        1064.460205078125
      ],
      "bbox_max": [
        -2425.917724609375,
        -3439.046142578125,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8987944722175598,
        -0.4383702278137207,
        -4.5666820369660854e-06
      ],
      "plane_d": 668.6804809570312,
      "bbox_min": [
        -2433.895751953125,
        -3464.87158203125,
        1065.0986328125
      ],
      "bbox_max": [
        -2425.917724609375,
        -3448.51416015625,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08697842806577682,
        -0.8274903893470764,
        -0.5547022819519043
      ],
      "plane_d": -2443.21435546875,
      "bbox_min": [
        -2956.8212890625,
        -3406.867431640625,
        1068.115478515625
      ],
      "bbox_max": [
        -2655.413818359375,
        -3383.7744140625,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9945216774940491,
        -0.10453074425458908,
        3.076078201047494e-06
      ],
      "plane_d": 2287.120849609375,
      "bbox_min": [
        -2676.688720703125,
        -3397.2705078125,
        1068.115478515625
      ],
      "bbox_max": [
        -2655.413818359375,
        -3383.7744140625,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9945220351219177,
        0.10452769696712494,
        -1.0024543826148147e-06
      ],
      "plane_d": -2307.134521484375,
      "bbox_min": [
        -2676.688720703125,
        -3395.179931640625,
        1069.7086181640625
      ],
      "bbox_max": [
        -2675.489990234375,
        -3383.7744140625,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1301591396331787,
        -0.8218053579330444,
        -0.5547022819519043
      ],
      "plane_d": -1816.0345458984375,
      "bbox_min": [
        -2956.8212890625,
        -3406.867431640625,
        1069.902587890625
      ],
      "bbox_max": [
        -2935.6201171875,
        -3393.852783203125,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.987689197063446,
        0.15642857551574707,
        -6.9202828854031395e-06
      ],
      "plane_d": 3431.929931640625,
      "bbox_min": [
        -2956.8212890625,
        -3406.867431640625,
        1069.902587890625
      ],
      "bbox_max": [
        -2935.6201171875,
        -3393.852783203125,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9876883029937744,
        -0.15643449127674103,
        -2.0004463294753805e-06
      ],
      "plane_d": -3451.937744140625,
      "bbox_min": [
        -2956.8212890625,
        -3406.867431640625,
        1070.666748046875
      ],
      "bbox_max": [
        -2955.3740234375,
        -3397.729736328125,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23947833478450775,
        -0.8831087350845337,
        0.4034464955329895
      ],
      "plane_d": -2932.8583984375,
      "bbox_min": [
        -2130.3798828125,
        -3430.0,
        1052.5999755859375
      ],
      "bbox_max": [
        -1906.3402099609375,
        -3248.03076171875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3485427498817444,
        -0.8757609128952026,
        0.3340070843696594
      ],
      "plane_d": -2608.564453125,
      "bbox_min": [
        -2074.00537109375,
        -3402.604736328125,
        1052.5999755859375
      ],
      "bbox_max": [
        -1906.3402099609375,
        -3248.03076171875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24250808358192444,
        -0.909406840801239,
        0.3378889858722687
      ],
      "plane_d": -2927.0478515625,
      "bbox_min": [
        -1925.2470703125,
        -3335.94384765625,
        1052.5999755859375
      ],
      "bbox_max": [
        -1906.3402099609375,
        -3248.03076171875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8625987768173218,
        -0.5058885812759399,
        0.0
      ],
      "plane_d": -3550.96826171875,
      "bbox_min": [
        -2121.00537109375,
        -3430.0,
        1052.5999755859375
      ],
      "bbox_max": [
        -2095.0,
        -3398.669677734375,
        1086.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8618017435073853,
        0.5072331428527832,
        0.003500441089272499
      ],
      "plane_d": 3538.946533203125,
      "bbox_min": [
        -2121.00537109375,
        -3430.0,
        1052.5999755859375
      ],
      "bbox_max": [
        -2095.0,
        -3398.669677734375,
        1086.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8840292096138,
        -0.46677976846694946,
        -0.02467990666627884
      ],
      "plane_d": -3436.5439453125,
      "bbox_min": [
        -2121.00537109375,
        -3430.0,
        1052.5999755859375
      ],
      "bbox_max": [
        -2095.0,
        -3398.669677734375,
        1086.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4472135901451111,
        -0.8944271802902222,
        0.0
      ],
      "plane_d": -2126.50048828125,
      "bbox_min": [
        -2121.00537109375,
        -3430.0,
        1052.5999755859375
      ],
      "bbox_max": [
        -2095.0,
        -3398.669677734375,
        1086.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8849280476570129,
        0.4657277762889862,
        -0.0
      ],
      "plane_d": 3449.0419921875,
      "bbox_min": [
        -2121.00537109375,
        -3430.0,
        1052.5999755859375
      ],
      "bbox_max": [
        -2095.0,
        -3398.669677734375,
        1086.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1085.9998779296875,
      "bbox_min": [
        -2121.00537109375,
        -3430.0,
        1086.0
      ],
      "bbox_max": [
        -2095.0,
        -3398.669677734375,
        1086.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7578271627426147,
        0.6524553894996643
      ],
      "plane_d": 2916.337158203125,
      "bbox_min": [
        -4035.11669921875,
        -5265.7685546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -1964.794921875,
        -3869.7685546875,
        1534.9000244140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.7578271627426147,
        0.6524554491043091
      ],
      "plane_d": 2989.088623046875,
      "bbox_min": [
        -3377.63818359375,
        -5265.7685546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -2824.65869140625,
        -4969.7685546875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4606236219406128,
        0.5994809865951538,
        0.6545597910881042
      ],
      "plane_d": 3650.314208984375,
      "bbox_min": [
        -3377.63818359375,
        -5265.7685546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -2824.65869140625,
        -4969.7685546875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46659424901008606,
        0.5960854887962341,
        0.6534307599067688
      ],
      "plane_d": 760.7036743164062,
      "bbox_min": [
        -3377.63818359375,
        -5265.7685546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -2824.65869140625,
        -4969.7685546875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.46899479627609253,
        0.5899190306663513,
        0.6572970747947693
      ],
      "plane_d": 3624.95458984375,
      "bbox_min": [
        -3377.63818359375,
        -5169.7685546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -2824.65869140625,
        -4969.7685546875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.47042611241340637,
        0.5917193293571472,
        0.6546507477760315
      ],
      "plane_d": 725.4353637695312,
      "bbox_min": [
        -3377.63818359375,
        -5169.7685546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -2824.65869140625,
        -4969.7685546875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5505159497261047,
        0.5208008289337158,
        0.6524559259414673
      ],
      "plane_d": 3550.40869140625,
      "bbox_min": [
        -3377.63818359375,
        -5169.7685546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -2824.65869140625,
        -4969.7685546875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5524737238883972,
        0.5226529240608215,
        0.6493124961853027
      ],
      "plane_d": 144.815185546875,
      "bbox_min": [
        -2945.2109375,
        -5169.7685546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -2824.65869140625,
        -4969.7685546875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.735482931137085,
        0.0,
        0.6775433421134949
      ],
      "plane_d": 1875.4927978515625,
      "bbox_min": [
        -4035.11669921875,
        -5169.7685546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -1964.794921875,
        -3869.7685546875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.75782710313797,
        -0.0,
        0.6524554491043091
      ],
      "plane_d": 2056.467041015625,
      "bbox_min": [
        -4035.11669921875,
        -4839.2734375,
        1302.5999755859375
      ],
      "bbox_max": [
        -3749.99951171875,
        -4183.41845703125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7293676733970642,
        0.20572879910469055,
        0.6524556875228882
      ],
      "plane_d": 2884.762939453125,
      "bbox_min": [
        -4035.11669921875,
        -4839.2734375,
        1302.5999755859375
      ],
      "bbox_max": [
        -3749.99951171875,
        -4183.41845703125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5877209901809692,
        -0.4636683166027069,
        0.6630200743675232
      ],
      "plane_d": -627.662353515625,
      "bbox_min": [
        -4035.11669921875,
        -4839.2734375,
        1302.5999755859375
      ],
      "bbox_max": [
        -3749.99951171875,
        -4183.41845703125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7203983068466187,
        0.23521989583969116,
        0.6524553298950195
      ],
      "plane_d": 2989.8984375,
      "bbox_min": [
        -4035.11669921875,
        -4839.2734375,
        1302.5999755859375
      ],
      "bbox_max": [
        -3749.99951171875,
        -4183.41845703125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6123817563056946,
        -0.43806323409080505,
        0.6580951809883118
      ],
      "plane_d": -415.2310791015625,
      "bbox_min": [
        -4035.11669921875,
        -4352.2294921875,
        1302.5999755859375
      ],
      "bbox_max": [
        -3835.11669921875,
        -4183.41845703125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.75782710313797,
        0.6524553894996643
      ],
      "plane_d": 2848.13232421875,
      "bbox_min": [
        -3963.99951171875,
        -5169.7685546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -1964.794921875,
        -4828.22119140625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6807189583778381,
        2.035342185990885e-05,
        0.7325447797775269
      ],
      "plane_d": -2461.754150390625,
      "bbox_min": [
        -3597.21337890625,
        -5169.7685546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -1964.797119140625,
        -4879.7685546875,
        1534.9000244140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3389105796813965,
        0.677821159362793,
        0.6524554491043091
      ],
      "plane_d": 3660.854248046875,
      "bbox_min": [
        -3597.21337890625,
        -5169.7685546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -2954.386962890625,
        -4879.7685546875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4297522008419037,
        0.0,
        -0.902946949005127
      ],
      "plane_d": 2545.216064453125,
      "bbox_min": [
        -3185.643798828125,
        -4907.5830078125,
        1302.5999755859375
      ],
      "bbox_max": [
        -2954.386962890625,
        -4879.7685546875,
        1332.7203369140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8958584666252136,
        -0.0,
        0.44433948397636414
      ],
      "plane_d": 2067.916015625,
      "bbox_min": [
        -2962.83203125,
        -4907.5830078125,
        1302.5999755859375
      ],
      "bbox_max": [
        -2954.386962890625,
        -4879.7685546875,
        1319.626708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7203983068466187,
        0.23521989583969116,
        0.6524553298950195
      ],
      "plane_d": 2989.8984375,
      "bbox_min": [
        -3963.99951171875,
        -5079.7685546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -1964.794921875,
        -4828.22119140625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6807189583778381,
        2.035342185990885e-05,
        0.7325447797775269
      ],
      "plane_d": -2461.754150390625,
      "bbox_min": [
        -3244.551513671875,
        -5079.7685546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -1964.794921875,
        -4859.45361328125,
        1534.9000244140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.004279956221580505,
        0.9998396635055542,
        0.01739072985947132
      ],
      "plane_d": 4824.359375,
      "bbox_min": [
        -3244.551513671875,
        -4905.70068359375,
        1302.5999755859375
      ],
      "bbox_max": [
        -2954.386962890625,
        -4859.45361328125,
        1372.10791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3573431670665741,
        -0.0,
        0.9339731931686401
      ],
      "plane_d": -173.7481689453125,
      "bbox_min": [
        -3185.643798828125,
        -4905.70068359375,
        1302.5999755859375
      ],
      "bbox_max": [
        -2954.386962890625,
        -4860.4365234375,
        1372.10791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4297522008419037,
        0.0,
        -0.902946949005127
      ],
      "plane_d": 2545.216064453125,
      "bbox_min": [
        -3185.643798828125,
        -4905.60693359375,
        1302.5999755859375
      ],
      "bbox_max": [
        -2954.386962890625,
        -4860.4365234375,
        1343.361572265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8958584666252136,
        -0.0,
        0.44433948397636414
      ],
      "plane_d": 2067.916015625,
      "bbox_min": [
        -2962.83203125,
        -4894.427734375,
        1302.5999755859375
      ],
      "bbox_max": [
        -2954.386962890625,
        -4860.4365234375,
        1319.626708984375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.004279972054064274,
        0.9998396635055542,
        0.01739072985947132
      ],
      "plane_d": 4850.89501953125,
      "bbox_min": [
        -3244.551513671875,
        -4862.2685546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -2954.386962890625,
        -4859.45361328125,
        1372.10791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4297522008419037,
        0.0,
        -0.902946949005127
      ],
      "plane_d": 2545.216064453125,
      "bbox_min": [
        -3185.643798828125,
        -4861.7685546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -3100.0,
        -4860.693359375,
        1343.361572265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.003976674750447273,
        0.9978757500648499,
        0.06502451002597809
      ],
      "plane_d": 4776.4169921875,
      "bbox_min": [
        -3244.551513671875,
        -4861.7685546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -2954.386962890625,
        -4859.45361328125,
        1343.361572265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.003976684529334307,
        0.9978758096694946,
        0.06502450257539749
      ],
      "plane_d": 4751.76220703125,
      "bbox_min": [
        -3244.551513671875,
        -4861.7685546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -2954.386962890625,
        -4859.45361328125,
        1343.361572265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4297522008419037,
        0.0,
        -0.902946949005127
      ],
      "plane_d": 2545.216064453125,
      "bbox_min": [
        -3244.551513671875,
        -4861.7685546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -2954.386962890625,
        -4859.45361328125,
        1343.361572265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01227299403399229,
        0.9982650876045227,
        0.05758681520819664
      ],
      "plane_d": 4736.61279296875,
      "bbox_min": [
        -3244.551513671875,
        -4860.7685546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -3221.847900390625,
        -4859.59814453125,
        1319.626708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.006341905798763037,
        0.997999370098114,
        0.06290493160486221
      ],
      "plane_d": 4786.82275390625,
      "bbox_min": [
        -2978.151611328125,
        -4860.7685546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -2954.386962890625,
        -4859.59814453125,
        1319.626708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8958584070205688,
        0.0,
        0.44433945417404175
      ],
      "plane_d": 2067.916015625,
      "bbox_min": [
        -2962.83203125,
        -4860.7685546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -2954.386962890625,
        -4859.7490234375,
        1319.626708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6807189583778381,
        2.035342185990885e-05,
        0.7325447797775269
      ],
      "plane_d": -2461.754150390625,
      "bbox_min": [
        -2214.780029296875,
        -5006.90185546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -1669.3681640625,
        -3571.833740234375,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8925751447677612,
        -0.3231738805770874,
        0.31443309783935547
      ],
      "plane_d": -3277.05615234375,
      "bbox_min": [
        -2214.763427734375,
        -4508.3818359375,
        1302.5999755859375
      ],
      "bbox_max": [
        -1669.3681640625,
        -3571.833740234375,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6368418335914612,
        0.7004961371421814,
        0.3220832943916321
      ],
      "plane_d": 919.1990966796875,
      "bbox_min": [
        -1896.3922119140625,
        -3663.7890625,
        1302.5999755859375
      ],
      "bbox_max": [
        -1790.1177978515625,
        -3571.833740234375,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7682187557220459,
        0.10676255077123642,
        0.6312224864959717
      ],
      "plane_d": -1865.6572265625,
      "bbox_min": [
        -2214.763427734375,
        -4508.3818359375,
        1302.5999755859375
      ],
      "bbox_max": [
        -1669.3681640625,
        -3663.7890625,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.675262987613678,
        0.7349726557731628,
        0.06192777678370476
      ],
      "plane_d": 1778.2490234375,
      "bbox_min": [
        -1960.0,
        -4330.0,
        1302.5999755859375
      ],
      "bbox_max": [
        -1669.3681640625,
        -3816.79833984375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3447917699813843,
        0.6698105931282043,
        0.6576262712478638
      ],
      "plane_d": 1169.84033203125,
      "bbox_min": [
        -1744.305419921875,
        -4151.40185546875,
        1507.3250732421875
      ],
      "bbox_max": [
        -1669.3681640625,
        -4088.0654296875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9280664324760437,
        -0.22487972676753998,
        0.29685306549072266
      ],
      "plane_d": -2929.81591796875,
      "bbox_min": [
        -1683.0428466796875,
        -4112.8271484375,
        1507.3250732421875
      ],
      "bbox_max": [
        -1669.3681640625,
        -4088.0654296875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9724772572517395,
        0.06260393559932709,
        0.22442980110645294
      ],
      "plane_d": -1780.880615234375,
      "bbox_min": [
        -1799.9468994140625,
        -4182.94970703125,
        1302.5999755859375
      ],
      "bbox_max": [
        -1675.3681640625,
        -3816.79833984375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3447917699813843,
        0.6698105931282043,
        0.6576262712478638
      ],
      "plane_d": 1169.84033203125,
      "bbox_min": [
        -1784.5677490234375,
        -4151.40185546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -1675.3681640625,
        -3893.648193359375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9016920924186707,
        -0.31035327911376953,
        0.30105170607566833
      ],
      "plane_d": -3225.33056640625,
      "bbox_min": [
        -1784.5677490234375,
        -3944.052978515625,
        1302.5999755859375
      ],
      "bbox_max": [
        -1721.60205078125,
        -3893.648193359375,
        1522.3487548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9016920924186707,
        -0.31035327911376953,
        0.30105170607566833
      ],
      "plane_d": -3225.33056640625,
      "bbox_min": [
        -1787.0877685546875,
        -3944.052978515625,
        1302.5999755859375
      ],
      "bbox_max": [
        -1735.2222900390625,
        -3816.79833984375,
        1502.359130859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23304353654384613,
        0.7457394003868103,
        0.6241501569747925
      ],
      "plane_d": 1959.268310546875,
      "bbox_min": [
        -2214.763427734375,
        -4508.3818359375,
        1302.5999755859375
      ],
      "bbox_max": [
        -1713.584716796875,
        -3663.7890625,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3802012503147125,
        0.6782152652740479,
        0.6288648843765259
      ],
      "plane_d": 1345.3968505859375,
      "bbox_min": [
        -2214.763427734375,
        -4476.22900390625,
        1302.5999755859375
      ],
      "bbox_max": [
        -2071.58203125,
        -4380.0,
        1435.653076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17222049832344055,
        0.8089194893836975,
        0.5621291399002075
      ],
      "plane_d": 2445.73046875,
      "bbox_min": [
        -2120.0,
        -4508.3818359375,
        1302.5999755859375
      ],
      "bbox_max": [
        -1713.584716796875,
        -3663.7890625,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3802012503147125,
        0.6782152652740479,
        0.6288648843765259
      ],
      "plane_d": 1345.3968505859375,
      "bbox_min": [
        -2120.0,
        -4508.3818359375,
        1302.5999755859375
      ],
      "bbox_max": [
        -1964.780029296875,
        -4380.0,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9016920924186707,
        -0.31035327911376953,
        0.30105170607566833
      ],
      "plane_d": -3225.33056640625,
      "bbox_min": [
        -1790.1177978515625,
        -3930.347900390625,
        1426.2386474609375
      ],
      "bbox_max": [
        -1713.584716796875,
        -3663.7890625,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9280664324760437,
        -0.22487972676753998,
        0.29685306549072266
      ],
      "plane_d": -2929.81591796875,
      "bbox_min": [
        -1721.60205078125,
        -3930.347900390625,
        1522.3487548828125
      ],
      "bbox_max": [
        -1713.584716796875,
        -3912.10302734375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6806984543800354,
        -2.937276804004796e-07,
        0.7325637340545654
      ],
      "plane_d": -2461.836181640625,
      "bbox_min": [
        -2214.780029296875,
        -4888.11669921875,
        1302.5999755859375
      ],
      "bbox_max": [
        -1964.780029296875,
        -4433.12353515625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3802012503147125,
        0.6782152652740479,
        0.6288648843765259
      ],
      "plane_d": 1345.3968505859375,
      "bbox_min": [
        -2214.780029296875,
        -4508.3818359375,
        1302.5999755859375
      ],
      "bbox_max": [
        -1964.780029296875,
        -4433.12353515625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17169524729251862,
        -0.6159459352493286,
        0.7688506841659546
      ],
      "plane_d": -3457.595703125,
      "bbox_min": [
        -3634.55712890625,
        -4069.7685546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -1925.1641845703125,
        -2979.77587890625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23221024870872498,
        -0.8293224573135376,
        0.5082348585128784
      ],
      "plane_d": -2908.64794921875,
      "bbox_min": [
        -2278.3076171875,
        -3352.430908203125,
        1302.5999755859375
      ],
      "bbox_max": [
        -1925.1641845703125,
        -3114.94677734375,
        1534.9000244140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.22970595955848694,
        -0.8470718264579773,
        0.4792749881744385
      ],
      "plane_d": -2933.39697265625,
      "bbox_min": [
        -2166.9013671875,
        -3315.716064453125,
        1302.5999755859375
      ],
      "bbox_max": [
        -1925.2470703125,
        -3248.052978515625,
        1341.522705078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2753306031227112,
        -0.8354538679122925,
        0.4756152629852295
      ],
      "plane_d": -2793.050048828125,
      "bbox_min": [
        -2166.9013671875,
        -3315.716064453125,
        1302.5999755859375
      ],
      "bbox_max": [
        -2130.3798828125,
        -3282.2880859375,
        1341.522705078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26883310079574585,
        -0.8187206983566284,
        0.5073708295822144
      ],
      "plane_d": -2802.57958984375,
      "bbox_min": [
        -2278.3076171875,
        -3352.430908203125,
        1302.5999755859375
      ],
      "bbox_max": [
        -1925.2470703125,
        -3114.94677734375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22970595955848694,
        -0.8470718264579773,
        0.4792749881744385
      ],
      "plane_d": -2933.39697265625,
      "bbox_min": [
        -2278.3076171875,
        -3352.430908203125,
        1302.5999755859375
      ],
      "bbox_max": [
        -1925.2470703125,
        -3195.6806640625,
        1471.4671630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2753306031227112,
        -0.8354538679122925,
        0.4756152629852295
      ],
      "plane_d": -2793.050048828125,
      "bbox_min": [
        -2278.3076171875,
        -3352.430908203125,
        1302.5999755859375
      ],
      "bbox_max": [
        -2132.705078125,
        -3234.538818359375,
        1428.4024658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4783487617969513,
        -0.20142510533332825,
        0.85475754737854
      ],
      "plane_d": -2977.39794921875,
      "bbox_min": [
        -3634.55712890625,
        -4069.7685546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -2018.7822265625,
        -2979.77587890625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26112592220306396,
        -0.6418163180351257,
        0.721030592918396
      ],
      "plane_d": -3705.04443359375,
      "bbox_min": [
        -2512.55908203125,
        -3365.8603515625,
        1302.5999755859375
      ],
      "bbox_max": [
        -2018.7822265625,
        -3134.806884765625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2753306031227112,
        -0.8354538679122925,
        0.4756152629852295
      ],
      "plane_d": -2793.050048828125,
      "bbox_min": [
        -2319.057373046875,
        -3365.8603515625,
        1302.5999755859375
      ],
      "bbox_max": [
        -2018.7822265625,
        -3134.806884765625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26883310079574585,
        -0.8187206983566284,
        0.5073708295822144
      ],
      "plane_d": -2802.57958984375,
      "bbox_min": [
        -2144.25732421875,
        -3234.538818359375,
        1428.4024658203125
      ],
      "bbox_max": [
        -2018.7822265625,
        -3134.806884765625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22970595955848694,
        -0.8470718264579773,
        0.4792749881744385
      ],
      "plane_d": -2933.39697265625,
      "bbox_min": [
        -2144.25732421875,
        -3234.538818359375,
        1428.4024658203125
      ],
      "bbox_max": [
        -2084.453369140625,
        -3176.007568359375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5327659845352173,
        -0.5439295768737793,
        0.6483063697814941
      ],
      "plane_d": -1163.5986328125,
      "bbox_min": [
        -3634.55712890625,
        -4069.7685546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -2512.55908203125,
        -2979.77587890625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14996828138828278,
        -0.7595442533493042,
        0.6329313516616821
      ],
      "plane_d": -2905.852783203125,
      "bbox_min": [
        -3239.798583984375,
        -3604.59033203125,
        1302.5999755859375
      ],
      "bbox_max": [
        -2753.905029296875,
        -3111.114501953125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3154846429824829,
        -0.6847353577613831,
        0.6569679379463196
      ],
      "plane_d": -2236.382080078125,
      "bbox_min": [
        -2861.24462890625,
        -3141.194580078125,
        1494.9527587890625
      ],
      "bbox_max": [
        -2842.10595703125,
        -3111.114501953125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45930567383766174,
        -0.7651201486587524,
        0.45125314593315125
      ],
      "plane_d": -1759.25537109375,
      "bbox_min": [
        -3239.798583984375,
        -3604.59033203125,
        1302.5999755859375
      ],
      "bbox_max": [
        -2861.24462890625,
        -3111.68505859375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5322588086128235,
        -0.7790220975875854,
        0.3313983976840973
      ],
      "plane_d": -1399.44775390625,
      "bbox_min": [
        -3174.781494140625,
        -3384.146240234375,
        1302.5999755859375
      ],
      "bbox_max": [
        -3001.666748046875,
        -3207.9873046875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8624072670936584,
        -0.13326707482337952,
        0.48835813999176025
      ],
      "plane_d": 1580.2606201171875,
      "bbox_min": [
        -3174.781494140625,
        -3384.146240234375,
        1302.5999755859375
      ],
      "bbox_max": [
        -3086.888427734375,
        -3345.46533203125,
        1457.6466064453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7868428826332092,
        0.027674341574311256,
        0.616532564163208
      ],
      "plane_d": 1719.455078125,
      "bbox_min": [
        -3106.85986328125,
        -3384.146240234375,
        1302.5999755859375
      ],
      "bbox_max": [
        -3086.888427734375,
        -3352.1396484375,
        1327.9552001953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7868428826332092,
        0.027674341574311256,
        0.616532564163208
      ],
      "plane_d": 1719.455078125,
      "bbox_min": [
        -3239.798583984375,
        -3604.59033203125,
        1302.5999755859375
      ],
      "bbox_max": [
        -3021.666748046875,
        -3207.9873046875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7917473912239075,
        -0.03682546317577362,
        0.6097375154495239
      ],
      "plane_d": 1512.502685546875,
      "bbox_min": [
        -3110.700927734375,
        -3604.59033203125,
        1302.5999755859375
      ],
      "bbox_max": [
        -3080.0,
        -3580.0,
        1342.072998046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5322588086128235,
        -0.7790220975875854,
        0.3313983976840973
      ],
      "plane_d": -1399.44775390625,
      "bbox_min": [
        -3239.798583984375,
        -3536.609375,
        1327.955322265625
      ],
      "bbox_max": [
        -3021.666748046875,
        -3207.9873046875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8624072670936584,
        -0.13326707482337952,
        0.48835813999176025
      ],
      "plane_d": 1580.2606201171875,
      "bbox_min": [
        -3239.798583984375,
        -3536.609375,
        1327.955322265625
      ],
      "bbox_max": [
        -3106.85986328125,
        -3342.1396484375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5355481505393982,
        -0.5337325930595398,
        0.6544598937034607
      ],
      "plane_d": -1123.4718017578125,
      "bbox_min": [
        -3634.55712890625,
        -4069.7685546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -2512.55908203125,
        -2979.77587890625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.009789052419364452,
        -0.60419100522995,
        0.7967793345451355
      ],
      "plane_d": -3048.53662109375,
      "bbox_min": [
        -3379.318603515625,
        -3820.448974609375,
        1302.5999755859375
      ],
      "bbox_max": [
        -2512.55908203125,
        -2979.77587890625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3154846429824829,
        -0.6847353577613831,
        0.6569679379463196
      ],
      "plane_d": -2236.382080078125,
      "bbox_min": [
        -3379.318603515625,
        -3820.448974609375,
        1302.5999755859375
      ],
      "bbox_max": [
        -2574.94580078125,
        -2979.77587890625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14996828138828278,
        -0.7595442533493042,
        0.6329313516616821
      ],
      "plane_d": -2905.852783203125,
      "bbox_min": [
        -2842.10595703125,
        -3284.06787109375,
        1302.5999755859375
      ],
      "bbox_max": [
        -2749.9501953125,
        -3141.1943359375,
        1494.9527587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09131287038326263,
        -0.7589693069458008,
        0.6446918249130249
      ],
      "plane_d": -3437.9072265625,
      "bbox_min": [
        -3379.318603515625,
        -3820.448974609375,
        1302.5999755859375
      ],
      "bbox_max": [
        -3081.143798828125,
        -3483.112060546875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7917473912239075,
        -0.03682546317577362,
        0.6097375154495239
      ],
      "plane_d": 1512.502685546875,
      "bbox_min": [
        -3379.318603515625,
        -3820.448974609375,
        1302.5999755859375
      ],
      "bbox_max": [
        -3081.143798828125,
        -3483.112060546875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.009909606538712978,
        -0.755048930644989,
        0.6555936336517334
      ],
      "plane_d": -3705.885498046875,
      "bbox_min": [
        -3379.318603515625,
        -3820.448974609375,
        1302.5999755859375
      ],
      "bbox_max": [
        -3110.700927734375,
        -3521.56689453125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7868428826332092,
        0.027674341574311256,
        0.616532564163208
      ],
      "plane_d": 1719.455078125,
      "bbox_min": [
        -3260.67529296875,
        -3618.21142578125,
        1342.072998046875
      ],
      "bbox_max": [
        -3110.700927734375,
        -3521.56689453125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8624072670936584,
        -0.13326707482337952,
        0.48835813999176025
      ],
      "plane_d": 1580.2606201171875,
      "bbox_min": [
        -3260.67529296875,
        -3618.21142578125,
        1463.6553955078125
      ],
      "bbox_max": [
        -3207.721435546875,
        -3521.56689453125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8624072670936584,
        -0.13326707482337952,
        0.48835813999176025
      ],
      "plane_d": 1580.2606201171875,
      "bbox_min": [
        -3260.67529296875,
        -3618.21142578125,
        1483.6881103515625
      ],
      "bbox_max": [
        -3216.740966796875,
        -3483.112060546875,
        1534.9000244140625
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CBreakableObject piece: ",
      "entity_class": "CBreakableObject",
      "piece_name": "",
      "offset": 3257,
      "centroid": [
        -3066.9437255859375,
        -3870.349853515625,
        1060.5999755859375
      ],
      "bbox_min": [
        -3070.238037109375,
        -3870.580078125,
        1054.5999755859375
      ],
      "bbox_max": [
        -3063.6494140625,
        -3870.11962890625,
        1066.5999755859375
      ],
      "dimensions_source": {
        "span_x": 6.588623046875,
        "span_y": 0.46044921875,
        "height_z": 12.0,
        "door_width": 6.588623046875,
        "door_depth": 0.46044921875,
        "leaf_depth": 0.46044921875,
        "clearance_margin": 0.0,
        "slide_axis": "x",
        "slide_vector": [
          -0.0697,
          -0.9976,
          -0.0
        ]
      },
      "vertices": [
        [
          -3070.238037109375,
          -3870.11962890625,
          1054.5999755859375
        ],
        [
          -3070.238037109375,
          -3870.11962890625,
          1054.5999755859375
        ],
        [
          -3070.238037109375,
          -3870.11962890625,
          1066.5999755859375
        ],
        [
          -3070.238037109375,
          -3870.11962890625,
          1066.5999755859375
        ],
        [
          -3063.6494140625,
          -3870.580078125,
          1066.5999755859375
        ],
        [
          -3063.6494140625,
          -3870.580078125,
          1066.5999755859375
        ],
        [
          -3063.6494140625,
          -3870.580078125,
          1054.5999755859375
        ],
        [
          -3063.6494140625,
          -3870.580078125,
          1054.5999755859375
        ]
      ],
      "plane_distance": -4074.7463
    },
    {
      "tag": "CBreakableObject piece: ",
      "entity_class": "CBreakableObject",
      "piece_name": "",
      "offset": 4248,
      "centroid": [
        -2161.75,
        -4385.751220703125,
        1060.5999755859375
      ],
      "bbox_min": [
        -2163.5,
        -4388.5517578125,
        1054.5999755859375
      ],
      "bbox_max": [
        -2160.0,
        -4382.95068359375,
        1066.5999755859375
      ],
      "dimensions_source": {
        "span_x": 3.5,
        "span_y": 5.60107421875,
        "height_z": 12.0,
        "door_width": 5.60107421875,
        "door_depth": 3.5,
        "leaf_depth": 3.5,
        "clearance_margin": 0.0,
        "slide_axis": "z",
        "slide_vector": [
          -0.848,
          -0.5299,
          -0.0
        ]
      },
      "vertices": [
        [
          -2163.5,
          -4382.95068359375,
          1054.5999755859375
        ],
        [
          -2163.5,
          -4382.95068359375,
          1054.5999755859375
        ],
        [
          -2163.5,
          -4382.95068359375,
          1066.5999755859375
        ],
        [
          -2163.5,
          -4382.95068359375,
          1066.5999755859375
        ],
        [
          -2160.0,
          -4388.5517578125,
          1066.5999755859375
        ],
        [
          -2160.0,
          -4388.5517578125,
          1066.5999755859375
        ],
        [
          -2160.0,
          -4388.5517578125,
          1054.5999755859375
        ],
        [
          -2160.0,
          -4388.5517578125,
          1054.5999755859375
        ]
      ],
      "plane_distance": -4157.3823
    },
    {
      "tag": "CSlidingDoor piece: gate",
      "entity_class": "CSlidingDoor",
      "piece_name": "gate",
      "offset": 5273,
      "centroid": [
        -2092.5,
        -3447.5,
        1057.2870635986328
      ],
      "bbox_min": [
        -2105.0,
        -3470.0,
        1027.6832275390625
      ],
      "bbox_max": [
        -2080.0,
        -3425.0,
        1086.0
      ],
      "dimensions_source": {
        "span_x": 25.0,
        "span_y": 45.0,
        "height_z": 58.3167724609375,
        "door_width": 45.0,
        "door_depth": 25.0,
        "leaf_depth": 24.96,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          0.9363,
          0.3511,
          0.0
        ]
      },
      "vertices": [
        [
          -2105.0,
          -3430.0,
          1086.0
        ],
        [
          -2095.0,
          -3425.0,
          1086.0
        ],
        [
          -2080.0,
          -3465.0,
          1086.0
        ],
        [
          -2090.0,
          -3470.0,
          1086.0
        ],
        [
          -2080.0,
          -3465.0,
          1028.187255859375
        ],
        [
          -2095.0,
          -3425.0,
          1027.6832275390625
        ],
        [
          -2090.0,
          -3470.0,
          1029.570556640625
        ],
        [
          -2105.0,
          -3430.0,
          1028.85546875
        ]
      ],
      "plane_distance": 3164.2075,
      "authentic_texture": "basegatedoor"
    },
    {
      "tag": "CSlidingDoor piece: recsta",
      "entity_class": "CSlidingDoor",
      "piece_name": "recsta",
      "offset": 6394,
      "centroid": [
        -2524.4053955078125,
        -3963.2918701171875,
        1056.8250122070312
      ],
      "bbox_min": [
        -2525.805419921875,
        -3964.169189453125,
        1055.4000244140625
      ],
      "bbox_max": [
        -2523.00537109375,
        -3962.41455078125,
        1058.25
      ],
      "dimensions_source": {
        "span_x": 2.800048828125,
        "span_y": 1.754638671875,
        "height_z": 2.8499755859375,
        "door_width": 2.800048828125,
        "door_depth": 1.754638671875,
        "leaf_depth": 1.714638671875,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          -0.531,
          -0.8474,
          -0.0
        ]
      },
      "vertices": [
        [
          -2525.805419921875,
          -3962.41455078125,
          1055.4000244140625
        ],
        [
          -2525.805419921875,
          -3962.41455078125,
          1058.25
        ],
        [
          -2523.00537109375,
          -3964.169189453125,
          1058.25
        ],
        [
          -2523.00537109375,
          -3964.169189453125,
          1055.4000244140625
        ]
      ],
      "plane_distance": -4698.8413
    }
  ],
  "tutorial_messages": []
}